// Copyright 2023 The MediaPipe Authors.
var $b34bd66f0aa7fdf3$var$t = "undefined" != typeof self ? self : {};
function $b34bd66f0aa7fdf3$var$e(e) {
    t: {
        for(var n = [
            "CLOSURE_FLAGS"
        ], r = $b34bd66f0aa7fdf3$var$t, i = 0; i < n.length; i++)if (null == (r = r[n[i]])) {
            n = null;
            break t;
        }
        n = r;
    }
    return null != (e = n && n[e]) && e;
}
function $b34bd66f0aa7fdf3$var$n() {
    throw Error("Invalid UTF8");
}
function $b34bd66f0aa7fdf3$var$r(t, e) {
    return e = String.fromCharCode.apply(null, e), null == t ? e : t + e;
}
let $b34bd66f0aa7fdf3$var$i, $b34bd66f0aa7fdf3$var$s;
const $b34bd66f0aa7fdf3$var$o = "undefined" != typeof TextDecoder;
let $b34bd66f0aa7fdf3$var$a;
const $b34bd66f0aa7fdf3$var$h = "undefined" != typeof TextEncoder;
function $b34bd66f0aa7fdf3$var$c(t) {
    if ($b34bd66f0aa7fdf3$var$h) t = ($b34bd66f0aa7fdf3$var$a ||= new TextEncoder).encode(t);
    else {
        let n = 0;
        const r = new Uint8Array(3 * t.length);
        for(let i = 0; i < t.length; i++){
            var e = t.charCodeAt(i);
            if (128 > e) r[n++] = e;
            else {
                if (2048 > e) r[n++] = e >> 6 | 192;
                else {
                    if (55296 <= e && 57343 >= e) {
                        if (56319 >= e && i < t.length) {
                            const s = t.charCodeAt(++i);
                            if (56320 <= s && 57343 >= s) {
                                e = 1024 * (e - 55296) + s - 56320 + 65536, r[n++] = e >> 18 | 240, r[n++] = e >> 12 & 63 | 128, r[n++] = e >> 6 & 63 | 128, r[n++] = 63 & e | 128;
                                continue;
                            }
                            i--;
                        }
                        e = 65533;
                    }
                    r[n++] = e >> 12 | 224, r[n++] = e >> 6 & 63 | 128;
                }
                r[n++] = 63 & e | 128;
            }
        }
        t = n === r.length ? r : r.subarray(0, n);
    }
    return t;
}
var $b34bd66f0aa7fdf3$var$u, $b34bd66f0aa7fdf3$var$l = $b34bd66f0aa7fdf3$var$e(610401301), $b34bd66f0aa7fdf3$var$d = $b34bd66f0aa7fdf3$var$e(188588736);
const $b34bd66f0aa7fdf3$var$f = $b34bd66f0aa7fdf3$var$t.navigator;
function $b34bd66f0aa7fdf3$var$p(t) {
    return !!$b34bd66f0aa7fdf3$var$l && !!$b34bd66f0aa7fdf3$var$u && $b34bd66f0aa7fdf3$var$u.brands.some(({ brand: e })=>e && -1 != e.indexOf(t));
}
function $b34bd66f0aa7fdf3$var$g(e) {
    var n;
    return (n = $b34bd66f0aa7fdf3$var$t.navigator) && (n = n.userAgent) || (n = ""), -1 != n.indexOf(e);
}
function $b34bd66f0aa7fdf3$var$m() {
    return !!$b34bd66f0aa7fdf3$var$l && !!$b34bd66f0aa7fdf3$var$u && 0 < $b34bd66f0aa7fdf3$var$u.brands.length;
}
function $b34bd66f0aa7fdf3$var$y() {
    return $b34bd66f0aa7fdf3$var$m() ? $b34bd66f0aa7fdf3$var$p("Chromium") : ($b34bd66f0aa7fdf3$var$g("Chrome") || $b34bd66f0aa7fdf3$var$g("CriOS")) && !(!$b34bd66f0aa7fdf3$var$m() && $b34bd66f0aa7fdf3$var$g("Edge")) || $b34bd66f0aa7fdf3$var$g("Silk");
}
function $b34bd66f0aa7fdf3$var$_(t) {
    return $b34bd66f0aa7fdf3$var$_[" "](t), t;
}
$b34bd66f0aa7fdf3$var$u = $b34bd66f0aa7fdf3$var$f && $b34bd66f0aa7fdf3$var$f.userAgentData || null, $b34bd66f0aa7fdf3$var$_[" "] = function() {};
var $b34bd66f0aa7fdf3$var$v = !$b34bd66f0aa7fdf3$var$m() && ($b34bd66f0aa7fdf3$var$g("Trident") || $b34bd66f0aa7fdf3$var$g("MSIE"));
!$b34bd66f0aa7fdf3$var$g("Android") || $b34bd66f0aa7fdf3$var$y(), $b34bd66f0aa7fdf3$var$y(), $b34bd66f0aa7fdf3$var$g("Safari") && ($b34bd66f0aa7fdf3$var$y() || !$b34bd66f0aa7fdf3$var$m() && $b34bd66f0aa7fdf3$var$g("Coast") || !$b34bd66f0aa7fdf3$var$m() && $b34bd66f0aa7fdf3$var$g("Opera") || !$b34bd66f0aa7fdf3$var$m() && $b34bd66f0aa7fdf3$var$g("Edge") || ($b34bd66f0aa7fdf3$var$m() ? $b34bd66f0aa7fdf3$var$p("Microsoft Edge") : $b34bd66f0aa7fdf3$var$g("Edg/")) || $b34bd66f0aa7fdf3$var$m() && $b34bd66f0aa7fdf3$var$p("Opera"));
var $b34bd66f0aa7fdf3$var$E = {}, $b34bd66f0aa7fdf3$var$w = null;
function $b34bd66f0aa7fdf3$var$T(t) {
    var e = t.length, n = 3 * e / 4;
    n % 3 ? n = Math.floor(n) : -1 != "=.".indexOf(t[e - 1]) && (n = -1 != "=.".indexOf(t[e - 2]) ? n - 2 : n - 1);
    var r = new Uint8Array(n), i = 0;
    return function(t, e) {
        function n(e) {
            for(; r < t.length;){
                var n = t.charAt(r++), i = $b34bd66f0aa7fdf3$var$w[n];
                if (null != i) return i;
                if (!/^[\s\xa0]*$/.test(n)) throw Error("Unknown base64 encoding at char: " + n);
            }
            return e;
        }
        $b34bd66f0aa7fdf3$var$A();
        for(var r = 0;;){
            var i = n(-1), s = n(0), o = n(64), a = n(64);
            if (64 === a && -1 === i) break;
            e(i << 2 | s >> 4), 64 != o && (e(s << 4 & 240 | o >> 2), 64 != a && e(o << 6 & 192 | a));
        }
    }(t, function(t) {
        r[i++] = t;
    }), i !== n ? r.subarray(0, i) : r;
}
function $b34bd66f0aa7fdf3$var$A() {
    if (!$b34bd66f0aa7fdf3$var$w) {
        $b34bd66f0aa7fdf3$var$w = {};
        for(var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), e = [
            "+/=",
            "+/",
            "-_=",
            "-_.",
            "-_"
        ], n = 0; 5 > n; n++){
            var r = t.concat(e[n].split(""));
            $b34bd66f0aa7fdf3$var$E[n] = r;
            for(var i = 0; i < r.length; i++){
                var s = r[i];
                void 0 === $b34bd66f0aa7fdf3$var$w[s] && ($b34bd66f0aa7fdf3$var$w[s] = i);
            }
        }
    }
}
var $b34bd66f0aa7fdf3$var$b = "undefined" != typeof Uint8Array, $b34bd66f0aa7fdf3$var$k = !$b34bd66f0aa7fdf3$var$v && "function" == typeof btoa;
function $b34bd66f0aa7fdf3$var$x(t) {
    if (!$b34bd66f0aa7fdf3$var$k) {
        var e;
        void 0 === e && (e = 0), $b34bd66f0aa7fdf3$var$A(), e = $b34bd66f0aa7fdf3$var$E[e];
        var n = Array(Math.floor(t.length / 3)), r = e[64] || "";
        let h = 0, c = 0;
        for(; h < t.length - 2; h += 3){
            var i = t[h], s = t[h + 1], o = t[h + 2], a = e[i >> 2];
            i = e[(3 & i) << 4 | s >> 4], s = e[(15 & s) << 2 | o >> 6], o = e[63 & o], n[c++] = a + i + s + o;
        }
        switch(a = 0, o = r, t.length - h){
            case 2:
                o = e[(15 & (a = t[h + 1])) << 2] || r;
            case 1:
                t = t[h], n[c] = e[t >> 2] + e[(3 & t) << 4 | a >> 4] + o + r;
        }
        return n.join("");
    }
    for(e = "", n = 0, r = t.length - 10240; n < r;)e += String.fromCharCode.apply(null, t.subarray(n, n += 10240));
    return e += String.fromCharCode.apply(null, n ? t.subarray(n) : t), btoa(e);
}
const $b34bd66f0aa7fdf3$var$S = /[-_.]/g, $b34bd66f0aa7fdf3$var$L = {
    "-": "+",
    _: "/",
    ".": "="
};
function $b34bd66f0aa7fdf3$var$F(t) {
    return $b34bd66f0aa7fdf3$var$L[t] || "";
}
function $b34bd66f0aa7fdf3$var$R(t) {
    if (!$b34bd66f0aa7fdf3$var$k) return $b34bd66f0aa7fdf3$var$T(t);
    $b34bd66f0aa7fdf3$var$S.test(t) && (t = t.replace($b34bd66f0aa7fdf3$var$S, $b34bd66f0aa7fdf3$var$F)), t = atob(t);
    const e = new Uint8Array(t.length);
    for(let n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
    return e;
}
function $b34bd66f0aa7fdf3$var$M(t) {
    return $b34bd66f0aa7fdf3$var$b && null != t && t instanceof Uint8Array;
}
let $b34bd66f0aa7fdf3$var$P;
function $b34bd66f0aa7fdf3$var$C() {
    return $b34bd66f0aa7fdf3$var$P ||= new Uint8Array(0);
}
var $b34bd66f0aa7fdf3$var$O = {};
let $b34bd66f0aa7fdf3$var$I;
function $b34bd66f0aa7fdf3$var$U(t) {
    if (t !== $b34bd66f0aa7fdf3$var$O) throw Error("illegal external caller");
}
function $b34bd66f0aa7fdf3$var$D() {
    return $b34bd66f0aa7fdf3$var$I ||= new $b34bd66f0aa7fdf3$var$B(null, $b34bd66f0aa7fdf3$var$O);
}
function $b34bd66f0aa7fdf3$var$N(t) {
    $b34bd66f0aa7fdf3$var$U($b34bd66f0aa7fdf3$var$O);
    var e = t.g;
    return null == (e = null == e || $b34bd66f0aa7fdf3$var$M(e) ? e : "string" == typeof e ? $b34bd66f0aa7fdf3$var$R(e) : null) ? e : t.g = e;
}
var $b34bd66f0aa7fdf3$var$B = class {
    constructor(t, e){
        if ($b34bd66f0aa7fdf3$var$U(e), this.g = t, null != t && 0 === t.length) throw Error("ByteString should be constructed with non-empty values");
    }
    h() {
        const t = $b34bd66f0aa7fdf3$var$N(this);
        return t ? new Uint8Array(t) : $b34bd66f0aa7fdf3$var$C();
    }
};
function $b34bd66f0aa7fdf3$var$G(t, e) {
    return Error(`Invalid wire type: ${t} (at position ${e})`);
}
function $b34bd66f0aa7fdf3$var$j() {
    return Error("Failed to read varint, encoding is invalid.");
}
function $b34bd66f0aa7fdf3$var$V(t, e) {
    return Error(`Tried to read past the end of the data ${e} > ${t}`);
}
function $b34bd66f0aa7fdf3$var$X(t) {
    if ("string" == typeof t) return {
        buffer: $b34bd66f0aa7fdf3$var$R(t),
        P: !1
    };
    if (Array.isArray(t)) return {
        buffer: new Uint8Array(t),
        P: !1
    };
    if (t.constructor === Uint8Array) return {
        buffer: t,
        P: !1
    };
    if (t.constructor === ArrayBuffer) return {
        buffer: new Uint8Array(t),
        P: !1
    };
    if (t.constructor === $b34bd66f0aa7fdf3$var$B) return {
        buffer: $b34bd66f0aa7fdf3$var$N(t) || $b34bd66f0aa7fdf3$var$C(),
        P: !0
    };
    if (t instanceof Uint8Array) return {
        buffer: new Uint8Array(t.buffer, t.byteOffset, t.byteLength),
        P: !1
    };
    throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, a ByteString or an Array of numbers");
}
function $b34bd66f0aa7fdf3$var$H() {
    return "function" == typeof BigInt;
}
const $b34bd66f0aa7fdf3$var$W = "function" == typeof Uint8Array.prototype.slice;
let $b34bd66f0aa7fdf3$var$z, $b34bd66f0aa7fdf3$var$K = 0, $b34bd66f0aa7fdf3$var$Y = 0;
function $b34bd66f0aa7fdf3$var$$(t) {
    const e = 0 > t;
    let n = (t = Math.abs(t)) >>> 0;
    if (t = Math.floor((t - n) / 4294967296), e) {
        const [e, r] = $b34bd66f0aa7fdf3$var$rt(n, t);
        t = r, n = e;
    }
    $b34bd66f0aa7fdf3$var$K = n >>> 0, $b34bd66f0aa7fdf3$var$Y = t >>> 0;
}
function $b34bd66f0aa7fdf3$var$q(t) {
    const e = $b34bd66f0aa7fdf3$var$z ||= new DataView(new ArrayBuffer(8));
    e.setFloat32(0, +t, !0), $b34bd66f0aa7fdf3$var$Y = 0, $b34bd66f0aa7fdf3$var$K = e.getUint32(0, !0);
}
function $b34bd66f0aa7fdf3$var$J(t, e) {
    return 4294967296 * e + (t >>> 0);
}
function $b34bd66f0aa7fdf3$var$Z(t, e) {
    const n = 2147483648 & e;
    return n && (e = ~e >>> 0, 0 == (t = 1 + ~t >>> 0) && (e = e + 1 >>> 0)), t = $b34bd66f0aa7fdf3$var$J(t, e), n ? -t : t;
}
function $b34bd66f0aa7fdf3$var$Q(t, e) {
    if (t >>>= 0, 2097151 >= (e >>>= 0)) var n = "" + (4294967296 * e + t);
    else $b34bd66f0aa7fdf3$var$H() ? n = "" + (BigInt(e) << BigInt(32) | BigInt(t)) : (t = (16777215 & t) + 6777216 * (n = 16777215 & (t >>> 24 | e << 8)) + 6710656 * (e = e >> 16 & 65535), n += 8147497 * e, e *= 2, 1e7 <= t && (n += Math.floor(t / 1e7), t %= 1e7), 1e7 <= n && (e += Math.floor(n / 1e7), n %= 1e7), n = e + $b34bd66f0aa7fdf3$var$tt(n) + $b34bd66f0aa7fdf3$var$tt(t));
    return n;
}
function $b34bd66f0aa7fdf3$var$tt(t) {
    return t = String(t), "0000000".slice(t.length) + t;
}
function $b34bd66f0aa7fdf3$var$et() {
    var t = $b34bd66f0aa7fdf3$var$K, e = $b34bd66f0aa7fdf3$var$Y;
    if (2147483648 & e) {
        if ($b34bd66f0aa7fdf3$var$H()) t = "" + (BigInt(0 | e) << BigInt(32) | BigInt(t >>> 0));
        else {
            const [n, r] = $b34bd66f0aa7fdf3$var$rt(t, e);
            t = "-" + $b34bd66f0aa7fdf3$var$Q(n, r);
        }
    } else t = $b34bd66f0aa7fdf3$var$Q(t, e);
    return t;
}
function $b34bd66f0aa7fdf3$var$nt(t) {
    if (16 > t.length) $b34bd66f0aa7fdf3$var$$(Number(t));
    else if ($b34bd66f0aa7fdf3$var$H()) t = BigInt(t), $b34bd66f0aa7fdf3$var$K = Number(t & BigInt(4294967295)) >>> 0, $b34bd66f0aa7fdf3$var$Y = Number(t >> BigInt(32) & BigInt(4294967295));
    else {
        const e = +("-" === t[0]);
        $b34bd66f0aa7fdf3$var$Y = $b34bd66f0aa7fdf3$var$K = 0;
        const n = t.length;
        for(let r = e, i = (n - e) % 6 + e; i <= n; r = i, i += 6){
            const e = Number(t.slice(r, i));
            $b34bd66f0aa7fdf3$var$Y *= 1e6, $b34bd66f0aa7fdf3$var$K = 1e6 * $b34bd66f0aa7fdf3$var$K + e, 4294967296 <= $b34bd66f0aa7fdf3$var$K && ($b34bd66f0aa7fdf3$var$Y += Math.trunc($b34bd66f0aa7fdf3$var$K / 4294967296), $b34bd66f0aa7fdf3$var$Y >>>= 0, $b34bd66f0aa7fdf3$var$K >>>= 0);
        }
        if (e) {
            const [t, e] = $b34bd66f0aa7fdf3$var$rt($b34bd66f0aa7fdf3$var$K, $b34bd66f0aa7fdf3$var$Y);
            $b34bd66f0aa7fdf3$var$K = t, $b34bd66f0aa7fdf3$var$Y = e;
        }
    }
}
function $b34bd66f0aa7fdf3$var$rt(t, e) {
    return e = ~e, t ? t = 1 + ~t : e += 1, [
        t,
        e
    ];
}
function $b34bd66f0aa7fdf3$var$it(t, e) {
    let n, r = 0, i = 0, s = 0;
    const o = t.h;
    let a = t.g;
    do n = o[a++], r |= (127 & n) << s, s += 7;
    while (32 > s && 128 & n);
    for(32 < s && (i |= (127 & n) >> 4), s = 3; 32 > s && 128 & n; s += 7)n = o[a++], i |= (127 & n) << s;
    if ($b34bd66f0aa7fdf3$var$dt(t, a), 128 > n) return e(r >>> 0, i >>> 0);
    throw $b34bd66f0aa7fdf3$var$j();
}
function $b34bd66f0aa7fdf3$var$st(t) {
    let e = 0, n = t.g;
    const r = n + 10, i = t.h;
    for(; n < r;){
        const r = i[n++];
        if (e |= r, 0 == (128 & r)) return $b34bd66f0aa7fdf3$var$dt(t, n), !!(127 & e);
    }
    throw $b34bd66f0aa7fdf3$var$j();
}
function $b34bd66f0aa7fdf3$var$ot(t) {
    const e = t.h;
    let n = t.g, r = e[n++], i = 127 & r;
    if (128 & r && (r = e[n++], i |= (127 & r) << 7, 128 & r && (r = e[n++], i |= (127 & r) << 14, 128 & r && (r = e[n++], i |= (127 & r) << 21, 128 & r && (r = e[n++], i |= r << 28, 128 & r && 128 & e[n++] && 128 & e[n++] && 128 & e[n++] && 128 & e[n++] && 128 & e[n++]))))) throw $b34bd66f0aa7fdf3$var$j();
    return $b34bd66f0aa7fdf3$var$dt(t, n), i;
}
function $b34bd66f0aa7fdf3$var$at(t) {
    return $b34bd66f0aa7fdf3$var$ot(t) >>> 0;
}
function $b34bd66f0aa7fdf3$var$ht(t) {
    var e = t.h;
    const n = t.g, r = e[n], i = e[n + 1], s = e[n + 2];
    return e = e[n + 3], $b34bd66f0aa7fdf3$var$dt(t, t.g + 4), (r << 0 | i << 8 | s << 16 | e << 24) >>> 0;
}
function $b34bd66f0aa7fdf3$var$ct(t) {
    var e = $b34bd66f0aa7fdf3$var$ht(t);
    t = 2 * (e >> 31) + 1;
    const n = e >>> 23 & 255;
    return e &= 8388607, 255 == n ? e ? NaN : 1 / 0 * t : 0 == n ? t * Math.pow(2, -149) * e : t * Math.pow(2, n - 150) * (e + Math.pow(2, 23));
}
function $b34bd66f0aa7fdf3$var$ut(t) {
    return $b34bd66f0aa7fdf3$var$ot(t);
}
function $b34bd66f0aa7fdf3$var$lt(t, e, { ca: n = !1 } = {}) {
    t.ca = n, e && (e = $b34bd66f0aa7fdf3$var$X(e), t.h = e.buffer, t.m = e.P, t.j = 0, t.l = t.h.length, t.g = t.j);
}
function $b34bd66f0aa7fdf3$var$dt(t, e) {
    if (t.g = e, e > t.l) throw $b34bd66f0aa7fdf3$var$V(t.l, e);
}
function $b34bd66f0aa7fdf3$var$ft(t, e) {
    if (0 > e) throw Error(`Tried to read a negative byte length: ${e}`);
    const n = t.g, r = n + e;
    if (r > t.l) throw $b34bd66f0aa7fdf3$var$V(e, t.l - n);
    return t.g = r, n;
}
function $b34bd66f0aa7fdf3$var$pt(t, e) {
    if (0 == e) return $b34bd66f0aa7fdf3$var$D();
    var n = $b34bd66f0aa7fdf3$var$ft(t, e);
    return t.ca && t.m ? n = t.h.subarray(n, n + e) : (t = t.h, n = n === (e = n + e) ? $b34bd66f0aa7fdf3$var$C() : $b34bd66f0aa7fdf3$var$W ? t.slice(n, e) : new Uint8Array(t.subarray(n, e))), 0 == n.length ? $b34bd66f0aa7fdf3$var$D() : new $b34bd66f0aa7fdf3$var$B(n, $b34bd66f0aa7fdf3$var$O);
}
var $b34bd66f0aa7fdf3$var$gt = [];
function $b34bd66f0aa7fdf3$var$mt(t) {
    var e = t.g;
    if (e.g == e.l) return !1;
    t.l = t.g.g;
    var n = $b34bd66f0aa7fdf3$var$at(t.g);
    if (e = n >>> 3, !(0 <= (n &= 7) && 5 >= n)) throw $b34bd66f0aa7fdf3$var$G(n, t.l);
    if (1 > e) throw Error(`Invalid field number: ${e} (at position ${t.l})`);
    return t.m = e, t.h = n, !0;
}
function $b34bd66f0aa7fdf3$var$yt(t) {
    switch(t.h){
        case 0:
            0 != t.h ? $b34bd66f0aa7fdf3$var$yt(t) : $b34bd66f0aa7fdf3$var$st(t.g);
            break;
        case 1:
            $b34bd66f0aa7fdf3$var$dt(t = t.g, t.g + 8);
            break;
        case 2:
            if (2 != t.h) $b34bd66f0aa7fdf3$var$yt(t);
            else {
                var e = $b34bd66f0aa7fdf3$var$at(t.g);
                $b34bd66f0aa7fdf3$var$dt(t = t.g, t.g + e);
            }
            break;
        case 5:
            $b34bd66f0aa7fdf3$var$dt(t = t.g, t.g + 4);
            break;
        case 3:
            for(e = t.m;;){
                if (!$b34bd66f0aa7fdf3$var$mt(t)) throw Error("Unmatched start-group tag: stream EOF");
                if (4 == t.h) {
                    if (t.m != e) throw Error("Unmatched end-group tag");
                    break;
                }
                $b34bd66f0aa7fdf3$var$yt(t);
            }
            break;
        default:
            throw $b34bd66f0aa7fdf3$var$G(t.h, t.l);
    }
}
function $b34bd66f0aa7fdf3$var$_t(t, e, n) {
    const r = t.g.l, i = $b34bd66f0aa7fdf3$var$at(t.g), s = t.g.g + i;
    let o = s - r;
    if (0 >= o && (t.g.l = s, n(e, t, void 0, void 0, void 0), o = s - t.g.g), o) throw Error(`Message parsing ended unexpectedly. Expected to read ${i} bytes, instead read ${i - o} bytes, either the data ended unexpectedly or the message misreported its own length`);
    return t.g.g = s, t.g.l = r, e;
}
function $b34bd66f0aa7fdf3$var$vt(t) {
    var e = $b34bd66f0aa7fdf3$var$at(t.g), a = $b34bd66f0aa7fdf3$var$ft(t = t.g, e);
    if (t = t.h, $b34bd66f0aa7fdf3$var$o) {
        var h, c = t;
        (h = $b34bd66f0aa7fdf3$var$s) || (h = $b34bd66f0aa7fdf3$var$s = new TextDecoder("utf-8", {
            fatal: !0
        })), e = a + e, c = 0 === a && e === c.length ? c : c.subarray(a, e);
        try {
            var u = h.decode(c);
        } catch (t) {
            if (void 0 === $b34bd66f0aa7fdf3$var$i) {
                try {
                    h.decode(new Uint8Array([
                        128
                    ]));
                } catch (t) {}
                try {
                    h.decode(new Uint8Array([
                        97
                    ])), $b34bd66f0aa7fdf3$var$i = !0;
                } catch (t) {
                    $b34bd66f0aa7fdf3$var$i = !1;
                }
            }
            throw !$b34bd66f0aa7fdf3$var$i && ($b34bd66f0aa7fdf3$var$s = void 0), t;
        }
    } else {
        e = (u = a) + e, a = [];
        let i, s = null;
        for(; u < e;){
            var l = t[u++];
            128 > l ? a.push(l) : 224 > l ? u >= e ? $b34bd66f0aa7fdf3$var$n() : (i = t[u++], 194 > l || 128 != (192 & i) ? (u--, $b34bd66f0aa7fdf3$var$n()) : a.push((31 & l) << 6 | 63 & i)) : 240 > l ? u >= e - 1 ? $b34bd66f0aa7fdf3$var$n() : (i = t[u++], 128 != (192 & i) || 224 === l && 160 > i || 237 === l && 160 <= i || 128 != (192 & (h = t[u++])) ? (u--, $b34bd66f0aa7fdf3$var$n()) : a.push((15 & l) << 12 | (63 & i) << 6 | 63 & h)) : 244 >= l ? u >= e - 2 ? $b34bd66f0aa7fdf3$var$n() : (i = t[u++], 128 != (192 & i) || 0 != i - 144 + (l << 28) >> 30 || 128 != (192 & (h = t[u++])) || 128 != (192 & (c = t[u++])) ? (u--, $b34bd66f0aa7fdf3$var$n()) : (l = (7 & l) << 18 | (63 & i) << 12 | (63 & h) << 6 | 63 & c, l -= 65536, a.push(55296 + (l >> 10 & 1023), 56320 + (1023 & l)))) : $b34bd66f0aa7fdf3$var$n(), 8192 <= a.length && (s = $b34bd66f0aa7fdf3$var$r(s, a), a.length = 0);
        }
        u = $b34bd66f0aa7fdf3$var$r(s, a);
    }
    return u;
}
function $b34bd66f0aa7fdf3$var$Et(t) {
    const e = $b34bd66f0aa7fdf3$var$at(t.g);
    return $b34bd66f0aa7fdf3$var$pt(t.g, e);
}
function $b34bd66f0aa7fdf3$var$wt(t, e, n) {
    var r = $b34bd66f0aa7fdf3$var$at(t.g);
    for(r = t.g.g + r; t.g.g < r;)n.push(e(t.g));
}
var $b34bd66f0aa7fdf3$var$Tt = [];
function $b34bd66f0aa7fdf3$var$At(t) {
    return t ? /^\d+$/.test(t) ? ($b34bd66f0aa7fdf3$var$nt(t), new $b34bd66f0aa7fdf3$var$bt($b34bd66f0aa7fdf3$var$K, $b34bd66f0aa7fdf3$var$Y)) : null : $b34bd66f0aa7fdf3$var$kt ||= new $b34bd66f0aa7fdf3$var$bt(0, 0);
}
var $b34bd66f0aa7fdf3$var$bt = class {
    constructor(t, e){
        this.h = t >>> 0, this.g = e >>> 0;
    }
};
let $b34bd66f0aa7fdf3$var$kt;
function $b34bd66f0aa7fdf3$var$xt(t) {
    return t ? /^-?\d+$/.test(t) ? ($b34bd66f0aa7fdf3$var$nt(t), new $b34bd66f0aa7fdf3$var$St($b34bd66f0aa7fdf3$var$K, $b34bd66f0aa7fdf3$var$Y)) : null : $b34bd66f0aa7fdf3$var$Lt ||= new $b34bd66f0aa7fdf3$var$St(0, 0);
}
var $b34bd66f0aa7fdf3$var$St = class {
    constructor(t, e){
        this.h = t >>> 0, this.g = e >>> 0;
    }
};
let $b34bd66f0aa7fdf3$var$Lt;
function $b34bd66f0aa7fdf3$var$Ft(t, e, n) {
    for(; 0 < n || 127 < e;)t.g.push(127 & e | 128), e = (e >>> 7 | n << 25) >>> 0, n >>>= 7;
    t.g.push(e);
}
function $b34bd66f0aa7fdf3$var$Rt(t, e) {
    for(; 127 < e;)t.g.push(127 & e | 128), e >>>= 7;
    t.g.push(e);
}
function $b34bd66f0aa7fdf3$var$Mt(t, e) {
    if (0 <= e) $b34bd66f0aa7fdf3$var$Rt(t, e);
    else {
        for(let n = 0; 9 > n; n++)t.g.push(127 & e | 128), e >>= 7;
        t.g.push(1);
    }
}
function $b34bd66f0aa7fdf3$var$Pt(t, e) {
    t.g.push(e >>> 0 & 255), t.g.push(e >>> 8 & 255), t.g.push(e >>> 16 & 255), t.g.push(e >>> 24 & 255);
}
function $b34bd66f0aa7fdf3$var$Ct(t, e) {
    0 !== e.length && (t.l.push(e), t.h += e.length);
}
function $b34bd66f0aa7fdf3$var$Ot(t, e, n) {
    $b34bd66f0aa7fdf3$var$Rt(t.g, 8 * e + n);
}
function $b34bd66f0aa7fdf3$var$It(t, e) {
    return $b34bd66f0aa7fdf3$var$Ot(t, e, 2), e = t.g.end(), $b34bd66f0aa7fdf3$var$Ct(t, e), e.push(t.h), e;
}
function $b34bd66f0aa7fdf3$var$Ut(t, e) {
    var n = e.pop();
    for(n = t.h + t.g.length() - n; 127 < n;)e.push(127 & n | 128), n >>>= 7, t.h++;
    e.push(n), t.h++;
}
function $b34bd66f0aa7fdf3$var$Dt(t, e, n) {
    $b34bd66f0aa7fdf3$var$Ot(t, e, 2), $b34bd66f0aa7fdf3$var$Rt(t.g, n.length), $b34bd66f0aa7fdf3$var$Ct(t, t.g.end()), $b34bd66f0aa7fdf3$var$Ct(t, n);
}
function $b34bd66f0aa7fdf3$var$Nt(t, e, n, r) {
    null != n && (e = $b34bd66f0aa7fdf3$var$It(t, e), r(n, t), $b34bd66f0aa7fdf3$var$Ut(t, e));
}
class $b34bd66f0aa7fdf3$var$Bt {
    constructor(t, e, n, r){
        this.g = t, this.h = e, this.l = n, this.pa = r;
    }
}
function $b34bd66f0aa7fdf3$var$Gt(t) {
    return Array.prototype.slice.call(t);
}
function $b34bd66f0aa7fdf3$var$jt(t) {
    return "function" == typeof Symbol && "symbol" == typeof Symbol() ? Symbol() : t;
}
var $b34bd66f0aa7fdf3$var$Vt = $b34bd66f0aa7fdf3$var$jt(), $b34bd66f0aa7fdf3$var$Xt = $b34bd66f0aa7fdf3$var$jt("0di"), $b34bd66f0aa7fdf3$var$Ht = $b34bd66f0aa7fdf3$var$jt("2ex"), $b34bd66f0aa7fdf3$var$Wt = $b34bd66f0aa7fdf3$var$jt("0dg"), $b34bd66f0aa7fdf3$var$zt = $b34bd66f0aa7fdf3$var$Vt ? (t, e)=>{
    t[$b34bd66f0aa7fdf3$var$Vt] |= e;
} : (t, e)=>{
    void 0 !== t.g ? t.g |= e : Object.defineProperties(t, {
        g: {
            value: e,
            configurable: !0,
            writable: !0,
            enumerable: !1
        }
    });
}, $b34bd66f0aa7fdf3$var$Kt = $b34bd66f0aa7fdf3$var$Vt ? (t, e)=>{
    t[$b34bd66f0aa7fdf3$var$Vt] &= ~e;
} : (t, e)=>{
    void 0 !== t.g && (t.g &= ~e);
};
function $b34bd66f0aa7fdf3$var$Yt(t, e, n) {
    return n ? t | e : t & ~e;
}
var $b34bd66f0aa7fdf3$var$$t = $b34bd66f0aa7fdf3$var$Vt ? (t)=>0 | t[$b34bd66f0aa7fdf3$var$Vt] : (t)=>0 | t.g, $b34bd66f0aa7fdf3$var$qt = $b34bd66f0aa7fdf3$var$Vt ? (t)=>t[$b34bd66f0aa7fdf3$var$Vt] : (t)=>t.g, $b34bd66f0aa7fdf3$var$Jt = $b34bd66f0aa7fdf3$var$Vt ? (t, e)=>(t[$b34bd66f0aa7fdf3$var$Vt] = e, t) : (t, e)=>(void 0 !== t.g ? t.g = e : Object.defineProperties(t, {
        g: {
            value: e,
            configurable: !0,
            writable: !0,
            enumerable: !1
        }
    }), t);
function $b34bd66f0aa7fdf3$var$Zt(t) {
    return $b34bd66f0aa7fdf3$var$zt(t, 34), t;
}
function $b34bd66f0aa7fdf3$var$Qt(t, e) {
    $b34bd66f0aa7fdf3$var$Jt(e, -14591 & (0 | t));
}
function $b34bd66f0aa7fdf3$var$te(t, e) {
    $b34bd66f0aa7fdf3$var$Jt(e, -14557 & (34 | t));
}
function $b34bd66f0aa7fdf3$var$ee(t) {
    return 0 === (t = t >> 14 & 1023) ? 536870912 : t;
}
var $b34bd66f0aa7fdf3$var$ne, $b34bd66f0aa7fdf3$var$re = {}, $b34bd66f0aa7fdf3$var$ie = {};
function $b34bd66f0aa7fdf3$var$se(t) {
    return !(!t || "object" != typeof t || t.Ja !== $b34bd66f0aa7fdf3$var$ie);
}
function $b34bd66f0aa7fdf3$var$oe(t) {
    return null !== t && "object" == typeof t && !Array.isArray(t) && t.constructor === Object;
}
function $b34bd66f0aa7fdf3$var$ae(t, e, n) {
    if (null != t) {
        if ("string" == typeof t) t = t ? new $b34bd66f0aa7fdf3$var$B(t, $b34bd66f0aa7fdf3$var$O) : $b34bd66f0aa7fdf3$var$D();
        else if (t.constructor !== $b34bd66f0aa7fdf3$var$B) {
            if ($b34bd66f0aa7fdf3$var$M(t)) t = t.length ? new $b34bd66f0aa7fdf3$var$B(n ? t : new Uint8Array(t), $b34bd66f0aa7fdf3$var$O) : $b34bd66f0aa7fdf3$var$D();
            else {
                if (!e) throw Error();
                t = void 0;
            }
        }
    }
    return t;
}
function $b34bd66f0aa7fdf3$var$he(t, e, n) {
    if (!Array.isArray(t) || t.length) return !1;
    const r = $b34bd66f0aa7fdf3$var$$t(t);
    return !!(1 & r) || !(!e || !(Array.isArray(e) ? e.includes(n) : e.has(n))) && ($b34bd66f0aa7fdf3$var$Jt(t, 1 | r), !0);
}
const $b34bd66f0aa7fdf3$var$ce = [];
function $b34bd66f0aa7fdf3$var$ue(t) {
    if (2 & t) throw Error();
}
$b34bd66f0aa7fdf3$var$Jt($b34bd66f0aa7fdf3$var$ce, 55), $b34bd66f0aa7fdf3$var$ne = Object.freeze($b34bd66f0aa7fdf3$var$ce);
class $b34bd66f0aa7fdf3$var$le {
    constructor(t, e, n){
        this.l = 0, this.g = t, this.h = e, this.m = n;
    }
    next() {
        if (this.l < this.g.length) {
            const t = this.g[this.l++];
            return {
                done: !1,
                value: this.h ? this.h.call(this.m, t) : t
            };
        }
        return {
            done: !0,
            value: void 0
        };
    }
    [Symbol.iterator]() {
        return new $b34bd66f0aa7fdf3$var$le(this.g, this.h, this.m);
    }
}
let $b34bd66f0aa7fdf3$var$de, $b34bd66f0aa7fdf3$var$fe, $b34bd66f0aa7fdf3$var$pe;
function $b34bd66f0aa7fdf3$var$ge(t, e) {
    (e = $b34bd66f0aa7fdf3$var$de ? e[$b34bd66f0aa7fdf3$var$de] : void 0) && (t[$b34bd66f0aa7fdf3$var$de] = $b34bd66f0aa7fdf3$var$Gt(e));
}
function $b34bd66f0aa7fdf3$var$me(t, e) {
    t.__closure__error__context__984382 || (t.__closure__error__context__984382 = {}), t.__closure__error__context__984382.severity = e;
}
function $b34bd66f0aa7fdf3$var$ye() {
    const e = Error();
    $b34bd66f0aa7fdf3$var$me(e, "incident"), function(e) {
        $b34bd66f0aa7fdf3$var$t.setTimeout(()=>{
            throw e;
        }, 0);
    }(e);
}
function $b34bd66f0aa7fdf3$var$_e(t) {
    return $b34bd66f0aa7fdf3$var$me(t = Error(t), "warning"), t;
}
function $b34bd66f0aa7fdf3$var$ve(t) {
    return null == t || "number" == typeof t ? t : "NaN" === t || "Infinity" === t || "-Infinity" === t ? Number(t) : void 0;
}
function $b34bd66f0aa7fdf3$var$Ee(t) {
    return null == t || "boolean" == typeof t ? t : "number" == typeof t ? !!t : void 0;
}
Object.freeze(new class {
}), Object.freeze(new class {
});
const $b34bd66f0aa7fdf3$var$we = /^-?([1-9][0-9]*|0)(\.[0-9]+)?$/;
function $b34bd66f0aa7fdf3$var$Te(t) {
    const e = typeof t;
    return "number" === e ? Number.isFinite(t) : "string" === e && $b34bd66f0aa7fdf3$var$we.test(t);
}
function $b34bd66f0aa7fdf3$var$Ae(t) {
    if (null == t) return t;
    if ("string" == typeof t) {
        if (!t) return;
        t = +t;
    }
    return "number" == typeof t && Number.isFinite(t) ? 0 | t : void 0;
}
function $b34bd66f0aa7fdf3$var$be(t) {
    if (null == t) return t;
    if ("string" == typeof t) {
        if (!t) return;
        t = +t;
    }
    return "number" == typeof t && Number.isFinite(t) ? t >>> 0 : void 0;
}
function $b34bd66f0aa7fdf3$var$ke(t) {
    return "-" !== t[0] && (20 > t.length || 20 === t.length && 184467 > Number(t.substring(0, 6)));
}
function $b34bd66f0aa7fdf3$var$xe(t) {
    return "-" === t[0] ? 20 > t.length || 20 === t.length && -922337 < Number(t.substring(0, 7)) : 19 > t.length || 19 === t.length && 922337 > Number(t.substring(0, 6));
}
function $b34bd66f0aa7fdf3$var$Se(t) {
    return t = Math.trunc(t), Number.isSafeInteger(t) || ($b34bd66f0aa7fdf3$var$$(t), t = $b34bd66f0aa7fdf3$var$Z($b34bd66f0aa7fdf3$var$K, $b34bd66f0aa7fdf3$var$Y)), t;
}
function $b34bd66f0aa7fdf3$var$Le(t) {
    var e = Math.trunc(Number(t));
    return Number.isSafeInteger(e) ? String(e) : (-1 !== (e = t.indexOf(".")) && (t = t.substring(0, e)), $b34bd66f0aa7fdf3$var$xe(t) || ($b34bd66f0aa7fdf3$var$nt(t), t = $b34bd66f0aa7fdf3$var$et()), t);
}
function $b34bd66f0aa7fdf3$var$Fe(t) {
    return null == t ? t : $b34bd66f0aa7fdf3$var$Te(t) ? "number" == typeof t ? $b34bd66f0aa7fdf3$var$Se(t) : $b34bd66f0aa7fdf3$var$Le(t) : void 0;
}
function $b34bd66f0aa7fdf3$var$Re(t) {
    if ("string" != typeof t) throw Error();
    return t;
}
function $b34bd66f0aa7fdf3$var$Me(t) {
    if (null != t && "string" != typeof t) throw Error();
    return t;
}
function $b34bd66f0aa7fdf3$var$Pe(t) {
    return null == t || "string" == typeof t ? t : void 0;
}
function $b34bd66f0aa7fdf3$var$Ce(t, e, n, r) {
    if (null != t && "object" == typeof t && t.X === $b34bd66f0aa7fdf3$var$re) return t;
    if (!Array.isArray(t)) return n ? 2 & r ? (t = e[$b34bd66f0aa7fdf3$var$Xt]) ? e = t : ($b34bd66f0aa7fdf3$var$Zt((t = new e).s), e = e[$b34bd66f0aa7fdf3$var$Xt] = t) : e = new e : e = void 0, e;
    let i = n = $b34bd66f0aa7fdf3$var$$t(t);
    return 0 === i && (i |= 32 & r), i |= 2 & r, i !== n && $b34bd66f0aa7fdf3$var$Jt(t, i), new e(t);
}
function $b34bd66f0aa7fdf3$var$Oe(t, e, n) {
    if (e) {
        var r = !!r;
        if (!$b34bd66f0aa7fdf3$var$Te(e = t)) throw $b34bd66f0aa7fdf3$var$_e("int64");
        "string" == typeof e ? r = $b34bd66f0aa7fdf3$var$Le(e) : r ? (r = Math.trunc(e), Number.isSafeInteger(r) ? r = String(r) : $b34bd66f0aa7fdf3$var$xe(e = String(r)) ? r = e : ($b34bd66f0aa7fdf3$var$$(r), r = $b34bd66f0aa7fdf3$var$et())) : r = $b34bd66f0aa7fdf3$var$Se(e);
    } else r = $b34bd66f0aa7fdf3$var$Fe(t);
    return "string" == typeof (n = null == (t = r) ? n ? 0 : void 0 : t) && (r = +n, Number.isSafeInteger(r)) ? r : n;
}
let $b34bd66f0aa7fdf3$var$Ie, $b34bd66f0aa7fdf3$var$Ue, $b34bd66f0aa7fdf3$var$De;
function $b34bd66f0aa7fdf3$var$Ne(t) {
    switch(typeof t){
        case "boolean":
            return $b34bd66f0aa7fdf3$var$Ue ||= [
                0,
                void 0,
                !0
            ];
        case "number":
            return 0 < t ? void 0 : 0 === t ? $b34bd66f0aa7fdf3$var$De ||= [
                0,
                void 0
            ] : [
                -t,
                void 0
            ];
        case "string":
            return [
                0,
                t
            ];
        case "object":
            return t;
    }
}
function $b34bd66f0aa7fdf3$var$Be(t, e) {
    return $b34bd66f0aa7fdf3$var$Ge(t, e[0], e[1]);
}
function $b34bd66f0aa7fdf3$var$Ge(t, e, n) {
    if (null == t && (t = $b34bd66f0aa7fdf3$var$Ie), $b34bd66f0aa7fdf3$var$Ie = void 0, null == t) {
        var r = 96;
        n ? (t = [
            n
        ], r |= 512) : t = [], e && (r = -16760833 & r | (1023 & e) << 14);
    } else {
        if (!Array.isArray(t)) throw Error("narr");
        if (2048 & (r = $b34bd66f0aa7fdf3$var$$t(t))) throw Error("farr");
        if (64 & r) return t;
        if (r |= 64, n && (r |= 512, n !== t[0])) throw Error("mid");
        t: {
            const i = (n = t).length;
            if (i) {
                const t = i - 1;
                if ($b34bd66f0aa7fdf3$var$oe(n[t])) {
                    if (1024 <= (e = t - (+!!(512 & (r |= 256)) - 1))) throw Error("pvtlmt");
                    r = -16760833 & r | (1023 & e) << 14;
                    break t;
                }
            }
            if (e) {
                if (1024 < (e = Math.max(e, i - (+!!(512 & r) - 1)))) throw Error("spvt");
                r = -16760833 & r | (1023 & e) << 14;
            }
        }
    }
    return $b34bd66f0aa7fdf3$var$Jt(t, r), t;
}
const $b34bd66f0aa7fdf3$var$je = {};
let $b34bd66f0aa7fdf3$var$Ve = function() {
    try {
        return $b34bd66f0aa7fdf3$var$_(new class extends Map {
            constructor(){
                super();
            }
        }), !1;
    } catch  {
        return !0;
    }
}();
class $b34bd66f0aa7fdf3$var$Xe {
    constructor(){
        this.g = new Map;
    }
    get(t) {
        return this.g.get(t);
    }
    set(t, e) {
        return this.g.set(t, e), this.size = this.g.size, this;
    }
    delete(t) {
        return t = this.g.delete(t), this.size = this.g.size, t;
    }
    clear() {
        this.g.clear(), this.size = this.g.size;
    }
    has(t) {
        return this.g.has(t);
    }
    entries() {
        return this.g.entries();
    }
    keys() {
        return this.g.keys();
    }
    values() {
        return this.g.values();
    }
    forEach(t, e) {
        return this.g.forEach(t, e);
    }
    [Symbol.iterator]() {
        return this.entries();
    }
}
const $b34bd66f0aa7fdf3$var$He = $b34bd66f0aa7fdf3$var$Ve ? (Object.setPrototypeOf($b34bd66f0aa7fdf3$var$Xe.prototype, Map.prototype), Object.defineProperties($b34bd66f0aa7fdf3$var$Xe.prototype, {
    size: {
        value: 0,
        configurable: !0,
        enumerable: !0,
        writable: !0
    }
}), $b34bd66f0aa7fdf3$var$Xe) : class extends Map {
    constructor(){
        super();
    }
};
function $b34bd66f0aa7fdf3$var$We(t) {
    return t;
}
function $b34bd66f0aa7fdf3$var$ze(t) {
    if (2 & t.N) throw Error("Cannot mutate an immutable Map");
}
var $b34bd66f0aa7fdf3$var$Ke = class extends $b34bd66f0aa7fdf3$var$He {
    constructor(t, e, n = $b34bd66f0aa7fdf3$var$We, r = $b34bd66f0aa7fdf3$var$We){
        super();
        let i = $b34bd66f0aa7fdf3$var$$t(t);
        i |= 64, $b34bd66f0aa7fdf3$var$Jt(t, i), this.N = i, this.U = e, this.S = n, this.Z = this.U ? $b34bd66f0aa7fdf3$var$Ye : r;
        for(let s = 0; s < t.length; s++){
            const o = t[s], a = n(o[0], !1, !0);
            let h = o[1];
            e ? void 0 === h && (h = null) : h = r(o[1], !1, !0, void 0, void 0, i), super.set(a, h);
        }
    }
    oa(t = $b34bd66f0aa7fdf3$var$$e) {
        if (0 !== this.size) return this.Y(t);
    }
    Y(t = $b34bd66f0aa7fdf3$var$$e) {
        const e = [], n = super.entries();
        for(var r; !(r = n.next()).done;)(r = r.value)[0] = t(r[0]), r[1] = t(r[1]), e.push(r);
        return e;
    }
    clear() {
        $b34bd66f0aa7fdf3$var$ze(this), super.clear();
    }
    delete(t) {
        return $b34bd66f0aa7fdf3$var$ze(this), super.delete(this.S(t, !0, !1));
    }
    entries() {
        var t = this.na();
        return new $b34bd66f0aa7fdf3$var$le(t, $b34bd66f0aa7fdf3$var$qe, this);
    }
    keys() {
        return this.Ia();
    }
    values() {
        var t = this.na();
        return new $b34bd66f0aa7fdf3$var$le(t, $b34bd66f0aa7fdf3$var$Ke.prototype.get, this);
    }
    forEach(t, e) {
        super.forEach((n, r)=>{
            t.call(e, this.get(r), r, this);
        });
    }
    set(t, e) {
        return $b34bd66f0aa7fdf3$var$ze(this), null == (t = this.S(t, !0, !1)) ? this : null == e ? (super.delete(t), this) : super.set(t, this.Z(e, !0, !0, this.U, !1, this.N));
    }
    Oa(t) {
        const e = this.S(t[0], !1, !0);
        t = t[1], t = this.U ? void 0 === t ? null : t : this.Z(t, !1, !0, void 0, !1, this.N), super.set(e, t);
    }
    has(t) {
        return super.has(this.S(t, !1, !1));
    }
    get(t) {
        t = this.S(t, !1, !1);
        const e = super.get(t);
        if (void 0 !== e) {
            var n = this.U;
            return n ? ((n = this.Z(e, !1, !0, n, this.ta, this.N)) !== e && super.set(t, n), n) : e;
        }
    }
    na() {
        return Array.from(super.keys());
    }
    Ia() {
        return super.keys();
    }
    [Symbol.iterator]() {
        return this.entries();
    }
};
function $b34bd66f0aa7fdf3$var$Ye(t, e, n, r, i, s) {
    return t = $b34bd66f0aa7fdf3$var$Ce(t, r, n, s), i && (t = $b34bd66f0aa7fdf3$var$an(t)), t;
}
function $b34bd66f0aa7fdf3$var$$e(t) {
    return t;
}
function $b34bd66f0aa7fdf3$var$qe(t) {
    return [
        t,
        this.get(t)
    ];
}
let $b34bd66f0aa7fdf3$var$Je;
function $b34bd66f0aa7fdf3$var$Ze() {
    return $b34bd66f0aa7fdf3$var$Je ||= new $b34bd66f0aa7fdf3$var$Ke($b34bd66f0aa7fdf3$var$Zt([]), void 0, void 0, void 0, $b34bd66f0aa7fdf3$var$je);
}
function $b34bd66f0aa7fdf3$var$Qe(t, e, n, r, i) {
    if (null != t) {
        if (Array.isArray(t)) t = $b34bd66f0aa7fdf3$var$he(t, void 0, 0) ? void 0 : i && 2 & $b34bd66f0aa7fdf3$var$$t(t) ? t : $b34bd66f0aa7fdf3$var$tn(t, e, n, void 0 !== r, i);
        else if ($b34bd66f0aa7fdf3$var$oe(t)) {
            const s = {};
            for(let o in t)s[o] = $b34bd66f0aa7fdf3$var$Qe(t[o], e, n, r, i);
            t = s;
        } else t = e(t, r);
        return t;
    }
}
function $b34bd66f0aa7fdf3$var$tn(t, e, n, r, i) {
    const s = r || n ? $b34bd66f0aa7fdf3$var$$t(t) : 0;
    r = r ? !!(32 & s) : void 0;
    const o = $b34bd66f0aa7fdf3$var$Gt(t);
    for(let t = 0; t < o.length; t++)o[t] = $b34bd66f0aa7fdf3$var$Qe(o[t], e, n, r, i);
    return n && ($b34bd66f0aa7fdf3$var$ge(o, t), n(s, o)), o;
}
function $b34bd66f0aa7fdf3$var$en(t) {
    return $b34bd66f0aa7fdf3$var$Qe(t, $b34bd66f0aa7fdf3$var$nn, void 0, void 0, !1);
}
function $b34bd66f0aa7fdf3$var$nn(t) {
    return t.X === $b34bd66f0aa7fdf3$var$re ? t.toJSON() : t instanceof $b34bd66f0aa7fdf3$var$Ke ? t.oa($b34bd66f0aa7fdf3$var$en) : function(t) {
        switch(typeof t){
            case "number":
                return isFinite(t) ? t : String(t);
            case "boolean":
                return t ? 1 : 0;
            case "object":
                if (t) {
                    if (Array.isArray(t)) {
                        if ($b34bd66f0aa7fdf3$var$he(t, void 0, 0)) return;
                    } else {
                        if ($b34bd66f0aa7fdf3$var$M(t)) return $b34bd66f0aa7fdf3$var$x(t);
                        if (t instanceof $b34bd66f0aa7fdf3$var$B) {
                            const e = t.g;
                            return null == e ? "" : "string" == typeof e ? e : t.g = $b34bd66f0aa7fdf3$var$x(e);
                        }
                        if (t instanceof $b34bd66f0aa7fdf3$var$Ke) return t.oa();
                    }
                }
        }
        return t;
    }(t);
}
function $b34bd66f0aa7fdf3$var$rn(t, e, n = $b34bd66f0aa7fdf3$var$te) {
    if (null != t) {
        if ($b34bd66f0aa7fdf3$var$b && t instanceof Uint8Array) return e ? t : new Uint8Array(t);
        if (Array.isArray(t)) {
            var r = $b34bd66f0aa7fdf3$var$$t(t);
            return 2 & r || (e &&= 0 === r || !!(32 & r) && !(64 & r || !(16 & r)), t = e ? $b34bd66f0aa7fdf3$var$Jt(t, -12293 & (34 | r)) : $b34bd66f0aa7fdf3$var$tn(t, $b34bd66f0aa7fdf3$var$rn, 4 & r ? $b34bd66f0aa7fdf3$var$te : n, !0, !0)), t;
        }
        return t.X === $b34bd66f0aa7fdf3$var$re ? (n = t.s, t = 2 & (r = $b34bd66f0aa7fdf3$var$qt(n)) ? t : $b34bd66f0aa7fdf3$var$sn(t, n, r, !0)) : t instanceof $b34bd66f0aa7fdf3$var$Ke && !(2 & t.N) && (n = $b34bd66f0aa7fdf3$var$Zt(t.Y($b34bd66f0aa7fdf3$var$rn)), t = new $b34bd66f0aa7fdf3$var$Ke(n, t.U, t.S, t.Z)), t;
    }
}
function $b34bd66f0aa7fdf3$var$sn(t, e, n, r) {
    return t = t.constructor, $b34bd66f0aa7fdf3$var$Ie = e = $b34bd66f0aa7fdf3$var$on(e, n, r), e = new t(e), $b34bd66f0aa7fdf3$var$Ie = void 0, e;
}
function $b34bd66f0aa7fdf3$var$on(t, e, n) {
    const r = n || 2 & e ? $b34bd66f0aa7fdf3$var$te : $b34bd66f0aa7fdf3$var$Qt, i = !!(32 & e);
    return t = function(t, e, n) {
        const r = $b34bd66f0aa7fdf3$var$Gt(t);
        var i = r.length;
        const s = 256 & e ? r[i - 1] : void 0;
        for(i += s ? -1 : 0, e = 512 & e ? 1 : 0; e < i; e++)r[e] = n(r[e]);
        if (s) {
            e = r[e] = {};
            for(const t in s)e[t] = n(s[t]);
        }
        return $b34bd66f0aa7fdf3$var$ge(r, t), r;
    }(t, e, (t)=>$b34bd66f0aa7fdf3$var$rn(t, i, r)), $b34bd66f0aa7fdf3$var$zt(t, 32 | (n ? 2 : 0)), t;
}
function $b34bd66f0aa7fdf3$var$an(t) {
    const e = t.s, n = $b34bd66f0aa7fdf3$var$qt(e);
    return 2 & n ? $b34bd66f0aa7fdf3$var$sn(t, e, n, !1) : t;
}
function $b34bd66f0aa7fdf3$var$hn(t, e, n, r) {
    return !(4 & e) || null != n && (!r && 0 === n && (4096 & e || 8192 & e) && 5 > (t.constructor[$b34bd66f0aa7fdf3$var$Wt] = 1 + (0 | t.constructor[$b34bd66f0aa7fdf3$var$Wt])) && $b34bd66f0aa7fdf3$var$ye(), 0 !== n && !(n & e));
}
function $b34bd66f0aa7fdf3$var$cn(t, e) {
    return $b34bd66f0aa7fdf3$var$ln(t = t.s, $b34bd66f0aa7fdf3$var$qt(t), e);
}
function $b34bd66f0aa7fdf3$var$un(t, e, n, r) {
    if (!(0 > (e = r + (+!!(512 & e) - 1)) || e >= t.length || e >= n)) return t[e];
}
function $b34bd66f0aa7fdf3$var$ln(t, e, n, r) {
    if (-1 === n) return null;
    const i = $b34bd66f0aa7fdf3$var$ee(e);
    if (!(n >= i)) {
        var s = t.length;
        return r && 256 & e && null != (r = t[s - 1][n]) ? ($b34bd66f0aa7fdf3$var$un(t, e, i, n) && null != $b34bd66f0aa7fdf3$var$Ht && (4 <= (e = (t = $b34bd66f0aa7fdf3$var$pe ??= {})[$b34bd66f0aa7fdf3$var$Ht] || 0) || (t[$b34bd66f0aa7fdf3$var$Ht] = e + 1, $b34bd66f0aa7fdf3$var$ye())), r) : $b34bd66f0aa7fdf3$var$un(t, e, i, n);
    }
    return 256 & e ? t[t.length - 1][n] : void 0;
}
function $b34bd66f0aa7fdf3$var$dn(t, e, n, r) {
    const i = t.s;
    let s = $b34bd66f0aa7fdf3$var$qt(i);
    return $b34bd66f0aa7fdf3$var$ue(s), $b34bd66f0aa7fdf3$var$fn(i, s, e, n, r), t;
}
function $b34bd66f0aa7fdf3$var$fn(t, e, n, r, i) {
    const s = $b34bd66f0aa7fdf3$var$ee(e);
    if (n >= s || i) {
        let o = e;
        if (256 & e) i = t[t.length - 1];
        else {
            if (null == r) return o;
            i = t[s + (+!!(512 & e) - 1)] = {}, o |= 256;
        }
        return i[n] = r, n < s && (t[n + (+!!(512 & e) - 1)] = void 0), o !== e && $b34bd66f0aa7fdf3$var$Jt(t, o), o;
    }
    return t[n + (+!!(512 & e) - 1)] = r, 256 & e && n in (t = t[t.length - 1]) && delete t[n], e;
}
function $b34bd66f0aa7fdf3$var$pn(t, e, n, r, i) {
    var s = 2 & e;
    let o = $b34bd66f0aa7fdf3$var$ln(t, e, n, i);
    Array.isArray(o) || (o = $b34bd66f0aa7fdf3$var$ne);
    const a = !(2 & r);
    r = !(1 & r);
    const h = !!(32 & e);
    let c = $b34bd66f0aa7fdf3$var$$t(o);
    return 0 !== c || !h || s || a ? 1 & c || (c |= 1, $b34bd66f0aa7fdf3$var$Jt(o, c)) : (c |= 33, $b34bd66f0aa7fdf3$var$Jt(o, c)), s ? (t = !1, 2 & c || ($b34bd66f0aa7fdf3$var$Zt(o), t = !!(4 & c)), (r || t) && Object.freeze(o)) : (s = !!(2 & c) || !!(2048 & c), r && s ? (o = $b34bd66f0aa7fdf3$var$Gt(o), r = 1, h && !a && (r |= 32), $b34bd66f0aa7fdf3$var$Jt(o, r), $b34bd66f0aa7fdf3$var$fn(t, e, n, o, i)) : a && 32 & c && !s && $b34bd66f0aa7fdf3$var$Kt(o, 32)), o;
}
function $b34bd66f0aa7fdf3$var$gn(t, e) {
    t = t.s;
    let n = $b34bd66f0aa7fdf3$var$qt(t);
    const r = $b34bd66f0aa7fdf3$var$ln(t, n, e), i = $b34bd66f0aa7fdf3$var$ve(r);
    return null != i && i !== r && $b34bd66f0aa7fdf3$var$fn(t, n, e, i), i;
}
function $b34bd66f0aa7fdf3$var$mn(t) {
    t = t.s;
    let e = $b34bd66f0aa7fdf3$var$qt(t);
    const n = $b34bd66f0aa7fdf3$var$ln(t, e, 1), r = $b34bd66f0aa7fdf3$var$ae(n, !0, !!(34 & e));
    return null != r && r !== n && $b34bd66f0aa7fdf3$var$fn(t, e, 1, r), r;
}
function $b34bd66f0aa7fdf3$var$yn(t, e, n) {
    const r = t.s;
    let i = $b34bd66f0aa7fdf3$var$qt(r);
    const s = 2 & i ? 1 : 2;
    let o = $b34bd66f0aa7fdf3$var$_n(r, i, e);
    var a = $b34bd66f0aa7fdf3$var$$t(o);
    if ($b34bd66f0aa7fdf3$var$hn(t, a, void 0, !1)) {
        (4 & a || Object.isFrozen(o)) && (o = $b34bd66f0aa7fdf3$var$Gt(o), a = $b34bd66f0aa7fdf3$var$In(a, i), i = $b34bd66f0aa7fdf3$var$fn(r, i, e, o));
        let s = t = 0;
        for(; t < o.length; t++){
            const e = n(o[t]);
            null != e && (o[s++] = e);
        }
        s < t && (o.length = s), a = $b34bd66f0aa7fdf3$var$Yt(a = $b34bd66f0aa7fdf3$var$vn(a, i), 20, !0), a = $b34bd66f0aa7fdf3$var$Yt(a, 4096, !1), a = $b34bd66f0aa7fdf3$var$Yt(a, 8192, !1), $b34bd66f0aa7fdf3$var$Jt(o, a), 2 & a && Object.freeze(o);
    }
    return $b34bd66f0aa7fdf3$var$En(a) || (n = a, (a = (t = 1 === s || 4 === s && !!(32 & a)) ? $b34bd66f0aa7fdf3$var$Yt(a, 2, !0) : $b34bd66f0aa7fdf3$var$Un(a, i, !1)) !== n && $b34bd66f0aa7fdf3$var$Jt(o, a), t && Object.freeze(o)), 2 === s && $b34bd66f0aa7fdf3$var$En(a) && (o = $b34bd66f0aa7fdf3$var$Gt(o), a = $b34bd66f0aa7fdf3$var$Un(a = $b34bd66f0aa7fdf3$var$In(a, i), i, !1), $b34bd66f0aa7fdf3$var$Jt(o, a), $b34bd66f0aa7fdf3$var$fn(r, i, e, o)), o;
}
function $b34bd66f0aa7fdf3$var$_n(t, e, n) {
    return t = $b34bd66f0aa7fdf3$var$ln(t, e, n), Array.isArray(t) ? t : $b34bd66f0aa7fdf3$var$ne;
}
function $b34bd66f0aa7fdf3$var$vn(t, e) {
    return 0 === t && (t = $b34bd66f0aa7fdf3$var$In(t, e)), $b34bd66f0aa7fdf3$var$Yt(t, 1, !0);
}
function $b34bd66f0aa7fdf3$var$En(t) {
    return !!(2 & t) && !!(4 & t) || !!(2048 & t);
}
function $b34bd66f0aa7fdf3$var$wn(t) {
    t = $b34bd66f0aa7fdf3$var$Gt(t);
    for(let e = 0; e < t.length; e++){
        const n = t[e] = $b34bd66f0aa7fdf3$var$Gt(t[e]);
        Array.isArray(n[1]) && (n[1] = $b34bd66f0aa7fdf3$var$Zt(n[1]));
    }
    return t;
}
function $b34bd66f0aa7fdf3$var$Tn(t, e, n) {
    {
        const a = t.s;
        let h = $b34bd66f0aa7fdf3$var$qt(a);
        if ($b34bd66f0aa7fdf3$var$ue(h), null == n) $b34bd66f0aa7fdf3$var$fn(a, h, e);
        else {
            var r, i = $b34bd66f0aa7fdf3$var$$t(n), s = i, o = !!(2 & i) || Object.isFrozen(n);
            if ((r = !o) && (r = !1), $b34bd66f0aa7fdf3$var$hn(t, i)) for(i = 21, o && (n = $b34bd66f0aa7fdf3$var$Gt(n), s = 0, i = $b34bd66f0aa7fdf3$var$Un(i = $b34bd66f0aa7fdf3$var$In(i, h), h, !0)), t = 0; t < n.length; t++)n[t] = $b34bd66f0aa7fdf3$var$Re(n[t]);
            r && (n = $b34bd66f0aa7fdf3$var$Gt(n), s = 0, i = $b34bd66f0aa7fdf3$var$Un(i = $b34bd66f0aa7fdf3$var$In(i, h), h, !0)), i !== s && $b34bd66f0aa7fdf3$var$Jt(n, i), $b34bd66f0aa7fdf3$var$fn(a, h, e, n);
        }
    }
}
function $b34bd66f0aa7fdf3$var$An(t, e, n, r) {
    t = t.s;
    let i = $b34bd66f0aa7fdf3$var$qt(t);
    $b34bd66f0aa7fdf3$var$ue(i), $b34bd66f0aa7fdf3$var$fn(t, i, e, ("0" === r ? 0 === Number(n) : n === r) ? void 0 : n);
}
function $b34bd66f0aa7fdf3$var$bn(t, e, n, r) {
    const i = $b34bd66f0aa7fdf3$var$qt(t);
    $b34bd66f0aa7fdf3$var$ue(i), t = $b34bd66f0aa7fdf3$var$pn(t, i, e, 2), r = n(r, !!(4 & (e = $b34bd66f0aa7fdf3$var$$t(t))) && !!(4096 & e)), t.push(r);
}
function $b34bd66f0aa7fdf3$var$kn(t) {
    return t;
}
function $b34bd66f0aa7fdf3$var$xn(t, e) {
    return $b34bd66f0aa7fdf3$var$Sn(t = t.s, $b34bd66f0aa7fdf3$var$qt(t), $b34bd66f0aa7fdf3$var$ws) === e ? e : -1;
}
function $b34bd66f0aa7fdf3$var$Sn(t, e, n) {
    let r = 0;
    for(let i = 0; i < n.length; i++){
        const s = n[i];
        null != $b34bd66f0aa7fdf3$var$ln(t, e, s) && (0 !== r && (e = $b34bd66f0aa7fdf3$var$fn(t, e, r)), r = s);
    }
    return r;
}
function $b34bd66f0aa7fdf3$var$Ln(t, e, n, r) {
    let i = $b34bd66f0aa7fdf3$var$qt(t);
    $b34bd66f0aa7fdf3$var$ue(i);
    const s = $b34bd66f0aa7fdf3$var$ln(t, i, n, r);
    let o;
    if (null != s && s.X === $b34bd66f0aa7fdf3$var$re) return (e = $b34bd66f0aa7fdf3$var$an(s)) !== s && $b34bd66f0aa7fdf3$var$fn(t, i, n, e, r), e.s;
    if (Array.isArray(s)) {
        const t = $b34bd66f0aa7fdf3$var$$t(s);
        o = 2 & t ? $b34bd66f0aa7fdf3$var$on(s, t, !1) : s, o = $b34bd66f0aa7fdf3$var$Be(o, e);
    } else o = $b34bd66f0aa7fdf3$var$Be(void 0, e);
    return o !== s && $b34bd66f0aa7fdf3$var$fn(t, i, n, o, r), o;
}
function $b34bd66f0aa7fdf3$var$Fn(t, e, n, r) {
    t = t.s;
    let i = $b34bd66f0aa7fdf3$var$qt(t);
    const s = $b34bd66f0aa7fdf3$var$ln(t, i, n, r);
    return (e = $b34bd66f0aa7fdf3$var$Ce(s, e, !1, i)) !== s && null != e && $b34bd66f0aa7fdf3$var$fn(t, i, n, e, r), e;
}
function $b34bd66f0aa7fdf3$var$Rn(t, e, n, r = !1) {
    if (null == (e = $b34bd66f0aa7fdf3$var$Fn(t, e, n, r))) return e;
    t = t.s;
    let i = $b34bd66f0aa7fdf3$var$qt(t);
    if (!(2 & i)) {
        const s = $b34bd66f0aa7fdf3$var$an(e);
        s !== e && $b34bd66f0aa7fdf3$var$fn(t, i, n, e = s, r);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$Mn(t, e, n, r, i, s) {
    var o = 2, a = !!(2 & e);
    o = a ? 1 : o, i = !!i, s &&= !a, a = $b34bd66f0aa7fdf3$var$_n(t, e, r);
    var h = $b34bd66f0aa7fdf3$var$$t(a);
    const c = !!(4 & h);
    if (!c) {
        var u = a, l = e;
        const t = !!(2 & (h = $b34bd66f0aa7fdf3$var$vn(h, e)));
        t && (l = $b34bd66f0aa7fdf3$var$Yt(l, 2, !0));
        let r = !t, i = !0, s = 0, o = 0;
        for(; s < u.length; s++){
            const e = $b34bd66f0aa7fdf3$var$Ce(u[s], n, !1, l);
            if (e instanceof n) {
                if (!t) {
                    const t = !!(2 & $b34bd66f0aa7fdf3$var$$t(e.s));
                    r &&= !t, i &&= t;
                }
                u[o++] = e;
            }
        }
        o < s && (u.length = o), h = $b34bd66f0aa7fdf3$var$Yt(h, 4, !0), h = $b34bd66f0aa7fdf3$var$Yt(h, 16, i), h = $b34bd66f0aa7fdf3$var$Yt(h, 8, r), $b34bd66f0aa7fdf3$var$Jt(u, h), t && Object.freeze(u);
    }
    if (s && !(8 & h || !a.length && (1 === o || 4 === o && 32 & h))) {
        for($b34bd66f0aa7fdf3$var$En(h) && (a = $b34bd66f0aa7fdf3$var$Gt(a), h = $b34bd66f0aa7fdf3$var$In(h, e), e = $b34bd66f0aa7fdf3$var$fn(t, e, r, a)), n = a, s = h, u = 0; u < n.length; u++)(h = n[u]) !== (l = $b34bd66f0aa7fdf3$var$an(h)) && (n[u] = l);
        s = $b34bd66f0aa7fdf3$var$Yt(s, 8, !0), s = $b34bd66f0aa7fdf3$var$Yt(s, 16, !n.length), $b34bd66f0aa7fdf3$var$Jt(n, s), h = s;
    }
    return $b34bd66f0aa7fdf3$var$En(h) || (n = h, (h = (s = 1 === o || 4 === o && !!(32 & h)) ? $b34bd66f0aa7fdf3$var$Yt(h, !a.length || 16 & h && (!c || 32 & h) ? 2 : 2048, !0) : $b34bd66f0aa7fdf3$var$Un(h, e, i)) !== n && $b34bd66f0aa7fdf3$var$Jt(a, h), s && Object.freeze(a)), 2 === o && $b34bd66f0aa7fdf3$var$En(h) && (a = $b34bd66f0aa7fdf3$var$Gt(a), h = $b34bd66f0aa7fdf3$var$Un(h = $b34bd66f0aa7fdf3$var$In(h, e), e, i), $b34bd66f0aa7fdf3$var$Jt(a, h), $b34bd66f0aa7fdf3$var$fn(t, e, r, a)), a;
}
function $b34bd66f0aa7fdf3$var$Pn(t, e, n) {
    t = t.s;
    const r = $b34bd66f0aa7fdf3$var$qt(t);
    return $b34bd66f0aa7fdf3$var$Mn(t, r, e, n, !1, !(2 & r));
}
function $b34bd66f0aa7fdf3$var$Cn(t, e, n, r, i) {
    return null == r && (r = void 0), $b34bd66f0aa7fdf3$var$dn(t, n, r, i);
}
function $b34bd66f0aa7fdf3$var$On(t, e, n, r) {
    null == r && (r = void 0), t = t.s;
    let i = $b34bd66f0aa7fdf3$var$qt(t);
    $b34bd66f0aa7fdf3$var$ue(i), (n = $b34bd66f0aa7fdf3$var$Sn(t, i, n)) && n !== e && null != r && (i = $b34bd66f0aa7fdf3$var$fn(t, i, n)), $b34bd66f0aa7fdf3$var$fn(t, i, e, r);
}
function $b34bd66f0aa7fdf3$var$In(t, e) {
    return t = $b34bd66f0aa7fdf3$var$Yt(t, 2, !!(2 & e)), t = $b34bd66f0aa7fdf3$var$Yt(t, 32, !0), $b34bd66f0aa7fdf3$var$Yt(t, 2048, !1);
}
function $b34bd66f0aa7fdf3$var$Un(t, e, n) {
    return 32 & e && n || (t = $b34bd66f0aa7fdf3$var$Yt(t, 32, !1)), t;
}
function $b34bd66f0aa7fdf3$var$Dn(t, e, n, r) {
    t = t.s;
    const i = $b34bd66f0aa7fdf3$var$qt(t);
    $b34bd66f0aa7fdf3$var$ue(i), e = $b34bd66f0aa7fdf3$var$Mn(t, i, n, e, !0), n = null != r ? r : new n, e.push(n), 2 & $b34bd66f0aa7fdf3$var$$t(n.s) ? $b34bd66f0aa7fdf3$var$Kt(e, 8) : $b34bd66f0aa7fdf3$var$Kt(e, 16);
}
function $b34bd66f0aa7fdf3$var$Nn(t, e) {
    return $b34bd66f0aa7fdf3$var$Ae($b34bd66f0aa7fdf3$var$cn(t, e));
}
function $b34bd66f0aa7fdf3$var$Bn(t, e) {
    return t ?? e;
}
function $b34bd66f0aa7fdf3$var$Gn(t, e) {
    return $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$gn(t, e), 0);
}
function $b34bd66f0aa7fdf3$var$jn(t, e) {
    return $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$Pe($b34bd66f0aa7fdf3$var$cn(t, e)), "");
}
function $b34bd66f0aa7fdf3$var$Vn(t, e, n) {
    if (null != n && "boolean" != typeof n) throw t = typeof n, Error(`Expected boolean but got ${"object" != t ? t : n ? Array.isArray(n) ? "array" : t : "null"}: ${n}`);
    $b34bd66f0aa7fdf3$var$dn(t, e, n);
}
function $b34bd66f0aa7fdf3$var$Xn(t, e, n) {
    if (null != n) {
        if ("number" != typeof n) throw $b34bd66f0aa7fdf3$var$_e("int32");
        if (!Number.isFinite(n)) throw $b34bd66f0aa7fdf3$var$_e("int32");
        n |= 0;
    }
    $b34bd66f0aa7fdf3$var$dn(t, e, n);
}
function $b34bd66f0aa7fdf3$var$Hn(t, e, n) {
    if (null != n && "number" != typeof n) throw Error(`Value of float/double field must be a number, found ${typeof n}: ${n}`);
    $b34bd66f0aa7fdf3$var$dn(t, e, n);
}
function $b34bd66f0aa7fdf3$var$Wn(t, e, n) {
    e.g ? e.m(t, e.g, e.h, n, !0) : e.m(t, e.h, n, !0);
}
$b34bd66f0aa7fdf3$var$Ke.prototype.toJSON = void 0, $b34bd66f0aa7fdf3$var$Ke.prototype.Ja = $b34bd66f0aa7fdf3$var$ie;
var $b34bd66f0aa7fdf3$var$zn = class {
    constructor(t, e){
        this.s = $b34bd66f0aa7fdf3$var$Ge(t, e);
    }
    toJSON() {
        return $b34bd66f0aa7fdf3$var$Kn(this, $b34bd66f0aa7fdf3$var$tn(this.s, $b34bd66f0aa7fdf3$var$nn, void 0, void 0, !1), !0);
    }
    l() {
        var t = $b34bd66f0aa7fdf3$var$ko;
        return t.g ? t.l(this, t.g, t.h, !0) : t.l(this, t.h, t.defaultValue, !0);
    }
    clone() {
        const t = this.s;
        return $b34bd66f0aa7fdf3$var$sn(this, t, $b34bd66f0aa7fdf3$var$qt(t), !1);
    }
    P() {
        return !!(2 & $b34bd66f0aa7fdf3$var$$t(this.s));
    }
};
function $b34bd66f0aa7fdf3$var$Kn(t, e, n) {
    var r = $b34bd66f0aa7fdf3$var$d ? void 0 : t.constructor.B;
    const i = $b34bd66f0aa7fdf3$var$qt(n ? t.s : e);
    if (!(t = e.length)) return e;
    let s, o;
    if ($b34bd66f0aa7fdf3$var$oe(n = e[t - 1])) {
        t: {
            var a = n;
            let t = {}, e = !1;
            for(var h in a){
                let n = a[h];
                if (Array.isArray(n)) {
                    let t = n;
                    ($b34bd66f0aa7fdf3$var$he(n, r, +h) || $b34bd66f0aa7fdf3$var$se(n) && 0 === n.size) && (n = null), n != t && (e = !0);
                }
                null != n ? t[h] = n : e = !0;
            }
            if (e) {
                for(var c in t){
                    a = t;
                    break t;
                }
                a = null;
            }
        }
        a != n && (s = !0), t--;
    }
    for(h = +!!(512 & i) - 1; 0 < t && (n = e[c = t - 1], c -= h, null == n || $b34bd66f0aa7fdf3$var$he(n, r, c) || $b34bd66f0aa7fdf3$var$se(n) && 0 === n.size); t--)o = !0;
    return s || o ? (e = Array.prototype.slice.call(e, 0, t), a && e.push(a), e) : e;
}
function $b34bd66f0aa7fdf3$var$Yn(t) {
    return Array.isArray(t) ? t[0] instanceof $b34bd66f0aa7fdf3$var$Bt ? t : [
        $b34bd66f0aa7fdf3$var$$r,
        t
    ] : [
        t,
        void 0
    ];
}
function $b34bd66f0aa7fdf3$var$$n(t, e) {
    if (Array.isArray(e)) {
        var n = $b34bd66f0aa7fdf3$var$$t(e);
        if (4 & n) return e;
        for(var r = 0, i = 0; r < e.length; r++){
            const n = t(e[r]);
            null != n && (e[i++] = n);
        }
        return i < r && (e.length = i), $b34bd66f0aa7fdf3$var$Jt(e, -12289 & (5 | n)), 2 & n && Object.freeze(e), e;
    }
}
$b34bd66f0aa7fdf3$var$zn.prototype.X = $b34bd66f0aa7fdf3$var$re, $b34bd66f0aa7fdf3$var$zn.prototype.toString = function() {
    return $b34bd66f0aa7fdf3$var$Kn(this, this.s, !1).toString();
};
const $b34bd66f0aa7fdf3$var$qn = Symbol();
function $b34bd66f0aa7fdf3$var$Jn(t) {
    let e = t[$b34bd66f0aa7fdf3$var$qn];
    if (!e) {
        const n = $b34bd66f0aa7fdf3$var$sr(t), r = $b34bd66f0aa7fdf3$var$yr(t), i = r.l;
        e = i ? (t, e)=>i(t, e, r) : (t, e)=>{
            for(; $b34bd66f0aa7fdf3$var$mt(e) && 4 != e.h;){
                var i = e.m, s = r[i];
                if (!s) {
                    var o = r.ea;
                    o && (o = o[i]) && (s = r[i] = $b34bd66f0aa7fdf3$var$Zn(o));
                }
                s && s(e, t, i) || (i = (s = e).l, $b34bd66f0aa7fdf3$var$yt(s), s.ia ? s = void 0 : (o = s.g.g - i, s.g.g = i, s = $b34bd66f0aa7fdf3$var$pt(s.g, o)), i = t, s && ($b34bd66f0aa7fdf3$var$de ||= Symbol(), (o = i[$b34bd66f0aa7fdf3$var$de]) ? o.push(s) : i[$b34bd66f0aa7fdf3$var$de] = [
                    s
                ]));
            }
            n === $b34bd66f0aa7fdf3$var$tr || n === $b34bd66f0aa7fdf3$var$er || n.j || (t[$b34bd66f0aa7fdf3$var$fe ||= Symbol()] = n);
        }, t[$b34bd66f0aa7fdf3$var$qn] = e;
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$Zn(t) {
    const e = (t = $b34bd66f0aa7fdf3$var$Yn(t))[0].g;
    if (t = t[1]) {
        const n = $b34bd66f0aa7fdf3$var$Jn(t), r = $b34bd66f0aa7fdf3$var$yr(t).T;
        return (t, i, s)=>e(t, i, s, r, n);
    }
    return e;
}
class $b34bd66f0aa7fdf3$var$Qn {
}
let $b34bd66f0aa7fdf3$var$tr, $b34bd66f0aa7fdf3$var$er;
const $b34bd66f0aa7fdf3$var$nr = Symbol();
function $b34bd66f0aa7fdf3$var$rr(t, e, n) {
    const r = n[1];
    let i;
    if (r) {
        const n = r[$b34bd66f0aa7fdf3$var$nr];
        i = n ? n.T : $b34bd66f0aa7fdf3$var$Ne(r[0]), t[e] = n ?? r;
    }
    i && i === $b34bd66f0aa7fdf3$var$Ue ? (t.g || (t.g = new Set)).add(e) : n[0] && (t.h || (t.h = new Set)).add(e);
}
function $b34bd66f0aa7fdf3$var$ir(t, e) {
    return [
        t.l,
        !e || 0 < e[0] ? void 0 : e
    ];
}
function $b34bd66f0aa7fdf3$var$sr(t) {
    var e = t[$b34bd66f0aa7fdf3$var$nr];
    if (e) return e;
    if (!(e = $b34bd66f0aa7fdf3$var$ar(t, t[$b34bd66f0aa7fdf3$var$nr] = new $b34bd66f0aa7fdf3$var$Qn, $b34bd66f0aa7fdf3$var$ir, $b34bd66f0aa7fdf3$var$ir, $b34bd66f0aa7fdf3$var$rr)).ea && !e.h && !e.g) {
        let n = !0;
        for(let t in e)isNaN(t) || (n = !1);
        n ? ($b34bd66f0aa7fdf3$var$Ne(t[0]) === $b34bd66f0aa7fdf3$var$Ue ? $b34bd66f0aa7fdf3$var$er ? e = $b34bd66f0aa7fdf3$var$er : ((e = new $b34bd66f0aa7fdf3$var$Qn).T = $b34bd66f0aa7fdf3$var$Ne(!0), e = $b34bd66f0aa7fdf3$var$er = e) : e = $b34bd66f0aa7fdf3$var$tr ||= new $b34bd66f0aa7fdf3$var$Qn, e = t[$b34bd66f0aa7fdf3$var$nr] = e) : e.j = !0;
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$or(t, e, n) {
    t[e] = n;
}
function $b34bd66f0aa7fdf3$var$ar(t, e, n, r, i = $b34bd66f0aa7fdf3$var$or) {
    e.T = $b34bd66f0aa7fdf3$var$Ne(t[0]);
    let s = 0;
    var o = t[++s];
    o && o.constructor === Object && (e.ea = o, "function" == typeof (o = t[++s]) && (e.l = o, e.m = t[++s], o = t[++s]));
    const a = {};
    for(; Array.isArray(o) && "number" == typeof o[0] && 0 < o[0];){
        for(var h = 0; h < o.length; h++)a[o[h]] = o;
        o = t[++s];
    }
    for(h = 1; void 0 !== o;){
        let l;
        "number" == typeof o && (h += o, o = t[++s]);
        var c = void 0;
        if (o instanceof $b34bd66f0aa7fdf3$var$Bt ? l = o : (l = $b34bd66f0aa7fdf3$var$qr, s--), l.pa) {
            o = t[++s], c = t;
            var u = s;
            "function" == typeof o && (o = o(), c[u] = o), c = o;
        }
        for(u = h + 1, "number" == typeof (o = t[++s]) && 0 > o && (u -= o, o = t[++s]); h < u; h++){
            const t = a[h];
            i(e, h, c ? r(l, c, t) : n(l, t));
        }
    }
    return e;
}
const $b34bd66f0aa7fdf3$var$hr = Symbol();
function $b34bd66f0aa7fdf3$var$cr(t) {
    let e = t[$b34bd66f0aa7fdf3$var$hr];
    if (!e) {
        const n = $b34bd66f0aa7fdf3$var$fr(t);
        e = (t, e)=>$b34bd66f0aa7fdf3$var$Er(t, e, n), t[$b34bd66f0aa7fdf3$var$hr] = e;
    }
    return e;
}
const $b34bd66f0aa7fdf3$var$ur = Symbol();
function $b34bd66f0aa7fdf3$var$lr(t) {
    return t.h;
}
function $b34bd66f0aa7fdf3$var$dr(t, e) {
    let n, r;
    const i = t.h;
    return (t, s, o)=>i(t, s, o, r ||= $b34bd66f0aa7fdf3$var$fr(e).T, n ||= $b34bd66f0aa7fdf3$var$cr(e));
}
function $b34bd66f0aa7fdf3$var$fr(t) {
    let e = t[$b34bd66f0aa7fdf3$var$ur];
    return e || (e = $b34bd66f0aa7fdf3$var$ar(t, t[$b34bd66f0aa7fdf3$var$ur] = {}, $b34bd66f0aa7fdf3$var$lr, $b34bd66f0aa7fdf3$var$dr), $b34bd66f0aa7fdf3$var$_r(t), e);
}
const $b34bd66f0aa7fdf3$var$pr = Symbol();
function $b34bd66f0aa7fdf3$var$gr(t, e) {
    const n = t.g;
    return e ? (t, r, i)=>n(t, r, i, e) : n;
}
function $b34bd66f0aa7fdf3$var$mr(t, e, n) {
    const r = t.g;
    let i, s;
    return (t, o, a)=>r(t, o, a, s ||= $b34bd66f0aa7fdf3$var$yr(e).T, i ||= $b34bd66f0aa7fdf3$var$Jn(e), n);
}
function $b34bd66f0aa7fdf3$var$yr(t) {
    let e = t[$b34bd66f0aa7fdf3$var$pr];
    return e || ($b34bd66f0aa7fdf3$var$sr(t), e = $b34bd66f0aa7fdf3$var$ar(t, t[$b34bd66f0aa7fdf3$var$pr] = {}, $b34bd66f0aa7fdf3$var$gr, $b34bd66f0aa7fdf3$var$mr), $b34bd66f0aa7fdf3$var$_r(t), e);
}
function $b34bd66f0aa7fdf3$var$_r(t) {
    $b34bd66f0aa7fdf3$var$pr in t && $b34bd66f0aa7fdf3$var$nr in t && $b34bd66f0aa7fdf3$var$ur in t && (t.length = 0);
}
function $b34bd66f0aa7fdf3$var$vr(t, e) {
    var n = t[e];
    if (n) return n;
    if ((n = t.ea) && (n = n[e])) {
        var r = (n = $b34bd66f0aa7fdf3$var$Yn(n))[0].h;
        if (n = n[1]) {
            const e = $b34bd66f0aa7fdf3$var$cr(n), i = $b34bd66f0aa7fdf3$var$fr(n).T;
            n = (n = t.m) ? n(i, e) : (t, n, s)=>r(t, n, s, i, e);
        } else n = r;
        return t[e] = n;
    }
}
function $b34bd66f0aa7fdf3$var$Er(t, e, n) {
    for(var r = $b34bd66f0aa7fdf3$var$qt(t), i = +!!(512 & r) - 1, s = t.length, o = 512 & r ? 1 : 0, a = s + (256 & r ? -1 : 0); o < a; o++){
        const r = t[o];
        if (null == r) continue;
        const s = o - i, a = $b34bd66f0aa7fdf3$var$vr(n, s);
        a && a(e, r, s);
    }
    if (256 & r) {
        r = t[s - 1];
        for(let t in r)i = +t, Number.isNaN(i) || null != (s = r[t]) && (a = $b34bd66f0aa7fdf3$var$vr(n, i)) && a(e, s, i);
    }
    if (t = $b34bd66f0aa7fdf3$var$de ? t[$b34bd66f0aa7fdf3$var$de] : void 0) for($b34bd66f0aa7fdf3$var$Ct(e, e.g.end()), n = 0; n < t.length; n++)$b34bd66f0aa7fdf3$var$Ct(e, $b34bd66f0aa7fdf3$var$N(t[n]) || $b34bd66f0aa7fdf3$var$C());
}
function $b34bd66f0aa7fdf3$var$wr(t, e) {
    return new $b34bd66f0aa7fdf3$var$Bt(t, e, !1, !1);
}
function $b34bd66f0aa7fdf3$var$Tr(t, e) {
    return new $b34bd66f0aa7fdf3$var$Bt(t, e, !0, !1);
}
function $b34bd66f0aa7fdf3$var$Ar(t, e) {
    return new $b34bd66f0aa7fdf3$var$Bt(t, e, !1, !0);
}
function $b34bd66f0aa7fdf3$var$br(t, e, n) {
    $b34bd66f0aa7fdf3$var$fn(t, $b34bd66f0aa7fdf3$var$qt(t), e, n);
}
var $b34bd66f0aa7fdf3$var$kr = $b34bd66f0aa7fdf3$var$Ar(function(t, e, n, r, i) {
    return 2 === t.h && (t = $b34bd66f0aa7fdf3$var$_t(t, $b34bd66f0aa7fdf3$var$Be([
        void 0,
        void 0
    ], r), i), $b34bd66f0aa7fdf3$var$ue(r = $b34bd66f0aa7fdf3$var$qt(e)), (i = $b34bd66f0aa7fdf3$var$ln(e, r, n)) instanceof $b34bd66f0aa7fdf3$var$Ke ? 0 != (2 & i.N) ? ((i = i.Y()).push(t), $b34bd66f0aa7fdf3$var$fn(e, r, n, i)) : i.Oa(t) : Array.isArray(i) ? (2 & $b34bd66f0aa7fdf3$var$$t(i) && $b34bd66f0aa7fdf3$var$fn(e, r, n, i = $b34bd66f0aa7fdf3$var$wn(i)), i.push(t)) : $b34bd66f0aa7fdf3$var$fn(e, r, n, [
        t
    ]), !0);
}, function(t, e, n, r, i) {
    if (e instanceof $b34bd66f0aa7fdf3$var$Ke) e.forEach((e, s)=>{
        $b34bd66f0aa7fdf3$var$Nt(t, n, $b34bd66f0aa7fdf3$var$Be([
            s,
            e
        ], r), i);
    });
    else if (Array.isArray(e)) for(let s = 0; s < e.length; s++){
        const o = e[s];
        Array.isArray(o) && $b34bd66f0aa7fdf3$var$Nt(t, n, $b34bd66f0aa7fdf3$var$Be(o, r), i);
    }
});
function $b34bd66f0aa7fdf3$var$xr(t, e, n) {
    t: if (null != e) {
        if ($b34bd66f0aa7fdf3$var$Te(e)) {
            if ("string" == typeof e) {
                e = $b34bd66f0aa7fdf3$var$Le(e);
                break t;
            }
            if ("number" == typeof e) {
                e = $b34bd66f0aa7fdf3$var$Se(e);
                break t;
            }
        }
        e = void 0;
    }
    null != e && ("string" == typeof e && $b34bd66f0aa7fdf3$var$xt(e), null != e && ($b34bd66f0aa7fdf3$var$Ot(t, n, 0), "number" == typeof e ? (t = t.g, $b34bd66f0aa7fdf3$var$$(e), $b34bd66f0aa7fdf3$var$Ft(t, $b34bd66f0aa7fdf3$var$K, $b34bd66f0aa7fdf3$var$Y)) : (n = $b34bd66f0aa7fdf3$var$xt(e), $b34bd66f0aa7fdf3$var$Ft(t.g, n.h, n.g))));
}
function $b34bd66f0aa7fdf3$var$Sr(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$Ae(e)) && null != e && ($b34bd66f0aa7fdf3$var$Ot(t, n, 0), $b34bd66f0aa7fdf3$var$Mt(t.g, e));
}
function $b34bd66f0aa7fdf3$var$Lr(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$Ee(e)) && ($b34bd66f0aa7fdf3$var$Ot(t, n, 0), t.g.g.push(e ? 1 : 0));
}
function $b34bd66f0aa7fdf3$var$Fr(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$Pe(e)) && $b34bd66f0aa7fdf3$var$Dt(t, n, $b34bd66f0aa7fdf3$var$c(e));
}
function $b34bd66f0aa7fdf3$var$Rr(t, e, n, r, i) {
    $b34bd66f0aa7fdf3$var$Nt(t, n, e instanceof $b34bd66f0aa7fdf3$var$zn ? e.s : Array.isArray(e) ? $b34bd66f0aa7fdf3$var$Be(e, r) : void 0, i);
}
function $b34bd66f0aa7fdf3$var$Mr(t, e, n) {
    null != (e = null == e || "string" == typeof e || $b34bd66f0aa7fdf3$var$M(e) || e instanceof $b34bd66f0aa7fdf3$var$B ? e : void 0) && $b34bd66f0aa7fdf3$var$Dt(t, n, $b34bd66f0aa7fdf3$var$X(e).buffer);
}
function $b34bd66f0aa7fdf3$var$Pr(t, e, n) {
    return (5 === t.h || 2 === t.h) && (e = $b34bd66f0aa7fdf3$var$pn(e, $b34bd66f0aa7fdf3$var$qt(e), n, 2, !1), 2 == t.h ? $b34bd66f0aa7fdf3$var$wt(t, $b34bd66f0aa7fdf3$var$ct, e) : e.push($b34bd66f0aa7fdf3$var$ct(t.g)), !0);
}
var $b34bd66f0aa7fdf3$var$Cr, $b34bd66f0aa7fdf3$var$Or = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    if (1 !== t.h) return !1;
    var r = t.g;
    t = $b34bd66f0aa7fdf3$var$ht(r);
    const i = $b34bd66f0aa7fdf3$var$ht(r);
    r = 2 * (i >> 31) + 1;
    const s = i >>> 20 & 2047;
    return t = 4294967296 * (1048575 & i) + t, $b34bd66f0aa7fdf3$var$br(e, n, 2047 == s ? t ? NaN : 1 / 0 * r : 0 == s ? r * Math.pow(2, -1074) * t : r * Math.pow(2, s - 1075) * (t + 4503599627370496)), !0;
}, function(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$ve(e)) && ($b34bd66f0aa7fdf3$var$Ot(t, n, 1), t = t.g, (n = $b34bd66f0aa7fdf3$var$z ||= new DataView(new ArrayBuffer(8))).setFloat64(0, +e, !0), $b34bd66f0aa7fdf3$var$K = n.getUint32(0, !0), $b34bd66f0aa7fdf3$var$Y = n.getUint32(4, !0), $b34bd66f0aa7fdf3$var$Pt(t, $b34bd66f0aa7fdf3$var$K), $b34bd66f0aa7fdf3$var$Pt(t, $b34bd66f0aa7fdf3$var$Y));
}), $b34bd66f0aa7fdf3$var$Ir = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 5 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, $b34bd66f0aa7fdf3$var$ct(t.g)), !0);
}, function(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$ve(e)) && ($b34bd66f0aa7fdf3$var$Ot(t, n, 5), t = t.g, $b34bd66f0aa7fdf3$var$q(e), $b34bd66f0aa7fdf3$var$Pt(t, $b34bd66f0aa7fdf3$var$K));
}), $b34bd66f0aa7fdf3$var$Ur = $b34bd66f0aa7fdf3$var$Tr($b34bd66f0aa7fdf3$var$Pr, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$$n($b34bd66f0aa7fdf3$var$ve, e))) for(let o = 0; o < e.length; o++){
        var r = t, i = n, s = e[o];
        null != s && ($b34bd66f0aa7fdf3$var$Ot(r, i, 5), r = r.g, $b34bd66f0aa7fdf3$var$q(s), $b34bd66f0aa7fdf3$var$Pt(r, $b34bd66f0aa7fdf3$var$K));
    }
}), $b34bd66f0aa7fdf3$var$Dr = $b34bd66f0aa7fdf3$var$Tr($b34bd66f0aa7fdf3$var$Pr, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$$n($b34bd66f0aa7fdf3$var$ve, e)) && e.length) {
        $b34bd66f0aa7fdf3$var$Ot(t, n, 2), $b34bd66f0aa7fdf3$var$Rt(t.g, 4 * e.length);
        for(let r = 0; r < e.length; r++)n = t.g, $b34bd66f0aa7fdf3$var$q(e[r]), $b34bd66f0aa7fdf3$var$Pt(n, $b34bd66f0aa7fdf3$var$K);
    }
}), $b34bd66f0aa7fdf3$var$Nr = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, $b34bd66f0aa7fdf3$var$it(t.g, $b34bd66f0aa7fdf3$var$Z)), !0);
}, $b34bd66f0aa7fdf3$var$xr), $b34bd66f0aa7fdf3$var$Br = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, 0 === (t = $b34bd66f0aa7fdf3$var$it(t.g, $b34bd66f0aa7fdf3$var$Z)) ? void 0 : t), !0);
}, $b34bd66f0aa7fdf3$var$xr), $b34bd66f0aa7fdf3$var$Gr = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, $b34bd66f0aa7fdf3$var$it(t.g, $b34bd66f0aa7fdf3$var$J)), !0);
}, function(t, e, n) {
    t: if (null != e) {
        if ($b34bd66f0aa7fdf3$var$Te(e)) {
            if ("string" == typeof e) {
                var r = Math.trunc(Number(e));
                Number.isSafeInteger(r) && 0 <= r ? e = String(r) : (-1 !== (r = e.indexOf(".")) && (e = e.substring(0, r)), $b34bd66f0aa7fdf3$var$ke(e) || ($b34bd66f0aa7fdf3$var$nt(e), e = $b34bd66f0aa7fdf3$var$Q($b34bd66f0aa7fdf3$var$K, $b34bd66f0aa7fdf3$var$Y)));
                break t;
            }
            if ("number" == typeof e) {
                e = 0 <= (e = Math.trunc(e)) && Number.isSafeInteger(e) ? e : function(t) {
                    if (0 > t) {
                        $b34bd66f0aa7fdf3$var$$(t);
                        const e = $b34bd66f0aa7fdf3$var$Q($b34bd66f0aa7fdf3$var$K, $b34bd66f0aa7fdf3$var$Y);
                        return t = Number(e), Number.isSafeInteger(t) ? t : e;
                    }
                    return $b34bd66f0aa7fdf3$var$ke(String(t)) ? t : ($b34bd66f0aa7fdf3$var$$(t), $b34bd66f0aa7fdf3$var$J($b34bd66f0aa7fdf3$var$K, $b34bd66f0aa7fdf3$var$Y));
                }(e);
                break t;
            }
        }
        e = void 0;
    }
    null != e && ("string" == typeof e && $b34bd66f0aa7fdf3$var$At(e), null != e && ($b34bd66f0aa7fdf3$var$Ot(t, n, 0), "number" == typeof e ? (t = t.g, $b34bd66f0aa7fdf3$var$$(e), $b34bd66f0aa7fdf3$var$Ft(t, $b34bd66f0aa7fdf3$var$K, $b34bd66f0aa7fdf3$var$Y)) : (n = $b34bd66f0aa7fdf3$var$At(e), $b34bd66f0aa7fdf3$var$Ft(t.g, n.h, n.g))));
}), $b34bd66f0aa7fdf3$var$jr = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, $b34bd66f0aa7fdf3$var$ot(t.g)), !0);
}, $b34bd66f0aa7fdf3$var$Sr), $b34bd66f0aa7fdf3$var$Vr = $b34bd66f0aa7fdf3$var$Tr(function(t, e, n) {
    return (0 === t.h || 2 === t.h) && (e = $b34bd66f0aa7fdf3$var$pn(e, $b34bd66f0aa7fdf3$var$qt(e), n, 2, !1), 2 == t.h ? $b34bd66f0aa7fdf3$var$wt(t, $b34bd66f0aa7fdf3$var$ot, e) : e.push($b34bd66f0aa7fdf3$var$ot(t.g)), !0);
}, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$$n($b34bd66f0aa7fdf3$var$Ae, e)) && e.length) {
        n = $b34bd66f0aa7fdf3$var$It(t, n);
        for(let n = 0; n < e.length; n++)$b34bd66f0aa7fdf3$var$Mt(t.g, e[n]);
        $b34bd66f0aa7fdf3$var$Ut(t, n);
    }
}), $b34bd66f0aa7fdf3$var$Xr = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, 0 === (t = $b34bd66f0aa7fdf3$var$ot(t.g)) ? void 0 : t), !0);
}, $b34bd66f0aa7fdf3$var$Sr), $b34bd66f0aa7fdf3$var$Hr = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, $b34bd66f0aa7fdf3$var$st(t.g)), !0);
}, $b34bd66f0aa7fdf3$var$Lr), $b34bd66f0aa7fdf3$var$Wr = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, !1 === (t = $b34bd66f0aa7fdf3$var$st(t.g)) ? void 0 : t), !0);
}, $b34bd66f0aa7fdf3$var$Lr), $b34bd66f0aa7fdf3$var$zr = $b34bd66f0aa7fdf3$var$Tr(function(t, e, n) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$bn(e, n, $b34bd66f0aa7fdf3$var$kn, t = $b34bd66f0aa7fdf3$var$vt(t)), !0);
}, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$$n($b34bd66f0aa7fdf3$var$Pe, e))) for(let o = 0; o < e.length; o++){
        var r = t, i = n, s = e[o];
        null != s && $b34bd66f0aa7fdf3$var$Dt(r, i, $b34bd66f0aa7fdf3$var$c(s));
    }
}), $b34bd66f0aa7fdf3$var$Kr = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, "" === (t = $b34bd66f0aa7fdf3$var$vt(t)) ? void 0 : t), !0);
}, $b34bd66f0aa7fdf3$var$Fr), $b34bd66f0aa7fdf3$var$Yr = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, $b34bd66f0aa7fdf3$var$vt(t)), !0);
}, $b34bd66f0aa7fdf3$var$Fr), $b34bd66f0aa7fdf3$var$$r = $b34bd66f0aa7fdf3$var$Ar(function(t, e, n, r, i) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$_t(t, $b34bd66f0aa7fdf3$var$Ln(e, r, n, !0), i), !0);
}, $b34bd66f0aa7fdf3$var$Rr), $b34bd66f0aa7fdf3$var$qr = $b34bd66f0aa7fdf3$var$Ar(function(t, e, n, r, i) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$_t(t, $b34bd66f0aa7fdf3$var$Ln(e, r, n), i), !0);
}, $b34bd66f0aa7fdf3$var$Rr);
$b34bd66f0aa7fdf3$var$Cr = new $b34bd66f0aa7fdf3$var$Bt(function(t, e, n, r, i) {
    if (2 !== t.h) return !1;
    r = $b34bd66f0aa7fdf3$var$Be(void 0, r);
    let s = $b34bd66f0aa7fdf3$var$qt(e);
    $b34bd66f0aa7fdf3$var$ue(s);
    let o = $b34bd66f0aa7fdf3$var$pn(e, s, n, 3);
    return s = $b34bd66f0aa7fdf3$var$qt(e), 4 & $b34bd66f0aa7fdf3$var$$t(o) && (o = $b34bd66f0aa7fdf3$var$Gt(o), $b34bd66f0aa7fdf3$var$Jt(o, -2079 & (1 | $b34bd66f0aa7fdf3$var$$t(o))), $b34bd66f0aa7fdf3$var$fn(e, s, n, o)), o.push(r), $b34bd66f0aa7fdf3$var$_t(t, r, i), !0;
}, function(t, e, n, r, i) {
    if (Array.isArray(e)) for(let s = 0; s < e.length; s++)$b34bd66f0aa7fdf3$var$Rr(t, e[s], n, r, i);
}, !0, !0);
var $b34bd66f0aa7fdf3$var$Jr = $b34bd66f0aa7fdf3$var$Ar(function(t, e, n, r, i, s) {
    if (2 !== t.h) return !1;
    let o = $b34bd66f0aa7fdf3$var$qt(e);
    return $b34bd66f0aa7fdf3$var$ue(o), (s = $b34bd66f0aa7fdf3$var$Sn(e, o, s)) && n !== s && $b34bd66f0aa7fdf3$var$fn(e, o, s), $b34bd66f0aa7fdf3$var$_t(t, e = $b34bd66f0aa7fdf3$var$Ln(e, r, n), i), !0;
}, $b34bd66f0aa7fdf3$var$Rr), $b34bd66f0aa7fdf3$var$Zr = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 2 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, $b34bd66f0aa7fdf3$var$Et(t)), !0);
}, $b34bd66f0aa7fdf3$var$Mr), $b34bd66f0aa7fdf3$var$Qr = $b34bd66f0aa7fdf3$var$Tr(function(t, e, n) {
    return (0 === t.h || 2 === t.h) && (e = $b34bd66f0aa7fdf3$var$pn(e, $b34bd66f0aa7fdf3$var$qt(e), n, 2, !1), 2 == t.h ? $b34bd66f0aa7fdf3$var$wt(t, $b34bd66f0aa7fdf3$var$at, e) : e.push($b34bd66f0aa7fdf3$var$at(t.g)), !0);
}, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$$n($b34bd66f0aa7fdf3$var$be, e))) for(let o = 0; o < e.length; o++){
        var r = t, i = n, s = e[o];
        null != s && ($b34bd66f0aa7fdf3$var$Ot(r, i, 0), $b34bd66f0aa7fdf3$var$Rt(r.g, s));
    }
}), $b34bd66f0aa7fdf3$var$ti = $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
    return 0 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, $b34bd66f0aa7fdf3$var$ot(t.g)), !0);
}, function(t, e, n) {
    null != (e = $b34bd66f0aa7fdf3$var$Ae(e)) && (e = parseInt(e, 10), $b34bd66f0aa7fdf3$var$Ot(t, n, 0), $b34bd66f0aa7fdf3$var$Mt(t.g, e));
}), $b34bd66f0aa7fdf3$var$ei = $b34bd66f0aa7fdf3$var$Tr(function(t, e, n) {
    return (0 === t.h || 2 === t.h) && (e = $b34bd66f0aa7fdf3$var$pn(e, $b34bd66f0aa7fdf3$var$qt(e), n, 2, !1), 2 == t.h ? $b34bd66f0aa7fdf3$var$wt(t, $b34bd66f0aa7fdf3$var$ut, e) : e.push($b34bd66f0aa7fdf3$var$ot(t.g)), !0);
}, function(t, e, n) {
    if (null != (e = $b34bd66f0aa7fdf3$var$$n($b34bd66f0aa7fdf3$var$Ae, e)) && e.length) {
        n = $b34bd66f0aa7fdf3$var$It(t, n);
        for(let n = 0; n < e.length; n++)$b34bd66f0aa7fdf3$var$Mt(t.g, e[n]);
        $b34bd66f0aa7fdf3$var$Ut(t, n);
    }
});
class $b34bd66f0aa7fdf3$var$ni {
    constructor(t, e){
        this.h = t, this.g = e, this.l = $b34bd66f0aa7fdf3$var$Rn, this.m = $b34bd66f0aa7fdf3$var$Cn, this.defaultValue = void 0;
    }
}
function $b34bd66f0aa7fdf3$var$ri(t, e) {
    return new $b34bd66f0aa7fdf3$var$ni(t, e);
}
function $b34bd66f0aa7fdf3$var$ii(t, e) {
    return (n, r)=>{
        if ($b34bd66f0aa7fdf3$var$Tt.length) {
            const t = $b34bd66f0aa7fdf3$var$Tt.pop();
            t.o(r), $b34bd66f0aa7fdf3$var$lt(t.g, n, r), n = t;
        } else n = new class {
            constructor(t, e){
                if ($b34bd66f0aa7fdf3$var$gt.length) {
                    const n = $b34bd66f0aa7fdf3$var$gt.pop();
                    $b34bd66f0aa7fdf3$var$lt(n, t, e), t = n;
                } else t = new class {
                    constructor(t, e){
                        this.h = null, this.m = !1, this.g = this.l = this.j = 0, $b34bd66f0aa7fdf3$var$lt(this, t, e);
                    }
                    clear() {
                        this.h = null, this.m = !1, this.g = this.l = this.j = 0, this.ca = !1;
                    }
                }(t, e);
                this.g = t, this.l = this.g.g, this.h = this.m = -1, this.o(e);
            }
            o({ ia: t = !1 } = {}) {
                this.ia = t;
            }
        }(n, r);
        try {
            const r = new t, s = r.s;
            $b34bd66f0aa7fdf3$var$Jn(e)(s, n);
            var i = r;
        } finally{
            n.g.clear(), n.m = -1, n.h = -1, 100 > $b34bd66f0aa7fdf3$var$Tt.length && $b34bd66f0aa7fdf3$var$Tt.push(n);
        }
        return i;
    };
}
function $b34bd66f0aa7fdf3$var$si(t) {
    return function() {
        const e = new class {
            constructor(){
                this.l = [], this.h = 0, this.g = new class {
                    constructor(){
                        this.g = [];
                    }
                    length() {
                        return this.g.length;
                    }
                    end() {
                        const t = this.g;
                        return this.g = [], t;
                    }
                };
            }
        };
        $b34bd66f0aa7fdf3$var$Er(this.s, e, $b34bd66f0aa7fdf3$var$fr(t)), $b34bd66f0aa7fdf3$var$Ct(e, e.g.end());
        const n = new Uint8Array(e.h), r = e.l, i = r.length;
        let s = 0;
        for(let t = 0; t < i; t++){
            const e = r[t];
            n.set(e, s), s += e.length;
        }
        return e.l = [
            n
        ], n;
    };
}
var $b34bd66f0aa7fdf3$var$oi = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$ai = [
    0,
    $b34bd66f0aa7fdf3$var$Kr,
    $b34bd66f0aa7fdf3$var$wr(function(t, e, n) {
        return 2 === t.h && ($b34bd66f0aa7fdf3$var$br(e, n, (t = $b34bd66f0aa7fdf3$var$Et(t)) === $b34bd66f0aa7fdf3$var$D() ? void 0 : t), !0);
    }, function(t, e, n) {
        if (null != e) {
            if (e instanceof $b34bd66f0aa7fdf3$var$zn) {
                const r = e.Qa;
                return void (r && (e = r(e), null != e && $b34bd66f0aa7fdf3$var$Dt(t, n, $b34bd66f0aa7fdf3$var$X(e).buffer)));
            }
            if (Array.isArray(e)) return;
        }
        $b34bd66f0aa7fdf3$var$Mr(t, e, n);
    })
], $b34bd66f0aa7fdf3$var$hi = [
    0,
    $b34bd66f0aa7fdf3$var$Yr
], $b34bd66f0aa7fdf3$var$ci = [
    0,
    $b34bd66f0aa7fdf3$var$jr,
    $b34bd66f0aa7fdf3$var$ti,
    $b34bd66f0aa7fdf3$var$Hr,
    -1,
    $b34bd66f0aa7fdf3$var$Vr,
    $b34bd66f0aa7fdf3$var$ti,
    -1
], $b34bd66f0aa7fdf3$var$ui = [
    0,
    $b34bd66f0aa7fdf3$var$Hr,
    -1
], $b34bd66f0aa7fdf3$var$li = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(){
        super();
    }
};
$b34bd66f0aa7fdf3$var$li.B = [
    6
];
var $b34bd66f0aa7fdf3$var$di = [
    0,
    $b34bd66f0aa7fdf3$var$Hr,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$Hr,
    $b34bd66f0aa7fdf3$var$ti,
    -1,
    $b34bd66f0aa7fdf3$var$ei,
    $b34bd66f0aa7fdf3$var$Yr,
    -1,
    $b34bd66f0aa7fdf3$var$ui,
    $b34bd66f0aa7fdf3$var$ti
], $b34bd66f0aa7fdf3$var$fi = [
    0,
    $b34bd66f0aa7fdf3$var$Yr,
    -2
], $b34bd66f0aa7fdf3$var$pi = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(){
        super();
    }
}, $b34bd66f0aa7fdf3$var$gi = [
    0
], $b34bd66f0aa7fdf3$var$mi = [
    0,
    $b34bd66f0aa7fdf3$var$jr,
    $b34bd66f0aa7fdf3$var$Hr,
    -4
], $b34bd66f0aa7fdf3$var$yi = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t, 2);
    }
}, $b34bd66f0aa7fdf3$var$_i = {}, $b34bd66f0aa7fdf3$var$vi = [
    -2,
    $b34bd66f0aa7fdf3$var$_i,
    $b34bd66f0aa7fdf3$var$Hr
];
$b34bd66f0aa7fdf3$var$_i[336783863] = [
    0,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$Hr,
    -1,
    $b34bd66f0aa7fdf3$var$jr,
    [
        0,
        [
            1,
            2,
            3,
            4,
            5,
            6
        ],
        $b34bd66f0aa7fdf3$var$Jr,
        $b34bd66f0aa7fdf3$var$gi,
        $b34bd66f0aa7fdf3$var$Jr,
        $b34bd66f0aa7fdf3$var$di,
        $b34bd66f0aa7fdf3$var$Jr,
        $b34bd66f0aa7fdf3$var$fi,
        $b34bd66f0aa7fdf3$var$Jr,
        $b34bd66f0aa7fdf3$var$mi,
        $b34bd66f0aa7fdf3$var$Jr,
        $b34bd66f0aa7fdf3$var$ci,
        $b34bd66f0aa7fdf3$var$Jr,
        [
            0,
            $b34bd66f0aa7fdf3$var$Yr
        ]
    ],
    $b34bd66f0aa7fdf3$var$hi,
    $b34bd66f0aa7fdf3$var$Hr,
    [
        0,
        [
            1,
            3
        ],
        [
            2,
            4
        ],
        $b34bd66f0aa7fdf3$var$Jr,
        [
            0,
            $b34bd66f0aa7fdf3$var$Vr
        ],
        -1,
        $b34bd66f0aa7fdf3$var$Jr,
        [
            0,
            $b34bd66f0aa7fdf3$var$zr
        ],
        -1,
        $b34bd66f0aa7fdf3$var$Cr,
        [
            0,
            $b34bd66f0aa7fdf3$var$Yr,
            -1
        ]
    ],
    $b34bd66f0aa7fdf3$var$Yr
];
var $b34bd66f0aa7fdf3$var$Ei = [
    0,
    $b34bd66f0aa7fdf3$var$Kr,
    $b34bd66f0aa7fdf3$var$Wr
], $b34bd66f0aa7fdf3$var$wi = [
    0,
    $b34bd66f0aa7fdf3$var$Br,
    -1,
    $b34bd66f0aa7fdf3$var$Wr,
    -3,
    $b34bd66f0aa7fdf3$var$Br,
    $b34bd66f0aa7fdf3$var$Vr,
    $b34bd66f0aa7fdf3$var$Kr,
    $b34bd66f0aa7fdf3$var$Xr,
    $b34bd66f0aa7fdf3$var$Br,
    -1,
    $b34bd66f0aa7fdf3$var$Wr,
    $b34bd66f0aa7fdf3$var$Xr,
    $b34bd66f0aa7fdf3$var$Wr,
    -2,
    $b34bd66f0aa7fdf3$var$Kr
], $b34bd66f0aa7fdf3$var$Ti = [
    -1,
    {}
], $b34bd66f0aa7fdf3$var$Ai = [
    0,
    $b34bd66f0aa7fdf3$var$Yr,
    1,
    $b34bd66f0aa7fdf3$var$Ti
], $b34bd66f0aa7fdf3$var$bi = [
    0,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$zr,
    $b34bd66f0aa7fdf3$var$Ti
];
function $b34bd66f0aa7fdf3$var$ki(t, e) {
    $b34bd66f0aa7fdf3$var$An(t, 2, $b34bd66f0aa7fdf3$var$Me(e), "");
}
function $b34bd66f0aa7fdf3$var$xi(t, e) {
    $b34bd66f0aa7fdf3$var$bn(t.s, 3, $b34bd66f0aa7fdf3$var$Re, e);
}
function $b34bd66f0aa7fdf3$var$Si(t, e) {
    $b34bd66f0aa7fdf3$var$bn(t.s, 4, $b34bd66f0aa7fdf3$var$Re, e);
}
var $b34bd66f0aa7fdf3$var$Li = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t, 500);
    }
    o(t) {
        return $b34bd66f0aa7fdf3$var$Cn(this, 0, 7, t);
    }
};
$b34bd66f0aa7fdf3$var$Li.B = [
    3,
    4,
    5,
    6,
    8,
    13,
    17,
    1005
];
var $b34bd66f0aa7fdf3$var$Fi = [
    -500,
    $b34bd66f0aa7fdf3$var$Kr,
    -1,
    $b34bd66f0aa7fdf3$var$zr,
    -3,
    $b34bd66f0aa7fdf3$var$vi,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$ai,
    $b34bd66f0aa7fdf3$var$Xr,
    -1,
    $b34bd66f0aa7fdf3$var$Ai,
    $b34bd66f0aa7fdf3$var$bi,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$Ei,
    $b34bd66f0aa7fdf3$var$Kr,
    $b34bd66f0aa7fdf3$var$wi,
    $b34bd66f0aa7fdf3$var$Xr,
    $b34bd66f0aa7fdf3$var$zr,
    987,
    $b34bd66f0aa7fdf3$var$zr
], $b34bd66f0aa7fdf3$var$Ri = [
    0,
    $b34bd66f0aa7fdf3$var$Kr,
    -1,
    $b34bd66f0aa7fdf3$var$Ti
], $b34bd66f0aa7fdf3$var$Mi = [
    -500,
    $b34bd66f0aa7fdf3$var$Yr,
    -1,
    [
        -1,
        {}
    ],
    998,
    $b34bd66f0aa7fdf3$var$Yr
], $b34bd66f0aa7fdf3$var$Pi = [
    -500,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$zr,
    -1,
    [
        -2,
        {},
        $b34bd66f0aa7fdf3$var$Hr
    ],
    997,
    $b34bd66f0aa7fdf3$var$zr,
    -1
], $b34bd66f0aa7fdf3$var$Ci = [
    -500,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$zr,
    $b34bd66f0aa7fdf3$var$Ti,
    998,
    $b34bd66f0aa7fdf3$var$zr
];
function $b34bd66f0aa7fdf3$var$Oi(t, e) {
    $b34bd66f0aa7fdf3$var$Dn(t, 1, $b34bd66f0aa7fdf3$var$Li, e);
}
function $b34bd66f0aa7fdf3$var$Ii(t, e) {
    $b34bd66f0aa7fdf3$var$bn(t.s, 10, $b34bd66f0aa7fdf3$var$Re, e);
}
function $b34bd66f0aa7fdf3$var$Ui(t, e) {
    $b34bd66f0aa7fdf3$var$bn(t.s, 15, $b34bd66f0aa7fdf3$var$Re, e);
}
var $b34bd66f0aa7fdf3$var$Di = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t, 500);
    }
    o(t) {
        return $b34bd66f0aa7fdf3$var$Cn(this, 0, 1001, t);
    }
};
$b34bd66f0aa7fdf3$var$Di.B = [
    1,
    6,
    7,
    9,
    10,
    15,
    16,
    17,
    14,
    1002
];
var $b34bd66f0aa7fdf3$var$Ni = [
    -500,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$Fi,
    4,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$Mi,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$Pi,
    $b34bd66f0aa7fdf3$var$Xr,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$Ci,
    $b34bd66f0aa7fdf3$var$zr,
    $b34bd66f0aa7fdf3$var$Xr,
    $b34bd66f0aa7fdf3$var$Ai,
    $b34bd66f0aa7fdf3$var$bi,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$Ri,
    $b34bd66f0aa7fdf3$var$zr,
    -2,
    $b34bd66f0aa7fdf3$var$wi,
    $b34bd66f0aa7fdf3$var$Kr,
    -1,
    $b34bd66f0aa7fdf3$var$Wr,
    979,
    $b34bd66f0aa7fdf3$var$Ti,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$ai
], $b34bd66f0aa7fdf3$var$Bi = $b34bd66f0aa7fdf3$var$ii($b34bd66f0aa7fdf3$var$Di, $b34bd66f0aa7fdf3$var$Ni);
$b34bd66f0aa7fdf3$var$Di.prototype.g = $b34bd66f0aa7fdf3$var$si($b34bd66f0aa7fdf3$var$Ni);
var $b34bd66f0aa7fdf3$var$Gi = [
    0,
    $b34bd66f0aa7fdf3$var$Cr,
    [
        0,
        $b34bd66f0aa7fdf3$var$jr,
        -2
    ]
], $b34bd66f0aa7fdf3$var$ji = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Vi = [
    0,
    $b34bd66f0aa7fdf3$var$jr,
    $b34bd66f0aa7fdf3$var$Ir,
    $b34bd66f0aa7fdf3$var$Yr,
    -1
], $b34bd66f0aa7fdf3$var$Xi = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
    g() {
        return $b34bd66f0aa7fdf3$var$Pn(this, $b34bd66f0aa7fdf3$var$ji, 1);
    }
};
$b34bd66f0aa7fdf3$var$Xi.B = [
    1
];
var $b34bd66f0aa7fdf3$var$Hi = [
    0,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$Vi
], $b34bd66f0aa7fdf3$var$Wi = $b34bd66f0aa7fdf3$var$ii($b34bd66f0aa7fdf3$var$Xi, $b34bd66f0aa7fdf3$var$Hi), $b34bd66f0aa7fdf3$var$zi = [
    0,
    $b34bd66f0aa7fdf3$var$jr,
    $b34bd66f0aa7fdf3$var$Ir
], $b34bd66f0aa7fdf3$var$Ki = [
    0,
    $b34bd66f0aa7fdf3$var$jr,
    -1,
    $b34bd66f0aa7fdf3$var$Gi
], $b34bd66f0aa7fdf3$var$Yi = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$$i = [
    0,
    $b34bd66f0aa7fdf3$var$jr,
    -3
], $b34bd66f0aa7fdf3$var$qi = [
    0,
    $b34bd66f0aa7fdf3$var$Ir,
    -3
], $b34bd66f0aa7fdf3$var$Ji = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Zi = [
    0,
    $b34bd66f0aa7fdf3$var$Ir,
    -1,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$Ir
], $b34bd66f0aa7fdf3$var$Qi = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
    h() {
        return $b34bd66f0aa7fdf3$var$Rn(this, $b34bd66f0aa7fdf3$var$Yi, 2);
    }
    g() {
        return $b34bd66f0aa7fdf3$var$Pn(this, $b34bd66f0aa7fdf3$var$Ji, 5);
    }
};
$b34bd66f0aa7fdf3$var$Qi.B = [
    5
];
var $b34bd66f0aa7fdf3$var$ts = [
    0,
    $b34bd66f0aa7fdf3$var$ti,
    $b34bd66f0aa7fdf3$var$$i,
    $b34bd66f0aa7fdf3$var$qi,
    $b34bd66f0aa7fdf3$var$Ki,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$Zi
], $b34bd66f0aa7fdf3$var$es = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$es.B = [
    1,
    2,
    3,
    8,
    9
];
var $b34bd66f0aa7fdf3$var$ns = $b34bd66f0aa7fdf3$var$ii($b34bd66f0aa7fdf3$var$es, [
    0,
    $b34bd66f0aa7fdf3$var$zr,
    $b34bd66f0aa7fdf3$var$Vr,
    $b34bd66f0aa7fdf3$var$Dr,
    $b34bd66f0aa7fdf3$var$ts,
    $b34bd66f0aa7fdf3$var$Yr,
    -1,
    $b34bd66f0aa7fdf3$var$Nr,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$zi,
    $b34bd66f0aa7fdf3$var$zr,
    $b34bd66f0aa7fdf3$var$Nr
]), $b34bd66f0aa7fdf3$var$rs = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$is = [
    0,
    $b34bd66f0aa7fdf3$var$Ir,
    -4
], $b34bd66f0aa7fdf3$var$ss = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$ss.B = [
    1
];
var $b34bd66f0aa7fdf3$var$os = $b34bd66f0aa7fdf3$var$ii($b34bd66f0aa7fdf3$var$ss, [
    0,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$is
]), $b34bd66f0aa7fdf3$var$as = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$hs = [
    0,
    $b34bd66f0aa7fdf3$var$Ir,
    -4
], $b34bd66f0aa7fdf3$var$cs = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$cs.B = [
    1
];
var $b34bd66f0aa7fdf3$var$us = $b34bd66f0aa7fdf3$var$ii($b34bd66f0aa7fdf3$var$cs, [
    0,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$hs
]), $b34bd66f0aa7fdf3$var$ls = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$ls.B = [
    3
];
var $b34bd66f0aa7fdf3$var$ds = [
    0,
    $b34bd66f0aa7fdf3$var$jr,
    -1,
    $b34bd66f0aa7fdf3$var$Dr,
    $b34bd66f0aa7fdf3$var$ti
], $b34bd66f0aa7fdf3$var$fs = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(){
        super();
    }
};
$b34bd66f0aa7fdf3$var$fs.prototype.g = $b34bd66f0aa7fdf3$var$si([
    0,
    $b34bd66f0aa7fdf3$var$Ir,
    -4,
    $b34bd66f0aa7fdf3$var$Nr
]);
var $b34bd66f0aa7fdf3$var$ps = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$gs = [
    0,
    1,
    $b34bd66f0aa7fdf3$var$jr,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$Hi
], $b34bd66f0aa7fdf3$var$ms = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$ms.B = [
    1
];
var $b34bd66f0aa7fdf3$var$ys = $b34bd66f0aa7fdf3$var$ii($b34bd66f0aa7fdf3$var$ms, [
    0,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$gs,
    $b34bd66f0aa7fdf3$var$Nr
]), $b34bd66f0aa7fdf3$var$_s = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$_s.B = [
    1
];
var $b34bd66f0aa7fdf3$var$vs = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
    qa() {
        const t = $b34bd66f0aa7fdf3$var$mn(this);
        return null == t ? $b34bd66f0aa7fdf3$var$D() : t;
    }
}, $b34bd66f0aa7fdf3$var$Es = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$ws = [
    1,
    2
], $b34bd66f0aa7fdf3$var$Ts = [
    0,
    $b34bd66f0aa7fdf3$var$ws,
    $b34bd66f0aa7fdf3$var$Jr,
    [
        0,
        $b34bd66f0aa7fdf3$var$Dr
    ],
    $b34bd66f0aa7fdf3$var$Jr,
    [
        0,
        $b34bd66f0aa7fdf3$var$Zr
    ],
    $b34bd66f0aa7fdf3$var$jr,
    $b34bd66f0aa7fdf3$var$Yr
], $b34bd66f0aa7fdf3$var$As = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$As.B = [
    1
];
var $b34bd66f0aa7fdf3$var$bs = $b34bd66f0aa7fdf3$var$ii($b34bd66f0aa7fdf3$var$As, [
    0,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$Ts,
    $b34bd66f0aa7fdf3$var$Nr
]), $b34bd66f0aa7fdf3$var$ks = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$ks.B = [
    4,
    5
];
var $b34bd66f0aa7fdf3$var$xs = [
    0,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$jr,
    $b34bd66f0aa7fdf3$var$Ir,
    $b34bd66f0aa7fdf3$var$zr,
    -1
], $b34bd66f0aa7fdf3$var$Ss = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Ls = [
    0,
    $b34bd66f0aa7fdf3$var$Hr,
    -1
], $b34bd66f0aa7fdf3$var$Fs = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Rs = [
    1,
    2,
    3,
    4,
    5
], $b34bd66f0aa7fdf3$var$Ms = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
    g() {
        return null != $b34bd66f0aa7fdf3$var$mn(this);
    }
    h() {
        return null != $b34bd66f0aa7fdf3$var$Pe($b34bd66f0aa7fdf3$var$cn(this, 2));
    }
}, $b34bd66f0aa7fdf3$var$Ps = [
    0,
    $b34bd66f0aa7fdf3$var$Zr,
    $b34bd66f0aa7fdf3$var$Yr,
    [
        0,
        $b34bd66f0aa7fdf3$var$jr,
        $b34bd66f0aa7fdf3$var$Nr,
        -1
    ],
    [
        0,
        $b34bd66f0aa7fdf3$var$Gr,
        $b34bd66f0aa7fdf3$var$Nr
    ]
], $b34bd66f0aa7fdf3$var$Cs = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
    g() {
        return $b34bd66f0aa7fdf3$var$Ee($b34bd66f0aa7fdf3$var$cn(this, 2)) ?? !1;
    }
}, $b34bd66f0aa7fdf3$var$Os = [
    0,
    $b34bd66f0aa7fdf3$var$Ps,
    $b34bd66f0aa7fdf3$var$Hr,
    [
        0,
        $b34bd66f0aa7fdf3$var$Rs,
        $b34bd66f0aa7fdf3$var$Jr,
        $b34bd66f0aa7fdf3$var$mi,
        $b34bd66f0aa7fdf3$var$Jr,
        $b34bd66f0aa7fdf3$var$di,
        $b34bd66f0aa7fdf3$var$Jr,
        $b34bd66f0aa7fdf3$var$ci,
        $b34bd66f0aa7fdf3$var$Jr,
        $b34bd66f0aa7fdf3$var$gi,
        $b34bd66f0aa7fdf3$var$Jr,
        $b34bd66f0aa7fdf3$var$fi
    ],
    $b34bd66f0aa7fdf3$var$ti
], $b34bd66f0aa7fdf3$var$Is = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Us = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Ir,
    -1,
    $b34bd66f0aa7fdf3$var$jr
], $b34bd66f0aa7fdf3$var$Ds = $b34bd66f0aa7fdf3$var$ri(502141897, $b34bd66f0aa7fdf3$var$Is);
$b34bd66f0aa7fdf3$var$_i[502141897] = $b34bd66f0aa7fdf3$var$Us;
var $b34bd66f0aa7fdf3$var$Ns = [
    0,
    $b34bd66f0aa7fdf3$var$Ps
];
$b34bd66f0aa7fdf3$var$_i[512499200] = $b34bd66f0aa7fdf3$var$Ns;
var $b34bd66f0aa7fdf3$var$Bs = [
    0,
    $b34bd66f0aa7fdf3$var$Ns
];
$b34bd66f0aa7fdf3$var$_i[515723506] = $b34bd66f0aa7fdf3$var$Bs;
var $b34bd66f0aa7fdf3$var$Gs = $b34bd66f0aa7fdf3$var$ii(class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, [
    0,
    [
        0,
        $b34bd66f0aa7fdf3$var$ti,
        -1,
        $b34bd66f0aa7fdf3$var$Ur,
        $b34bd66f0aa7fdf3$var$Qr
    ],
    $b34bd66f0aa7fdf3$var$ds
]), $b34bd66f0aa7fdf3$var$js = [
    0,
    $b34bd66f0aa7fdf3$var$Os
];
$b34bd66f0aa7fdf3$var$_i[508981768] = $b34bd66f0aa7fdf3$var$js;
var $b34bd66f0aa7fdf3$var$Vs = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Xs = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Ir,
    $b34bd66f0aa7fdf3$var$js,
    $b34bd66f0aa7fdf3$var$Hr
], $b34bd66f0aa7fdf3$var$Hs = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Ws = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Us,
    $b34bd66f0aa7fdf3$var$Xs,
    $b34bd66f0aa7fdf3$var$Ir,
    $b34bd66f0aa7fdf3$var$Bs
];
$b34bd66f0aa7fdf3$var$_i[508968149] = $b34bd66f0aa7fdf3$var$Xs;
var $b34bd66f0aa7fdf3$var$zs = $b34bd66f0aa7fdf3$var$ri(508968150, $b34bd66f0aa7fdf3$var$Hs);
$b34bd66f0aa7fdf3$var$_i[508968150] = $b34bd66f0aa7fdf3$var$Ws;
var $b34bd66f0aa7fdf3$var$Ks = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Ys = $b34bd66f0aa7fdf3$var$ri(513916220, $b34bd66f0aa7fdf3$var$Ks);
$b34bd66f0aa7fdf3$var$_i[513916220] = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Ws,
    $b34bd66f0aa7fdf3$var$jr
];
var $b34bd66f0aa7fdf3$var$$s = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
    h() {
        return $b34bd66f0aa7fdf3$var$Rn(this, $b34bd66f0aa7fdf3$var$ks, 2);
    }
    g() {
        $b34bd66f0aa7fdf3$var$dn(this, 2);
    }
}, $b34bd66f0aa7fdf3$var$qs = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$xs
];
$b34bd66f0aa7fdf3$var$_i[478825465] = $b34bd66f0aa7fdf3$var$qs;
var $b34bd66f0aa7fdf3$var$Js = [
    0,
    $b34bd66f0aa7fdf3$var$Os
];
$b34bd66f0aa7fdf3$var$_i[478825422] = $b34bd66f0aa7fdf3$var$Js;
var $b34bd66f0aa7fdf3$var$Zs = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Qs = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Js,
    $b34bd66f0aa7fdf3$var$qs,
    -1
], $b34bd66f0aa7fdf3$var$to = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$eo = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Ir,
    $b34bd66f0aa7fdf3$var$jr
], $b34bd66f0aa7fdf3$var$no = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$ro = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Ir
], $b34bd66f0aa7fdf3$var$io = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$so = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$eo,
    $b34bd66f0aa7fdf3$var$ro,
    $b34bd66f0aa7fdf3$var$Ir
], $b34bd66f0aa7fdf3$var$oo = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$ao = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$so,
    $b34bd66f0aa7fdf3$var$Qs
];
$b34bd66f0aa7fdf3$var$_i[463370452] = $b34bd66f0aa7fdf3$var$Qs, $b34bd66f0aa7fdf3$var$_i[464864288] = $b34bd66f0aa7fdf3$var$eo, $b34bd66f0aa7fdf3$var$_i[474472470] = $b34bd66f0aa7fdf3$var$ro;
var $b34bd66f0aa7fdf3$var$ho = $b34bd66f0aa7fdf3$var$ri(462713202, $b34bd66f0aa7fdf3$var$io);
$b34bd66f0aa7fdf3$var$_i[462713202] = $b34bd66f0aa7fdf3$var$so;
var $b34bd66f0aa7fdf3$var$co = $b34bd66f0aa7fdf3$var$ri(479097054, $b34bd66f0aa7fdf3$var$oo);
$b34bd66f0aa7fdf3$var$_i[479097054] = $b34bd66f0aa7fdf3$var$ao;
var $b34bd66f0aa7fdf3$var$uo = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$lo = [
    0,
    $b34bd66f0aa7fdf3$var$Os
], $b34bd66f0aa7fdf3$var$fo = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$po = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Ir,
    -1,
    $b34bd66f0aa7fdf3$var$jr
];
$b34bd66f0aa7fdf3$var$_i[514774813] = $b34bd66f0aa7fdf3$var$po;
var $b34bd66f0aa7fdf3$var$go = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$mo = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Ir,
    $b34bd66f0aa7fdf3$var$Hr
];
$b34bd66f0aa7fdf3$var$_i[518928384] = $b34bd66f0aa7fdf3$var$mo;
var $b34bd66f0aa7fdf3$var$yo = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(){
        super();
    }
};
$b34bd66f0aa7fdf3$var$yo.prototype.g = $b34bd66f0aa7fdf3$var$si([
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$ro,
    $b34bd66f0aa7fdf3$var$lo,
    $b34bd66f0aa7fdf3$var$Us,
    $b34bd66f0aa7fdf3$var$Xs,
    $b34bd66f0aa7fdf3$var$po,
    $b34bd66f0aa7fdf3$var$mo
]);
var $b34bd66f0aa7fdf3$var$_o = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$vo = $b34bd66f0aa7fdf3$var$ri(456383383, $b34bd66f0aa7fdf3$var$_o);
$b34bd66f0aa7fdf3$var$_i[456383383] = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$xs
];
var $b34bd66f0aa7fdf3$var$Eo = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$wo = $b34bd66f0aa7fdf3$var$ri(476348187, $b34bd66f0aa7fdf3$var$Eo);
$b34bd66f0aa7fdf3$var$_i[476348187] = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Ls
];
var $b34bd66f0aa7fdf3$var$To = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Ao = [
    0,
    $b34bd66f0aa7fdf3$var$ti,
    -1
], $b34bd66f0aa7fdf3$var$bo = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$bo.B = [
    3
];
var $b34bd66f0aa7fdf3$var$ko = $b34bd66f0aa7fdf3$var$ri(458105876, class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
    g() {
        var t = this.s;
        const e = $b34bd66f0aa7fdf3$var$qt(t);
        var n = 2 & e;
        return t = function(t, e, n) {
            var r = $b34bd66f0aa7fdf3$var$bo;
            const i = 2 & e;
            let s = !1;
            if (null == n) {
                if (i) return $b34bd66f0aa7fdf3$var$Ze();
                n = [];
            } else if (n.constructor === $b34bd66f0aa7fdf3$var$Ke) {
                if (0 == (2 & n.N) || i) return n;
                n = n.Y();
            } else Array.isArray(n) ? s = !!(2 & $b34bd66f0aa7fdf3$var$$t(n)) : n = [];
            if (i) {
                if (!n.length) return $b34bd66f0aa7fdf3$var$Ze();
                s || (s = !0, $b34bd66f0aa7fdf3$var$Zt(n));
            } else s && (s = !1, n = $b34bd66f0aa7fdf3$var$wn(n));
            return s || (64 & $b34bd66f0aa7fdf3$var$$t(n) ? $b34bd66f0aa7fdf3$var$Kt(n, 32) : 32 & e && $b34bd66f0aa7fdf3$var$zt(n, 32)), $b34bd66f0aa7fdf3$var$fn(t, e, 2, r = new $b34bd66f0aa7fdf3$var$Ke(n, r, $b34bd66f0aa7fdf3$var$Oe, void 0), !1), r;
        }(t, e, $b34bd66f0aa7fdf3$var$ln(t, e, 2)), null == t || !n && $b34bd66f0aa7fdf3$var$bo && (t.ta = !0), n = t;
    }
});
$b34bd66f0aa7fdf3$var$_i[458105876] = [
    0,
    $b34bd66f0aa7fdf3$var$Ao,
    $b34bd66f0aa7fdf3$var$kr,
    [
        !0,
        $b34bd66f0aa7fdf3$var$Nr,
        [
            0,
            $b34bd66f0aa7fdf3$var$Yr,
            -1,
            $b34bd66f0aa7fdf3$var$zr
        ]
    ]
];
var $b34bd66f0aa7fdf3$var$xo = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$So = $b34bd66f0aa7fdf3$var$ri(458105758, $b34bd66f0aa7fdf3$var$xo);
$b34bd66f0aa7fdf3$var$_i[458105758] = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$Ao
];
var $b34bd66f0aa7fdf3$var$Lo = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
};
$b34bd66f0aa7fdf3$var$Lo.B = [
    5,
    6
];
var $b34bd66f0aa7fdf3$var$Fo = $b34bd66f0aa7fdf3$var$ri(443442058, $b34bd66f0aa7fdf3$var$Lo);
$b34bd66f0aa7fdf3$var$_i[443442058] = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$jr,
    $b34bd66f0aa7fdf3$var$Ir,
    $b34bd66f0aa7fdf3$var$zr,
    -1
];
var $b34bd66f0aa7fdf3$var$Ro = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Mo = $b34bd66f0aa7fdf3$var$ri(516587230, $b34bd66f0aa7fdf3$var$Ro);
function $b34bd66f0aa7fdf3$var$Po(t, e) {
    return e = e ? e.clone() : new $b34bd66f0aa7fdf3$var$ks, void 0 !== t.displayNamesLocale ? $b34bd66f0aa7fdf3$var$dn(e, 1, $b34bd66f0aa7fdf3$var$Me(t.displayNamesLocale)) : void 0 === t.displayNamesLocale && $b34bd66f0aa7fdf3$var$dn(e, 1), void 0 !== t.maxResults ? $b34bd66f0aa7fdf3$var$Xn(e, 2, t.maxResults) : "maxResults" in t && $b34bd66f0aa7fdf3$var$dn(e, 2), void 0 !== t.scoreThreshold ? $b34bd66f0aa7fdf3$var$Hn(e, 3, t.scoreThreshold) : "scoreThreshold" in t && $b34bd66f0aa7fdf3$var$dn(e, 3), void 0 !== t.categoryAllowlist ? $b34bd66f0aa7fdf3$var$Tn(e, 4, t.categoryAllowlist) : "categoryAllowlist" in t && $b34bd66f0aa7fdf3$var$dn(e, 4), void 0 !== t.categoryDenylist ? $b34bd66f0aa7fdf3$var$Tn(e, 5, t.categoryDenylist) : "categoryDenylist" in t && $b34bd66f0aa7fdf3$var$dn(e, 5), e;
}
function $b34bd66f0aa7fdf3$var$Co(t, e = -1, n = "") {
    return {
        categories: t.map((t)=>({
                index: $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$Nn(t, 1), 0) ?? -1,
                score: $b34bd66f0aa7fdf3$var$Gn(t, 2) ?? 0,
                categoryName: $b34bd66f0aa7fdf3$var$jn(t, 3) ?? "",
                displayName: $b34bd66f0aa7fdf3$var$jn(t, 4) ?? ""
            })),
        headIndex: e,
        headName: n
    };
}
function $b34bd66f0aa7fdf3$var$Oo(t) {
    var e = $b34bd66f0aa7fdf3$var$yn(t, 3, $b34bd66f0aa7fdf3$var$ve), n = $b34bd66f0aa7fdf3$var$yn(t, 2, $b34bd66f0aa7fdf3$var$Ae), r = $b34bd66f0aa7fdf3$var$yn(t, 1, $b34bd66f0aa7fdf3$var$Pe), i = $b34bd66f0aa7fdf3$var$yn(t, 9, $b34bd66f0aa7fdf3$var$Pe);
    const s = {
        categories: [],
        keypoints: []
    };
    for(let t = 0; t < e.length; t++)s.categories.push({
        score: e[t],
        index: n[t] ?? -1,
        categoryName: r[t] ?? "",
        displayName: i[t] ?? ""
    });
    if ((e = $b34bd66f0aa7fdf3$var$Rn(t, $b34bd66f0aa7fdf3$var$Qi, 4)?.h()) && (s.boundingBox = {
        originX: $b34bd66f0aa7fdf3$var$Nn(e, 1) ?? 0,
        originY: $b34bd66f0aa7fdf3$var$Nn(e, 2) ?? 0,
        width: $b34bd66f0aa7fdf3$var$Nn(e, 3) ?? 0,
        height: $b34bd66f0aa7fdf3$var$Nn(e, 4) ?? 0,
        angle: 0
    }), $b34bd66f0aa7fdf3$var$Rn(t, $b34bd66f0aa7fdf3$var$Qi, 4)?.g().length) for (const e of $b34bd66f0aa7fdf3$var$Rn(t, $b34bd66f0aa7fdf3$var$Qi, 4).g())s.keypoints.push({
        x: $b34bd66f0aa7fdf3$var$gn(e, 1) ?? 0,
        y: $b34bd66f0aa7fdf3$var$gn(e, 2) ?? 0,
        score: $b34bd66f0aa7fdf3$var$gn(e, 4) ?? 0,
        label: $b34bd66f0aa7fdf3$var$Pe($b34bd66f0aa7fdf3$var$cn(e, 3)) ?? ""
    });
    return s;
}
function $b34bd66f0aa7fdf3$var$Io(t) {
    const e = [];
    for (const n of $b34bd66f0aa7fdf3$var$Pn(t, $b34bd66f0aa7fdf3$var$as, 1))e.push({
        x: $b34bd66f0aa7fdf3$var$Gn(n, 1) ?? 0,
        y: $b34bd66f0aa7fdf3$var$Gn(n, 2) ?? 0,
        z: $b34bd66f0aa7fdf3$var$Gn(n, 3) ?? 0,
        visibility: $b34bd66f0aa7fdf3$var$Gn(n, 4) ?? 0
    });
    return e;
}
function $b34bd66f0aa7fdf3$var$Uo(t) {
    const e = [];
    for (const n of $b34bd66f0aa7fdf3$var$Pn(t, $b34bd66f0aa7fdf3$var$rs, 1))e.push({
        x: $b34bd66f0aa7fdf3$var$Gn(n, 1) ?? 0,
        y: $b34bd66f0aa7fdf3$var$Gn(n, 2) ?? 0,
        z: $b34bd66f0aa7fdf3$var$Gn(n, 3) ?? 0,
        visibility: $b34bd66f0aa7fdf3$var$Gn(n, 4) ?? 0
    });
    return e;
}
function $b34bd66f0aa7fdf3$var$Do(t) {
    return Array.from(t, (t)=>127 < t ? t - 256 : t);
}
function $b34bd66f0aa7fdf3$var$No(t, e) {
    if (t.length !== e.length) throw Error(`Cannot compute cosine similarity between embeddings of different sizes (${t.length} vs. ${e.length}).`);
    let n = 0, r = 0, i = 0;
    for(let s = 0; s < t.length; s++)n += t[s] * e[s], r += t[s] * t[s], i += e[s] * e[s];
    if (0 >= r || 0 >= i) throw Error("Cannot compute cosine similarity on embedding with 0 norm.");
    return n / Math.sqrt(r * i);
}
let $b34bd66f0aa7fdf3$var$Bo;
$b34bd66f0aa7fdf3$var$_i[516587230] = [
    0,
    $b34bd66f0aa7fdf3$var$Os,
    $b34bd66f0aa7fdf3$var$po,
    $b34bd66f0aa7fdf3$var$mo,
    $b34bd66f0aa7fdf3$var$Ir
];
const $b34bd66f0aa7fdf3$var$Go = new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    5,
    1,
    96,
    0,
    1,
    123,
    3,
    2,
    1,
    0,
    10,
    10,
    1,
    8,
    0,
    65,
    0,
    253,
    15,
    253,
    98,
    11
]);
async function $b34bd66f0aa7fdf3$var$jo() {
    if (void 0 === $b34bd66f0aa7fdf3$var$Bo) try {
        await WebAssembly.instantiate($b34bd66f0aa7fdf3$var$Go), $b34bd66f0aa7fdf3$var$Bo = !0;
    } catch  {
        $b34bd66f0aa7fdf3$var$Bo = !1;
    }
    return $b34bd66f0aa7fdf3$var$Bo;
}
async function $b34bd66f0aa7fdf3$var$Vo(t, e = "") {
    const n = await $b34bd66f0aa7fdf3$var$jo() ? "wasm_internal" : "wasm_nosimd_internal";
    return {
        wasmLoaderPath: `${e}/${t}_${n}.js`,
        wasmBinaryPath: `${e}/${t}_${n}.wasm`
    };
}
var $b34bd66f0aa7fdf3$export$f97946dfe503e8d3 = class {
};
function $b34bd66f0aa7fdf3$var$Ho() {
    var t = navigator;
    return "undefined" != typeof OffscreenCanvas && (!function(t = navigator) {
        return (t = t.userAgent).includes("Safari") && !t.includes("Chrome");
    }(t) || !!((t = t.userAgent.match(/Version\/([\d]+).*Safari/)) && 1 <= t.length && 17 <= Number(t[1])));
}
async function $b34bd66f0aa7fdf3$var$Wo(t) {
    if ("function" != typeof importScripts) {
        const e = document.createElement("script");
        return e.src = t.toString(), e.crossOrigin = "anonymous", new Promise((t, n)=>{
            e.addEventListener("load", ()=>{
                t();
            }, !1), e.addEventListener("error", (t)=>{
                n(t);
            }, !1), document.body.appendChild(e);
        });
    }
    importScripts(t.toString());
}
function $b34bd66f0aa7fdf3$var$zo(t) {
    return void 0 !== t.videoWidth ? [
        t.videoWidth,
        t.videoHeight
    ] : void 0 !== t.naturalWidth ? [
        t.naturalWidth,
        t.naturalHeight
    ] : void 0 !== t.displayWidth ? [
        t.displayWidth,
        t.displayHeight
    ] : [
        t.width,
        t.height
    ];
}
function $b34bd66f0aa7fdf3$var$Ko(t, e, n) {
    t.m || console.error("No wasm multistream support detected: ensure dependency inclusion of :gl_graph_runner_internal_multi_input target"), n(e = t.i.stringToNewUTF8(e)), t.i._free(e);
}
function $b34bd66f0aa7fdf3$var$Yo(t, e, n) {
    if (!t.i.canvas) throw Error("No OpenGL canvas configured.");
    if (n ? t.i._bindTextureToStream(n) : t.i._bindTextureToCanvas(), !(n = t.i.canvas.getContext("webgl2") || t.i.canvas.getContext("webgl"))) throw Error("Failed to obtain WebGL context from the provided canvas. `getContext()` should only be invoked with `webgl` or `webgl2`.");
    t.i.gpuOriginForWebTexturesIsBottomLeft && n.pixelStorei(n.UNPACK_FLIP_Y_WEBGL, !0), n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, n.RGBA, n.UNSIGNED_BYTE, e), t.i.gpuOriginForWebTexturesIsBottomLeft && n.pixelStorei(n.UNPACK_FLIP_Y_WEBGL, !1);
    const [r, i] = $b34bd66f0aa7fdf3$var$zo(e);
    return !t.l || r === t.i.canvas.width && i === t.i.canvas.height || (t.i.canvas.width = r, t.i.canvas.height = i), [
        r,
        i
    ];
}
function $b34bd66f0aa7fdf3$var$$o(t, e, n) {
    t.m || console.error("No wasm multistream support detected: ensure dependency inclusion of :gl_graph_runner_internal_multi_input target");
    const r = new Uint32Array(e.length);
    for(let n = 0; n < e.length; n++)r[n] = t.i.stringToNewUTF8(e[n]);
    e = t.i._malloc(4 * r.length), t.i.HEAPU32.set(r, e >> 2), n(e);
    for (const e of r)t.i._free(e);
    t.i._free(e);
}
function $b34bd66f0aa7fdf3$var$qo(t, e, n) {
    t.i.simpleListeners = t.i.simpleListeners || {}, t.i.simpleListeners[e] = n;
}
function $b34bd66f0aa7fdf3$var$Jo(t, e, n) {
    let r = [];
    t.i.simpleListeners = t.i.simpleListeners || {}, t.i.simpleListeners[e] = (t, e, i)=>{
        e ? (n(r, i), r = []) : r.push(t);
    };
}
$b34bd66f0aa7fdf3$export$f97946dfe503e8d3.forVisionTasks = function(t) {
    return $b34bd66f0aa7fdf3$var$Vo("vision", t);
}, $b34bd66f0aa7fdf3$export$f97946dfe503e8d3.forTextTasks = function(t) {
    return $b34bd66f0aa7fdf3$var$Vo("text", t);
}, $b34bd66f0aa7fdf3$export$f97946dfe503e8d3.forGenAiExperimentalTasks = function(t) {
    return $b34bd66f0aa7fdf3$var$Vo("genai_experimental", t);
}, $b34bd66f0aa7fdf3$export$f97946dfe503e8d3.forGenAiTasks = function(t) {
    return $b34bd66f0aa7fdf3$var$Vo("genai", t);
}, $b34bd66f0aa7fdf3$export$f97946dfe503e8d3.forAudioTasks = function(t) {
    return $b34bd66f0aa7fdf3$var$Vo("audio", t);
}, $b34bd66f0aa7fdf3$export$f97946dfe503e8d3.isSimdSupported = function() {
    return $b34bd66f0aa7fdf3$var$jo();
};
async function $b34bd66f0aa7fdf3$var$Zo(t, e, n, r) {
    return t = await (async (t, e, n, r, i)=>{
        if (e && await $b34bd66f0aa7fdf3$var$Wo(e), !self.ModuleFactory) throw Error("ModuleFactory not set.");
        if (n && (await $b34bd66f0aa7fdf3$var$Wo(n), !self.ModuleFactory)) throw Error("ModuleFactory not set.");
        return self.Module && i && ((e = self.Module).locateFile = i.locateFile, i.mainScriptUrlOrBlob && (e.mainScriptUrlOrBlob = i.mainScriptUrlOrBlob)), i = await self.ModuleFactory(self.Module || i), self.ModuleFactory = self.Module = void 0, new t(i, r);
    })(t, n.wasmLoaderPath, n.assetLoaderPath, e, {
        locateFile: (t)=>t.endsWith(".wasm") ? n.wasmBinaryPath.toString() : n.assetBinaryPath && t.endsWith(".data") ? n.assetBinaryPath.toString() : t
    }), await t.o(r), t;
}
function $b34bd66f0aa7fdf3$var$Qo(t, e) {
    const n = $b34bd66f0aa7fdf3$var$Rn(t.baseOptions, $b34bd66f0aa7fdf3$var$Ms, 1) || new $b34bd66f0aa7fdf3$var$Ms;
    "string" == typeof e ? ($b34bd66f0aa7fdf3$var$dn(n, 2, $b34bd66f0aa7fdf3$var$Me(e)), $b34bd66f0aa7fdf3$var$dn(n, 1)) : e instanceof Uint8Array && ($b34bd66f0aa7fdf3$var$dn(n, 1, $b34bd66f0aa7fdf3$var$ae(e, !1, !1)), $b34bd66f0aa7fdf3$var$dn(n, 2)), $b34bd66f0aa7fdf3$var$Cn(t.baseOptions, 0, 1, n);
}
function $b34bd66f0aa7fdf3$var$ta(t) {
    try {
        const e = t.K.length;
        if (1 === e) throw Error(t.K[0].message);
        if (1 < e) throw Error("Encountered multiple errors: " + t.K.map((t)=>t.message).join(", "));
    } finally{
        t.K = [];
    }
}
function $b34bd66f0aa7fdf3$var$ea(t, e) {
    t.J = Math.max(t.J, e);
}
function $b34bd66f0aa7fdf3$var$na(t, e) {
    t.C = new $b34bd66f0aa7fdf3$var$Li, $b34bd66f0aa7fdf3$var$ki(t.C, "PassThroughCalculator"), $b34bd66f0aa7fdf3$var$xi(t.C, "free_memory"), $b34bd66f0aa7fdf3$var$Si(t.C, "free_memory_unused_out"), $b34bd66f0aa7fdf3$var$Ii(e, "free_memory"), $b34bd66f0aa7fdf3$var$Oi(e, t.C);
}
function $b34bd66f0aa7fdf3$var$ra(t, e) {
    $b34bd66f0aa7fdf3$var$xi(t.C, e), $b34bd66f0aa7fdf3$var$Si(t.C, e + "_unused_out");
}
function $b34bd66f0aa7fdf3$var$ia(t) {
    t.g.addBoolToStream(!0, "free_memory", t.J);
}
var $b34bd66f0aa7fdf3$var$sa = class {
    constructor(t){
        this.g = t, this.K = [], this.J = 0, this.g.setAutoRenderToScreen(!1);
    }
    l(t, e = !0) {
        if (e) {
            const e = t.baseOptions || {};
            if (t.baseOptions?.modelAssetBuffer && t.baseOptions?.modelAssetPath) throw Error("Cannot set both baseOptions.modelAssetPath and baseOptions.modelAssetBuffer");
            if (!($b34bd66f0aa7fdf3$var$Rn(this.baseOptions, $b34bd66f0aa7fdf3$var$Ms, 1)?.g() || $b34bd66f0aa7fdf3$var$Rn(this.baseOptions, $b34bd66f0aa7fdf3$var$Ms, 1)?.h() || t.baseOptions?.modelAssetBuffer || t.baseOptions?.modelAssetPath)) throw Error("Either baseOptions.modelAssetPath or baseOptions.modelAssetBuffer must be set");
            if (function(t, e) {
                let n = $b34bd66f0aa7fdf3$var$Rn(t.baseOptions, $b34bd66f0aa7fdf3$var$Fs, 3);
                if (!n) {
                    var r = n = new $b34bd66f0aa7fdf3$var$Fs, i = new $b34bd66f0aa7fdf3$var$pi;
                    $b34bd66f0aa7fdf3$var$On(r, 4, $b34bd66f0aa7fdf3$var$Rs, i);
                }
                "delegate" in e && ("GPU" === e.delegate ? (e = n, r = new $b34bd66f0aa7fdf3$var$li, $b34bd66f0aa7fdf3$var$On(e, 2, $b34bd66f0aa7fdf3$var$Rs, r)) : (e = n, r = new $b34bd66f0aa7fdf3$var$pi, $b34bd66f0aa7fdf3$var$On(e, 4, $b34bd66f0aa7fdf3$var$Rs, r))), $b34bd66f0aa7fdf3$var$Cn(t.baseOptions, 0, 3, n);
            }(this, e), e.modelAssetPath) return fetch(e.modelAssetPath.toString()).then((t)=>{
                if (t.ok) return t.arrayBuffer();
                throw Error(`Failed to fetch model: ${e.modelAssetPath} (${t.status})`);
            }).then((t)=>{
                try {
                    this.g.i.FS_unlink("/model.dat");
                } catch  {}
                this.g.i.FS_createDataFile("/", "model.dat", new Uint8Array(t), !0, !1, !1), $b34bd66f0aa7fdf3$var$Qo(this, "/model.dat"), this.m(), this.L();
            });
            if (e.modelAssetBuffer instanceof Uint8Array) $b34bd66f0aa7fdf3$var$Qo(this, e.modelAssetBuffer);
            else if (e.modelAssetBuffer) return (async function(t) {
                const e = [];
                for(var n = 0;;){
                    const { done: r, value: i } = await t.read();
                    if (r) break;
                    e.push(i), n += i.length;
                }
                if (0 === e.length) return new Uint8Array(0);
                if (1 === e.length) return e[0];
                t = new Uint8Array(n), n = 0;
                for (const r of e)t.set(r, n), n += r.length;
                return t;
            })(e.modelAssetBuffer).then((t)=>{
                $b34bd66f0aa7fdf3$var$Qo(this, t), this.m(), this.L();
            });
        }
        return this.m(), this.L(), Promise.resolve();
    }
    L() {}
    fa() {
        let t;
        if (this.g.fa((e)=>{
            t = $b34bd66f0aa7fdf3$var$Bi(e);
        }), !t) throw Error("Failed to retrieve CalculatorGraphConfig");
        return t;
    }
    setGraph(t, e) {
        this.g.attachErrorListener((t, e)=>{
            this.K.push(Error(e));
        }), this.g.Ma(), this.g.setGraph(t, e), this.C = void 0, $b34bd66f0aa7fdf3$var$ta(this);
    }
    finishProcessing() {
        this.g.finishProcessing(), $b34bd66f0aa7fdf3$var$ta(this);
    }
    close() {
        this.C = void 0, this.g.closeGraph();
    }
};
function $b34bd66f0aa7fdf3$var$oa(t, e) {
    if (!t) throw Error(`Unable to obtain required WebGL resource: ${e}`);
    return t;
}
$b34bd66f0aa7fdf3$var$sa.prototype.close = $b34bd66f0aa7fdf3$var$sa.prototype.close, function(e, n) {
    e = e.split(".");
    var r, i = $b34bd66f0aa7fdf3$var$t;
    e[0] in i || void 0 === i.execScript || i.execScript("var " + e[0]);
    for(; e.length && (r = e.shift());)e.length || void 0 === n ? i = i[r] && i[r] !== Object.prototype[r] ? i[r] : i[r] = {} : i[r] = n;
}("TaskRunner", $b34bd66f0aa7fdf3$var$sa);
class $b34bd66f0aa7fdf3$var$aa {
    constructor(t, e, n, r){
        this.g = t, this.h = e, this.m = n, this.l = r;
    }
    bind() {
        this.g.bindVertexArray(this.h);
    }
    close() {
        this.g.deleteVertexArray(this.h), this.g.deleteBuffer(this.m), this.g.deleteBuffer(this.l);
    }
}
function $b34bd66f0aa7fdf3$var$ha(t, e, n) {
    const r = t.g;
    if (n = $b34bd66f0aa7fdf3$var$oa(r.createShader(n), "Failed to create WebGL shader"), r.shaderSource(n, e), r.compileShader(n), !r.getShaderParameter(n, r.COMPILE_STATUS)) throw Error(`Could not compile WebGL shader: ${r.getShaderInfoLog(n)}`);
    return r.attachShader(t.h, n), n;
}
function $b34bd66f0aa7fdf3$var$ca(t, e) {
    const n = t.g, r = $b34bd66f0aa7fdf3$var$oa(n.createVertexArray(), "Failed to create vertex array");
    n.bindVertexArray(r);
    const i = $b34bd66f0aa7fdf3$var$oa(n.createBuffer(), "Failed to create buffer");
    n.bindBuffer(n.ARRAY_BUFFER, i), n.enableVertexAttribArray(t.K), n.vertexAttribPointer(t.K, 2, n.FLOAT, !1, 0, 0), n.bufferData(n.ARRAY_BUFFER, new Float32Array([
        -1,
        -1,
        -1,
        1,
        1,
        1,
        1,
        -1
    ]), n.STATIC_DRAW);
    const s = $b34bd66f0aa7fdf3$var$oa(n.createBuffer(), "Failed to create buffer");
    return n.bindBuffer(n.ARRAY_BUFFER, s), n.enableVertexAttribArray(t.J), n.vertexAttribPointer(t.J, 2, n.FLOAT, !1, 0, 0), n.bufferData(n.ARRAY_BUFFER, new Float32Array(e ? [
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1
    ] : [
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0
    ]), n.STATIC_DRAW), n.bindBuffer(n.ARRAY_BUFFER, null), n.bindVertexArray(null), new $b34bd66f0aa7fdf3$var$aa(n, r, i, s);
}
function $b34bd66f0aa7fdf3$var$ua(t, e) {
    if (t.g) {
        if (e !== t.g) throw Error("Cannot change GL context once initialized");
    } else t.g = e;
}
function $b34bd66f0aa7fdf3$var$la(t, e, n, r) {
    return $b34bd66f0aa7fdf3$var$ua(t, e), t.h || (t.m(), t.D()), n ? (t.v || (t.v = $b34bd66f0aa7fdf3$var$ca(t, !0)), n = t.v) : (t.A || (t.A = $b34bd66f0aa7fdf3$var$ca(t, !1)), n = t.A), e.useProgram(t.h), n.bind(), t.l(), t = r(), n.g.bindVertexArray(null), t;
}
function $b34bd66f0aa7fdf3$var$da(t, e, n) {
    return $b34bd66f0aa7fdf3$var$ua(t, e), t = $b34bd66f0aa7fdf3$var$oa(e.createTexture(), "Failed to create texture"), e.bindTexture(e.TEXTURE_2D, t), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, n ?? e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, n ?? e.LINEAR), e.bindTexture(e.TEXTURE_2D, null), t;
}
function $b34bd66f0aa7fdf3$var$fa(t, e, n) {
    $b34bd66f0aa7fdf3$var$ua(t, e), t.u || (t.u = $b34bd66f0aa7fdf3$var$oa(e.createFramebuffer(), "Failed to create framebuffe.")), e.bindFramebuffer(e.FRAMEBUFFER, t.u), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, n, 0);
}
function $b34bd66f0aa7fdf3$var$pa(t) {
    t.g?.bindFramebuffer(t.g.FRAMEBUFFER, null);
}
var $b34bd66f0aa7fdf3$var$ga = class {
    H() {
        return "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D inputTexture;\n  void main() {\n    gl_FragColor = texture2D(inputTexture, vTex);\n  }\n ";
    }
    m() {
        const t = this.g;
        if (this.h = $b34bd66f0aa7fdf3$var$oa(t.createProgram(), "Failed to create WebGL program"), this.ba = $b34bd66f0aa7fdf3$var$ha(this, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", t.VERTEX_SHADER), this.aa = $b34bd66f0aa7fdf3$var$ha(this, this.H(), t.FRAGMENT_SHADER), t.linkProgram(this.h), !t.getProgramParameter(this.h, t.LINK_STATUS)) throw Error(`Error during program linking: ${t.getProgramInfoLog(this.h)}`);
        this.K = t.getAttribLocation(this.h, "aVertex"), this.J = t.getAttribLocation(this.h, "aTex");
    }
    D() {}
    l() {}
    close() {
        if (this.h) {
            const t = this.g;
            t.deleteProgram(this.h), t.deleteShader(this.ba), t.deleteShader(this.aa);
        }
        this.u && this.g.deleteFramebuffer(this.u), this.A && this.A.close(), this.v && this.v.close();
    }
};
var $b34bd66f0aa7fdf3$var$ma = class extends $b34bd66f0aa7fdf3$var$ga {
    H() {
        return "\n  precision mediump float;\n  uniform sampler2D backgroundTexture;\n  uniform sampler2D maskTexture;\n  uniform sampler2D colorMappingTexture;\n  varying vec2 vTex;\n  void main() {\n    vec4 backgroundColor = texture2D(backgroundTexture, vTex);\n    float category = texture2D(maskTexture, vTex).r;\n    vec4 categoryColor = texture2D(colorMappingTexture, vec2(category, 0.0));\n    gl_FragColor = mix(backgroundColor, categoryColor, categoryColor.a);\n  }\n ";
    }
    D() {
        const t = this.g;
        t.activeTexture(t.TEXTURE1), this.C = $b34bd66f0aa7fdf3$var$da(this, t, t.LINEAR), t.activeTexture(t.TEXTURE2), this.j = $b34bd66f0aa7fdf3$var$da(this, t, t.NEAREST);
    }
    m() {
        super.m();
        const t = this.g;
        this.M = $b34bd66f0aa7fdf3$var$oa(t.getUniformLocation(this.h, "backgroundTexture"), "Uniform location"), this.V = $b34bd66f0aa7fdf3$var$oa(t.getUniformLocation(this.h, "colorMappingTexture"), "Uniform location"), this.L = $b34bd66f0aa7fdf3$var$oa(t.getUniformLocation(this.h, "maskTexture"), "Uniform location");
    }
    l() {
        super.l();
        const t = this.g;
        t.uniform1i(this.L, 0), t.uniform1i(this.M, 1), t.uniform1i(this.V, 2);
    }
    close() {
        this.C && this.g.deleteTexture(this.C), this.j && this.g.deleteTexture(this.j), super.close();
    }
}, $b34bd66f0aa7fdf3$var$ya = class extends $b34bd66f0aa7fdf3$var$ga {
    H() {
        return "\n  precision mediump float;\n  uniform sampler2D maskTexture;\n  uniform sampler2D defaultTexture;\n  uniform sampler2D overlayTexture;\n  varying vec2 vTex;\n  void main() {\n    float confidence = texture2D(maskTexture, vTex).r;\n    vec4 defaultColor = texture2D(defaultTexture, vTex);\n    vec4 overlayColor = texture2D(overlayTexture, vTex);\n    // Apply the alpha from the overlay and merge in the default color\n    overlayColor = mix(defaultColor, overlayColor, overlayColor.a);\n    gl_FragColor = mix(defaultColor, overlayColor, confidence);\n  }\n ";
    }
    D() {
        const t = this.g;
        t.activeTexture(t.TEXTURE1), this.j = $b34bd66f0aa7fdf3$var$da(this, t), t.activeTexture(t.TEXTURE2), this.C = $b34bd66f0aa7fdf3$var$da(this, t);
    }
    m() {
        super.m();
        const t = this.g;
        this.L = $b34bd66f0aa7fdf3$var$oa(t.getUniformLocation(this.h, "defaultTexture"), "Uniform location"), this.M = $b34bd66f0aa7fdf3$var$oa(t.getUniformLocation(this.h, "overlayTexture"), "Uniform location"), this.I = $b34bd66f0aa7fdf3$var$oa(t.getUniformLocation(this.h, "maskTexture"), "Uniform location");
    }
    l() {
        super.l();
        const t = this.g;
        t.uniform1i(this.I, 0), t.uniform1i(this.L, 1), t.uniform1i(this.M, 2);
    }
    close() {
        this.j && this.g.deleteTexture(this.j), this.C && this.g.deleteTexture(this.C), super.close();
    }
};
function $b34bd66f0aa7fdf3$var$_a(t, e) {
    switch(e){
        case 0:
            return t.g.find((t)=>t instanceof Uint8Array);
        case 1:
            return t.g.find((t)=>t instanceof Float32Array);
        case 2:
            return t.g.find((t)=>"undefined" != typeof WebGLTexture && t instanceof WebGLTexture);
        default:
            throw Error(`Type is not supported: ${e}`);
    }
}
function $b34bd66f0aa7fdf3$var$va(t) {
    var e = $b34bd66f0aa7fdf3$var$_a(t, 1);
    if (!e) {
        if (e = $b34bd66f0aa7fdf3$var$_a(t, 0)) e = new Float32Array(e).map((t)=>t / 255);
        else {
            e = new Float32Array(t.width * t.height);
            const r = $b34bd66f0aa7fdf3$var$wa(t);
            var n = $b34bd66f0aa7fdf3$var$Aa(t);
            if ($b34bd66f0aa7fdf3$var$fa(n, r, $b34bd66f0aa7fdf3$var$Ea(t)), "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in self.document) {
                n = new Float32Array(t.width * t.height * 4), r.readPixels(0, 0, t.width, t.height, r.RGBA, r.FLOAT, n);
                for(let t = 0, r = 0; t < e.length; ++t, r += 4)e[t] = n[r];
            } else r.readPixels(0, 0, t.width, t.height, r.RED, r.FLOAT, e);
        }
        t.g.push(e);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$Ea(t) {
    let e = $b34bd66f0aa7fdf3$var$_a(t, 2);
    if (!e) {
        const n = $b34bd66f0aa7fdf3$var$wa(t);
        e = $b34bd66f0aa7fdf3$var$ba(t);
        const r = $b34bd66f0aa7fdf3$var$va(t), i = $b34bd66f0aa7fdf3$var$Ta(t);
        n.texImage2D(n.TEXTURE_2D, 0, i, t.width, t.height, 0, n.RED, n.FLOAT, r), $b34bd66f0aa7fdf3$var$ka(t);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$wa(t) {
    if (!t.canvas) throw Error("Conversion to different image formats require that a canvas is passed when initializing the image.");
    return t.h || (t.h = $b34bd66f0aa7fdf3$var$oa(t.canvas.getContext("webgl2"), "You cannot use a canvas that is already bound to a different type of rendering context.")), t.h;
}
function $b34bd66f0aa7fdf3$var$Ta(t) {
    if (t = $b34bd66f0aa7fdf3$var$wa(t), !$b34bd66f0aa7fdf3$var$xa) {
        if (t.getExtension("EXT_color_buffer_float") && t.getExtension("OES_texture_float_linear") && t.getExtension("EXT_float_blend")) $b34bd66f0aa7fdf3$var$xa = t.R32F;
        else {
            if (!t.getExtension("EXT_color_buffer_half_float")) throw Error("GPU does not fully support 4-channel float32 or float16 formats");
            $b34bd66f0aa7fdf3$var$xa = t.R16F;
        }
    }
    return $b34bd66f0aa7fdf3$var$xa;
}
function $b34bd66f0aa7fdf3$var$Aa(t) {
    return t.l || (t.l = new $b34bd66f0aa7fdf3$var$ga), t.l;
}
function $b34bd66f0aa7fdf3$var$ba(t) {
    const e = $b34bd66f0aa7fdf3$var$wa(t);
    e.viewport(0, 0, t.width, t.height), e.activeTexture(e.TEXTURE0);
    let n = $b34bd66f0aa7fdf3$var$_a(t, 2);
    return n || (n = $b34bd66f0aa7fdf3$var$da($b34bd66f0aa7fdf3$var$Aa(t), e, t.m ? e.LINEAR : e.NEAREST), t.g.push(n), t.j = !0), e.bindTexture(e.TEXTURE_2D, n), n;
}
function $b34bd66f0aa7fdf3$var$ka(t) {
    t.h.bindTexture(t.h.TEXTURE_2D, null);
}
var $b34bd66f0aa7fdf3$var$xa, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef = class {
    constructor(t, e, n, r, i, s, o){
        this.g = t, this.m = e, this.j = n, this.canvas = r, this.l = i, this.width = s, this.height = o, this.j && 0 === --$b34bd66f0aa7fdf3$var$La && console.error("You seem to be creating MPMask instances without invoking .close(). This leaks resources.");
    }
    Ha() {
        return !!$b34bd66f0aa7fdf3$var$_a(this, 0);
    }
    la() {
        return !!$b34bd66f0aa7fdf3$var$_a(this, 1);
    }
    R() {
        return !!$b34bd66f0aa7fdf3$var$_a(this, 2);
    }
    ka() {
        var t, e;
        return (e = $b34bd66f0aa7fdf3$var$_a(t = this, 0)) || (e = $b34bd66f0aa7fdf3$var$va(t), e = new Uint8Array(e.map((t)=>255 * t)), t.g.push(e)), e;
    }
    ja() {
        return $b34bd66f0aa7fdf3$var$va(this);
    }
    O() {
        return $b34bd66f0aa7fdf3$var$Ea(this);
    }
    clone() {
        const t = [];
        for (const e of this.g){
            let n;
            if (e instanceof Uint8Array) n = new Uint8Array(e);
            else if (e instanceof Float32Array) n = new Float32Array(e);
            else {
                if (!(e instanceof WebGLTexture)) throw Error(`Type is not supported: ${e}`);
                {
                    const t = $b34bd66f0aa7fdf3$var$wa(this), e = $b34bd66f0aa7fdf3$var$Aa(this);
                    t.activeTexture(t.TEXTURE1), n = $b34bd66f0aa7fdf3$var$da(e, t, this.m ? t.LINEAR : t.NEAREST), t.bindTexture(t.TEXTURE_2D, n);
                    const r = $b34bd66f0aa7fdf3$var$Ta(this);
                    t.texImage2D(t.TEXTURE_2D, 0, r, this.width, this.height, 0, t.RED, t.FLOAT, null), t.bindTexture(t.TEXTURE_2D, null), $b34bd66f0aa7fdf3$var$fa(e, t, n), $b34bd66f0aa7fdf3$var$la(e, t, !1, ()=>{
                        $b34bd66f0aa7fdf3$var$ba(this), t.clearColor(0, 0, 0, 0), t.clear(t.COLOR_BUFFER_BIT), t.drawArrays(t.TRIANGLE_FAN, 0, 4), $b34bd66f0aa7fdf3$var$ka(this);
                    }), $b34bd66f0aa7fdf3$var$pa(e), $b34bd66f0aa7fdf3$var$ka(this);
                }
            }
            t.push(n);
        }
        return new $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef(t, this.m, this.R(), this.canvas, this.l, this.width, this.height);
    }
    close() {
        this.j && $b34bd66f0aa7fdf3$var$wa(this).deleteTexture($b34bd66f0aa7fdf3$var$_a(this, 2)), $b34bd66f0aa7fdf3$var$La = -1;
    }
};
$b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.close = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.close, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.clone = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.clone, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.getAsWebGLTexture = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.O, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.getAsFloat32Array = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.ja, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.getAsUint8Array = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.ka, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.hasWebGLTexture = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.R, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.hasFloat32Array = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.la, $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.hasUint8Array = $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef.prototype.Ha;
var $b34bd66f0aa7fdf3$var$La = 250;
const $b34bd66f0aa7fdf3$var$Fa = {
    color: "white",
    lineWidth: 4,
    radius: 6
};
function $b34bd66f0aa7fdf3$var$Ra(t) {
    return {
        ...$b34bd66f0aa7fdf3$var$Fa,
        fillColor: (t = t || {}).color,
        ...t
    };
}
function $b34bd66f0aa7fdf3$var$Ma(t, e) {
    return t instanceof Function ? t(e) : t;
}
function $b34bd66f0aa7fdf3$var$Pa(t, e, n) {
    return Math.max(Math.min(e, n), Math.min(Math.max(e, n), t));
}
function $b34bd66f0aa7fdf3$var$Ca(t) {
    if (!t.l) throw Error("CPU rendering requested but CanvasRenderingContext2D not provided.");
    return t.l;
}
function $b34bd66f0aa7fdf3$var$Oa(t) {
    if (!t.j) throw Error("GPU rendering requested but WebGL2RenderingContext not provided.");
    return t.j;
}
function $b34bd66f0aa7fdf3$var$Ia(t, e, n) {
    if (e.R()) n(e.O());
    else {
        const r = e.la() ? e.ja() : e.ka();
        t.m = t.m ?? new $b34bd66f0aa7fdf3$var$ga;
        const i = $b34bd66f0aa7fdf3$var$Oa(t);
        n((t = new $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef([
            r
        ], e.m, !1, i.canvas, t.m, e.width, e.height)).O()), t.close();
    }
}
function $b34bd66f0aa7fdf3$var$Ua(t, e, n, r) {
    const i = function(t) {
        return t.g || (t.g = new $b34bd66f0aa7fdf3$var$ma), t.g;
    }(t), s = $b34bd66f0aa7fdf3$var$Oa(t), o = Array.isArray(n) ? new ImageData(new Uint8ClampedArray(n), 1, 1) : n;
    $b34bd66f0aa7fdf3$var$la(i, s, !0, ()=>{
        !function(t, e, n, r) {
            const i = t.g;
            if (i.activeTexture(i.TEXTURE0), i.bindTexture(i.TEXTURE_2D, e), i.activeTexture(i.TEXTURE1), i.bindTexture(i.TEXTURE_2D, t.C), i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, i.RGBA, i.UNSIGNED_BYTE, n), t.I && function(t, e) {
                if (t !== e) return !1;
                t = t.entries(), e = e.entries();
                for (const [r, i] of t){
                    t = r;
                    const s = i;
                    var n = e.next();
                    if (n.done) return !1;
                    const [o, a] = n.value;
                    if (n = a, t !== o || s[0] !== n[0] || s[1] !== n[1] || s[2] !== n[2] || s[3] !== n[3]) return !1;
                }
                return !!e.next().done;
            }(t.I, r)) i.activeTexture(i.TEXTURE2), i.bindTexture(i.TEXTURE_2D, t.j);
            else {
                t.I = r;
                const e = Array(1024).fill(0);
                r.forEach((t, n)=>{
                    if (4 !== t.length) throw Error(`Color at index ${n} is not a four-channel value.`);
                    e[4 * n] = t[0], e[4 * n + 1] = t[1], e[4 * n + 2] = t[2], e[4 * n + 3] = t[3];
                }), i.activeTexture(i.TEXTURE2), i.bindTexture(i.TEXTURE_2D, t.j), i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, 256, 1, 0, i.RGBA, i.UNSIGNED_BYTE, new Uint8Array(e));
            }
        }(i, e, o, r), s.clearColor(0, 0, 0, 0), s.clear(s.COLOR_BUFFER_BIT), s.drawArrays(s.TRIANGLE_FAN, 0, 4);
        const t = i.g;
        t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, null), t.activeTexture(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, null), t.activeTexture(t.TEXTURE2), t.bindTexture(t.TEXTURE_2D, null);
    });
}
function $b34bd66f0aa7fdf3$var$Da(t, e, n, r) {
    const i = $b34bd66f0aa7fdf3$var$Oa(t), s = function(t) {
        return t.h || (t.h = new $b34bd66f0aa7fdf3$var$ya), t.h;
    }(t), o = Array.isArray(n) ? new ImageData(new Uint8ClampedArray(n), 1, 1) : n, a = Array.isArray(r) ? new ImageData(new Uint8ClampedArray(r), 1, 1) : r;
    $b34bd66f0aa7fdf3$var$la(s, i, !0, ()=>{
        var t = s.g;
        t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, e), t.activeTexture(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, s.j), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, o), t.activeTexture(t.TEXTURE2), t.bindTexture(t.TEXTURE_2D, s.C), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, a), i.clearColor(0, 0, 0, 0), i.clear(i.COLOR_BUFFER_BIT), i.drawArrays(i.TRIANGLE_FAN, 0, 4), i.bindTexture(i.TEXTURE_2D, null), (t = s.g).activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, null), t.activeTexture(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, null), t.activeTexture(t.TEXTURE2), t.bindTexture(t.TEXTURE_2D, null);
    });
}
var $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de = class {
    constructor(t, e){
        t instanceof CanvasRenderingContext2D || t instanceof OffscreenCanvasRenderingContext2D ? (this.l = t, this.j = e) : this.j = t;
    }
    Aa(t, e) {
        if (t) {
            var n = $b34bd66f0aa7fdf3$var$Ca(this);
            e = $b34bd66f0aa7fdf3$var$Ra(e), n.save();
            var r = n.canvas, i = 0;
            for (const s of t)n.fillStyle = $b34bd66f0aa7fdf3$var$Ma(e.fillColor, {
                index: i,
                from: s
            }), n.strokeStyle = $b34bd66f0aa7fdf3$var$Ma(e.color, {
                index: i,
                from: s
            }), n.lineWidth = $b34bd66f0aa7fdf3$var$Ma(e.lineWidth, {
                index: i,
                from: s
            }), (t = new Path2D).arc(s.x * r.width, s.y * r.height, $b34bd66f0aa7fdf3$var$Ma(e.radius, {
                index: i,
                from: s
            }), 0, 2 * Math.PI), n.fill(t), n.stroke(t), ++i;
            n.restore();
        }
    }
    za(t, e, n) {
        if (t && e) {
            var r = $b34bd66f0aa7fdf3$var$Ca(this);
            n = $b34bd66f0aa7fdf3$var$Ra(n), r.save();
            var i = r.canvas, s = 0;
            for (const o of e){
                r.beginPath(), e = t[o.start];
                const a = t[o.end];
                e && a && (r.strokeStyle = $b34bd66f0aa7fdf3$var$Ma(n.color, {
                    index: s,
                    from: e,
                    to: a
                }), r.lineWidth = $b34bd66f0aa7fdf3$var$Ma(n.lineWidth, {
                    index: s,
                    from: e,
                    to: a
                }), r.moveTo(e.x * i.width, e.y * i.height), r.lineTo(a.x * i.width, a.y * i.height)), ++s, r.stroke();
            }
            r.restore();
        }
    }
    wa(t, e) {
        const n = $b34bd66f0aa7fdf3$var$Ca(this);
        e = $b34bd66f0aa7fdf3$var$Ra(e), n.save(), n.beginPath(), n.lineWidth = $b34bd66f0aa7fdf3$var$Ma(e.lineWidth, {}), n.strokeStyle = $b34bd66f0aa7fdf3$var$Ma(e.color, {}), n.fillStyle = $b34bd66f0aa7fdf3$var$Ma(e.fillColor, {}), n.moveTo(t.originX, t.originY), n.lineTo(t.originX + t.width, t.originY), n.lineTo(t.originX + t.width, t.originY + t.height), n.lineTo(t.originX, t.originY + t.height), n.lineTo(t.originX, t.originY), n.stroke(), n.fill(), n.restore();
    }
    xa(t, e, n = [
        0,
        0,
        0,
        255
    ]) {
        this.l ? function(t, e, n, r) {
            const i = $b34bd66f0aa7fdf3$var$Oa(t);
            $b34bd66f0aa7fdf3$var$Ia(t, e, (e)=>{
                $b34bd66f0aa7fdf3$var$Ua(t, e, n, r), (e = $b34bd66f0aa7fdf3$var$Ca(t)).drawImage(i.canvas, 0, 0, e.canvas.width, e.canvas.height);
            });
        }(this, t, n, e) : $b34bd66f0aa7fdf3$var$Ua(this, t.O(), n, e);
    }
    ya(t, e, n) {
        this.l ? function(t, e, n, r) {
            const i = $b34bd66f0aa7fdf3$var$Oa(t);
            $b34bd66f0aa7fdf3$var$Ia(t, e, (e)=>{
                $b34bd66f0aa7fdf3$var$Da(t, e, n, r), (e = $b34bd66f0aa7fdf3$var$Ca(t)).drawImage(i.canvas, 0, 0, e.canvas.width, e.canvas.height);
            });
        }(this, t, e, n) : $b34bd66f0aa7fdf3$var$Da(this, t.O(), e, n);
    }
    close() {
        this.g?.close(), this.g = void 0, this.h?.close(), this.h = void 0, this.m?.close(), this.m = void 0;
    }
};
function $b34bd66f0aa7fdf3$var$Ba(t, e) {
    switch(e){
        case 0:
            return t.g.find((t)=>t instanceof ImageData);
        case 1:
            return t.g.find((t)=>"undefined" != typeof ImageBitmap && t instanceof ImageBitmap);
        case 2:
            return t.g.find((t)=>"undefined" != typeof WebGLTexture && t instanceof WebGLTexture);
        default:
            throw Error(`Type is not supported: ${e}`);
    }
}
function $b34bd66f0aa7fdf3$var$Ga(t) {
    var e = $b34bd66f0aa7fdf3$var$Ba(t, 0);
    if (!e) {
        e = $b34bd66f0aa7fdf3$var$Va(t);
        const n = $b34bd66f0aa7fdf3$var$Xa(t), r = new Uint8Array(t.width * t.height * 4);
        $b34bd66f0aa7fdf3$var$fa(n, e, $b34bd66f0aa7fdf3$var$ja(t)), e.readPixels(0, 0, t.width, t.height, e.RGBA, e.UNSIGNED_BYTE, r), $b34bd66f0aa7fdf3$var$pa(n), e = new ImageData(new Uint8ClampedArray(r.buffer), t.width, t.height), t.g.push(e);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$ja(t) {
    let e = $b34bd66f0aa7fdf3$var$Ba(t, 2);
    if (!e) {
        const n = $b34bd66f0aa7fdf3$var$Va(t);
        e = $b34bd66f0aa7fdf3$var$Ha(t);
        const r = $b34bd66f0aa7fdf3$var$Ba(t, 1) || $b34bd66f0aa7fdf3$var$Ga(t);
        n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, n.RGBA, n.UNSIGNED_BYTE, r), $b34bd66f0aa7fdf3$var$Wa(t);
    }
    return e;
}
function $b34bd66f0aa7fdf3$var$Va(t) {
    if (!t.canvas) throw Error("Conversion to different image formats require that a canvas is passed when iniitializing the image.");
    return t.h || (t.h = $b34bd66f0aa7fdf3$var$oa(t.canvas.getContext("webgl2"), "You cannot use a canvas that is already bound to a different type of rendering context.")), t.h;
}
function $b34bd66f0aa7fdf3$var$Xa(t) {
    return t.l || (t.l = new $b34bd66f0aa7fdf3$var$ga), t.l;
}
function $b34bd66f0aa7fdf3$var$Ha(t) {
    const e = $b34bd66f0aa7fdf3$var$Va(t);
    e.viewport(0, 0, t.width, t.height), e.activeTexture(e.TEXTURE0);
    let n = $b34bd66f0aa7fdf3$var$Ba(t, 2);
    return n || (n = $b34bd66f0aa7fdf3$var$da($b34bd66f0aa7fdf3$var$Xa(t), e), t.g.push(n), t.m = !0), e.bindTexture(e.TEXTURE_2D, n), n;
}
function $b34bd66f0aa7fdf3$var$Wa(t) {
    t.h.bindTexture(t.h.TEXTURE_2D, null);
}
function $b34bd66f0aa7fdf3$var$za(t) {
    const e = $b34bd66f0aa7fdf3$var$Va(t);
    return $b34bd66f0aa7fdf3$var$la($b34bd66f0aa7fdf3$var$Xa(t), e, !0, ()=>(function(t, e) {
            const n = t.canvas;
            if (n.width === t.width && n.height === t.height) return e();
            const r = n.width, i = n.height;
            return n.width = t.width, n.height = t.height, t = e(), n.width = r, n.height = i, t;
        })(t, ()=>{
            if (e.bindFramebuffer(e.FRAMEBUFFER, null), e.clearColor(0, 0, 0, 0), e.clear(e.COLOR_BUFFER_BIT), e.drawArrays(e.TRIANGLE_FAN, 0, 4), !(t.canvas instanceof OffscreenCanvas)) throw Error("Conversion to ImageBitmap requires that the MediaPipe Tasks is initialized with an OffscreenCanvas");
            return t.canvas.transferToImageBitmap();
        }));
}
$b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.close = $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.close, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.drawConfidenceMask = $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.ya, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.drawCategoryMask = $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.xa, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.drawBoundingBox = $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.wa, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.drawConnectors = $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.za, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.drawLandmarks = $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.prototype.Aa, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.lerp = function(t, e, n, r, i) {
    return $b34bd66f0aa7fdf3$var$Pa(r * (1 - (t - e) / (n - e)) + i * (1 - (n - t) / (n - e)), r, i);
}, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de.clamp = $b34bd66f0aa7fdf3$var$Pa;
var $b34bd66f0aa7fdf3$export$7c9479202f61c045 = class {
    constructor(t, e, n, r, i, s, o){
        this.g = t, this.j = e, this.m = n, this.canvas = r, this.l = i, this.width = s, this.height = o, (this.j || this.m) && 0 === --$b34bd66f0aa7fdf3$var$Ya && console.error("You seem to be creating MPImage instances without invoking .close(). This leaks resources.");
    }
    Ga() {
        return !!$b34bd66f0aa7fdf3$var$Ba(this, 0);
    }
    ma() {
        return !!$b34bd66f0aa7fdf3$var$Ba(this, 1);
    }
    R() {
        return !!$b34bd66f0aa7fdf3$var$Ba(this, 2);
    }
    Ea() {
        return $b34bd66f0aa7fdf3$var$Ga(this);
    }
    Da() {
        var t = $b34bd66f0aa7fdf3$var$Ba(this, 1);
        return t || ($b34bd66f0aa7fdf3$var$ja(this), $b34bd66f0aa7fdf3$var$Ha(this), t = $b34bd66f0aa7fdf3$var$za(this), $b34bd66f0aa7fdf3$var$Wa(this), this.g.push(t), this.j = !0), t;
    }
    O() {
        return $b34bd66f0aa7fdf3$var$ja(this);
    }
    clone() {
        const t = [];
        for (const e of this.g){
            let n;
            if (e instanceof ImageData) n = new ImageData(e.data, this.width, this.height);
            else if (e instanceof WebGLTexture) {
                const t = $b34bd66f0aa7fdf3$var$Va(this), e = $b34bd66f0aa7fdf3$var$Xa(this);
                t.activeTexture(t.TEXTURE1), n = $b34bd66f0aa7fdf3$var$da(e, t), t.bindTexture(t.TEXTURE_2D, n), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, this.width, this.height, 0, t.RGBA, t.UNSIGNED_BYTE, null), t.bindTexture(t.TEXTURE_2D, null), $b34bd66f0aa7fdf3$var$fa(e, t, n), $b34bd66f0aa7fdf3$var$la(e, t, !1, ()=>{
                    $b34bd66f0aa7fdf3$var$Ha(this), t.clearColor(0, 0, 0, 0), t.clear(t.COLOR_BUFFER_BIT), t.drawArrays(t.TRIANGLE_FAN, 0, 4), $b34bd66f0aa7fdf3$var$Wa(this);
                }), $b34bd66f0aa7fdf3$var$pa(e), $b34bd66f0aa7fdf3$var$Wa(this);
            } else {
                if (!(e instanceof ImageBitmap)) throw Error(`Type is not supported: ${e}`);
                $b34bd66f0aa7fdf3$var$ja(this), $b34bd66f0aa7fdf3$var$Ha(this), n = $b34bd66f0aa7fdf3$var$za(this), $b34bd66f0aa7fdf3$var$Wa(this);
            }
            t.push(n);
        }
        return new $b34bd66f0aa7fdf3$export$7c9479202f61c045(t, this.ma(), this.R(), this.canvas, this.l, this.width, this.height);
    }
    close() {
        this.j && $b34bd66f0aa7fdf3$var$Ba(this, 1).close(), this.m && $b34bd66f0aa7fdf3$var$Va(this).deleteTexture($b34bd66f0aa7fdf3$var$Ba(this, 2)), $b34bd66f0aa7fdf3$var$Ya = -1;
    }
};
$b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.close = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.close, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.clone = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.clone, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.getAsWebGLTexture = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.O, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.getAsImageBitmap = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.Da, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.getAsImageData = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.Ea, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.hasWebGLTexture = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.R, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.hasImageBitmap = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.ma, $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.hasImageData = $b34bd66f0aa7fdf3$export$7c9479202f61c045.prototype.Ga;
var $b34bd66f0aa7fdf3$var$Ya = 250;
function $b34bd66f0aa7fdf3$var$$a(...t) {
    return t.map(([t, e])=>({
            start: t,
            end: e
        }));
}
const $b34bd66f0aa7fdf3$var$qa = function(t) {
    return class extends t {
        Ma() {
            this.i._registerModelResourcesGraphService();
        }
    };
}(($b34bd66f0aa7fdf3$var$Ja = class {
    constructor(t, e){
        this.l = !0, this.i = t, this.g = null, this.h = 0, this.m = "function" == typeof this.i._addIntToInputStream, void 0 !== e ? this.i.canvas = e : $b34bd66f0aa7fdf3$var$Ho() ? this.i.canvas = new OffscreenCanvas(1, 1) : (console.warn("OffscreenCanvas not supported and GraphRunner constructor glCanvas parameter is undefined. Creating backup canvas."), this.i.canvas = document.createElement("canvas"));
    }
    async initializeGraph(t) {
        const e = await (await fetch(t)).arrayBuffer();
        t = !(t.endsWith(".pbtxt") || t.endsWith(".textproto")), this.setGraph(new Uint8Array(e), t);
    }
    setGraphFromString(t) {
        this.setGraph((new TextEncoder).encode(t), !1);
    }
    setGraph(t, e) {
        const n = t.length, r = this.i._malloc(n);
        this.i.HEAPU8.set(t, r), e ? this.i._changeBinaryGraph(n, r) : this.i._changeTextGraph(n, r), this.i._free(r);
    }
    configureAudio(t, e, n, r, i) {
        this.i._configureAudio || console.warn('Attempting to use configureAudio without support for input audio. Is build dep ":gl_graph_runner_audio" missing?'), $b34bd66f0aa7fdf3$var$Ko(this, r || "input_audio", (r)=>{
            $b34bd66f0aa7fdf3$var$Ko(this, i = i || "audio_header", (i)=>{
                this.i._configureAudio(r, i, t, e, n);
            });
        });
    }
    setAutoResizeCanvas(t) {
        this.l = t;
    }
    setAutoRenderToScreen(t) {
        this.i._setAutoRenderToScreen(t);
    }
    setGpuBufferVerticalFlip(t) {
        this.i.gpuOriginForWebTexturesIsBottomLeft = t;
    }
    fa(t) {
        $b34bd66f0aa7fdf3$var$qo(this, "__graph_config__", (e)=>{
            t(e);
        }), $b34bd66f0aa7fdf3$var$Ko(this, "__graph_config__", (t)=>{
            this.i._getGraphConfig(t, void 0);
        }), delete this.i.simpleListeners.__graph_config__;
    }
    attachErrorListener(t) {
        this.i.errorListener = t;
    }
    attachEmptyPacketListener(t, e) {
        this.i.emptyPacketListeners = this.i.emptyPacketListeners || {}, this.i.emptyPacketListeners[t] = e;
    }
    addAudioToStream(t, e, n) {
        this.addAudioToStreamWithShape(t, 0, 0, e, n);
    }
    addAudioToStreamWithShape(t, e, n, r, i) {
        const s = 4 * t.length;
        this.h !== s && (this.g && this.i._free(this.g), this.g = this.i._malloc(s), this.h = s), this.i.HEAPF32.set(t, this.g / 4), $b34bd66f0aa7fdf3$var$Ko(this, r, (t)=>{
            this.i._addAudioToInputStream(this.g, e, n, t, i);
        });
    }
    addGpuBufferToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const [r, i] = $b34bd66f0aa7fdf3$var$Yo(this, t, e);
            this.i._addBoundTextureToStream(e, r, i, n);
        });
    }
    addBoolToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            this.i._addBoolToInputStream(t, e, n);
        });
    }
    addDoubleToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            this.i._addDoubleToInputStream(t, e, n);
        });
    }
    addFloatToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            this.i._addFloatToInputStream(t, e, n);
        });
    }
    addIntToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            this.i._addIntToInputStream(t, e, n);
        });
    }
    addUintToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            this.i._addUintToInputStream(t, e, n);
        });
    }
    addStringToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
                this.i._addStringToInputStream(t, e, n);
            });
        });
    }
    addStringRecordToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            $b34bd66f0aa7fdf3$var$$o(this, Object.keys(t), (r)=>{
                $b34bd66f0aa7fdf3$var$$o(this, Object.values(t), (i)=>{
                    this.i._addFlatHashMapToInputStream(r, i, Object.keys(t).length, e, n);
                });
            });
        });
    }
    addProtoToStream(t, e, n, r) {
        $b34bd66f0aa7fdf3$var$Ko(this, n, (n)=>{
            $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
                const i = this.i._malloc(t.length);
                this.i.HEAPU8.set(t, i), this.i._addProtoToInputStream(i, t.length, e, n, r), this.i._free(i);
            });
        });
    }
    addEmptyPacketToStream(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._addEmptyPacketToInputStream(t, e);
        });
    }
    addBoolVectorToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const r = this.i._allocateBoolVector(t.length);
            if (!r) throw Error("Unable to allocate new bool vector on heap.");
            for (const e of t)this.i._addBoolVectorEntry(r, e);
            this.i._addBoolVectorToInputStream(r, e, n);
        });
    }
    addDoubleVectorToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const r = this.i._allocateDoubleVector(t.length);
            if (!r) throw Error("Unable to allocate new double vector on heap.");
            for (const e of t)this.i._addDoubleVectorEntry(r, e);
            this.i._addDoubleVectorToInputStream(r, e, n);
        });
    }
    addFloatVectorToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const r = this.i._allocateFloatVector(t.length);
            if (!r) throw Error("Unable to allocate new float vector on heap.");
            for (const e of t)this.i._addFloatVectorEntry(r, e);
            this.i._addFloatVectorToInputStream(r, e, n);
        });
    }
    addIntVectorToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const r = this.i._allocateIntVector(t.length);
            if (!r) throw Error("Unable to allocate new int vector on heap.");
            for (const e of t)this.i._addIntVectorEntry(r, e);
            this.i._addIntVectorToInputStream(r, e, n);
        });
    }
    addUintVectorToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const r = this.i._allocateUintVector(t.length);
            if (!r) throw Error("Unable to allocate new unsigned int vector on heap.");
            for (const e of t)this.i._addUintVectorEntry(r, e);
            this.i._addUintVectorToInputStream(r, e, n);
        });
    }
    addStringVectorToStream(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const r = this.i._allocateStringVector(t.length);
            if (!r) throw Error("Unable to allocate new string vector on heap.");
            for (const e of t)$b34bd66f0aa7fdf3$var$Ko(this, e, (t)=>{
                this.i._addStringVectorEntry(r, t);
            });
            this.i._addStringVectorToInputStream(r, e, n);
        });
    }
    addBoolToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            this.i._addBoolToInputSidePacket(t, e);
        });
    }
    addDoubleToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            this.i._addDoubleToInputSidePacket(t, e);
        });
    }
    addFloatToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            this.i._addFloatToInputSidePacket(t, e);
        });
    }
    addIntToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            this.i._addIntToInputSidePacket(t, e);
        });
    }
    addUintToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            this.i._addUintToInputSidePacket(t, e);
        });
    }
    addStringToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
                this.i._addStringToInputSidePacket(t, e);
            });
        });
    }
    addProtoToInputSidePacket(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, n, (n)=>{
            $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
                const r = this.i._malloc(t.length);
                this.i.HEAPU8.set(t, r), this.i._addProtoToInputSidePacket(r, t.length, e, n), this.i._free(r);
            });
        });
    }
    addBoolVectorToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const n = this.i._allocateBoolVector(t.length);
            if (!n) throw Error("Unable to allocate new bool vector on heap.");
            for (const e of t)this.i._addBoolVectorEntry(n, e);
            this.i._addBoolVectorToInputSidePacket(n, e);
        });
    }
    addDoubleVectorToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const n = this.i._allocateDoubleVector(t.length);
            if (!n) throw Error("Unable to allocate new double vector on heap.");
            for (const e of t)this.i._addDoubleVectorEntry(n, e);
            this.i._addDoubleVectorToInputSidePacket(n, e);
        });
    }
    addFloatVectorToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const n = this.i._allocateFloatVector(t.length);
            if (!n) throw Error("Unable to allocate new float vector on heap.");
            for (const e of t)this.i._addFloatVectorEntry(n, e);
            this.i._addFloatVectorToInputSidePacket(n, e);
        });
    }
    addIntVectorToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const n = this.i._allocateIntVector(t.length);
            if (!n) throw Error("Unable to allocate new int vector on heap.");
            for (const e of t)this.i._addIntVectorEntry(n, e);
            this.i._addIntVectorToInputSidePacket(n, e);
        });
    }
    addUintVectorToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const n = this.i._allocateUintVector(t.length);
            if (!n) throw Error("Unable to allocate new unsigned int vector on heap.");
            for (const e of t)this.i._addUintVectorEntry(n, e);
            this.i._addUintVectorToInputSidePacket(n, e);
        });
    }
    addStringVectorToInputSidePacket(t, e) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const n = this.i._allocateStringVector(t.length);
            if (!n) throw Error("Unable to allocate new string vector on heap.");
            for (const e of t)$b34bd66f0aa7fdf3$var$Ko(this, e, (t)=>{
                this.i._addStringVectorEntry(n, t);
            });
            this.i._addStringVectorToInputSidePacket(n, e);
        });
    }
    attachBoolListener(t, e) {
        $b34bd66f0aa7fdf3$var$qo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachBoolListener(t);
        });
    }
    attachBoolVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$Jo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachBoolVectorListener(t);
        });
    }
    attachIntListener(t, e) {
        $b34bd66f0aa7fdf3$var$qo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachIntListener(t);
        });
    }
    attachIntVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$Jo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachIntVectorListener(t);
        });
    }
    attachUintListener(t, e) {
        $b34bd66f0aa7fdf3$var$qo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachUintListener(t);
        });
    }
    attachUintVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$Jo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachUintVectorListener(t);
        });
    }
    attachDoubleListener(t, e) {
        $b34bd66f0aa7fdf3$var$qo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachDoubleListener(t);
        });
    }
    attachDoubleVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$Jo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachDoubleVectorListener(t);
        });
    }
    attachFloatListener(t, e) {
        $b34bd66f0aa7fdf3$var$qo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachFloatListener(t);
        });
    }
    attachFloatVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$Jo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachFloatVectorListener(t);
        });
    }
    attachStringListener(t, e) {
        $b34bd66f0aa7fdf3$var$qo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachStringListener(t);
        });
    }
    attachStringVectorListener(t, e) {
        $b34bd66f0aa7fdf3$var$Jo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachStringVectorListener(t);
        });
    }
    attachProtoListener(t, e, n) {
        $b34bd66f0aa7fdf3$var$qo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachProtoListener(t, n || !1);
        });
    }
    attachProtoVectorListener(t, e, n) {
        $b34bd66f0aa7fdf3$var$Jo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachProtoVectorListener(t, n || !1);
        });
    }
    attachAudioListener(t, e, n) {
        this.i._attachAudioListener || console.warn('Attempting to use attachAudioListener without support for output audio. Is build dep ":gl_graph_runner_audio_out" missing?'), $b34bd66f0aa7fdf3$var$qo(this, t, (t, n)=>{
            t = new Float32Array(t.buffer, t.byteOffset, t.length / 4), e(t, n);
        }), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.i._attachAudioListener(t, n || !1);
        });
    }
    finishProcessing() {
        this.i._waitUntilIdle();
    }
    closeGraph() {
        this.i._closeGraph(), this.i.simpleListeners = void 0, this.i.emptyPacketListeners = void 0;
    }
}, class extends $b34bd66f0aa7fdf3$var$Ja {
    get ha() {
        return this.i;
    }
    sa(t, e, n) {
        $b34bd66f0aa7fdf3$var$Ko(this, e, (e)=>{
            const [r, i] = $b34bd66f0aa7fdf3$var$Yo(this, t, e);
            this.ha._addBoundTextureAsImageToStream(e, r, i, n);
        });
    }
    W(t, e) {
        $b34bd66f0aa7fdf3$var$qo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.ha._attachImageListener(t);
        });
    }
    da(t, e) {
        $b34bd66f0aa7fdf3$var$Jo(this, t, e), $b34bd66f0aa7fdf3$var$Ko(this, t, (t)=>{
            this.ha._attachImageVectorListener(t);
        });
    }
}));
var $b34bd66f0aa7fdf3$var$Ja, $b34bd66f0aa7fdf3$var$Za = class extends $b34bd66f0aa7fdf3$var$qa {
};
async function $b34bd66f0aa7fdf3$var$Qa(t, e, n) {
    return async function(t, e, n, r) {
        return $b34bd66f0aa7fdf3$var$Zo(t, e, n, r);
    }(t, n.canvas ?? ($b34bd66f0aa7fdf3$var$Ho() ? void 0 : document.createElement("canvas")), e, n);
}
function $b34bd66f0aa7fdf3$var$th(t, e, n, r) {
    if (t.V) {
        const s = new $b34bd66f0aa7fdf3$var$fs;
        if (n?.regionOfInterest) {
            if (!t.ra) throw Error("This task doesn't support region-of-interest.");
            var i = n.regionOfInterest;
            if (i.left >= i.right || i.top >= i.bottom) throw Error("Expected RectF with left < right and top < bottom.");
            if (0 > i.left || 0 > i.top || 1 < i.right || 1 < i.bottom) throw Error("Expected RectF values to be in [0,1].");
            $b34bd66f0aa7fdf3$var$Hn(s, 1, (i.left + i.right) / 2), $b34bd66f0aa7fdf3$var$Hn(s, 2, (i.top + i.bottom) / 2), $b34bd66f0aa7fdf3$var$Hn(s, 4, i.right - i.left), $b34bd66f0aa7fdf3$var$Hn(s, 3, i.bottom - i.top);
        } else $b34bd66f0aa7fdf3$var$Hn(s, 1, .5), $b34bd66f0aa7fdf3$var$Hn(s, 2, .5), $b34bd66f0aa7fdf3$var$Hn(s, 4, 1), $b34bd66f0aa7fdf3$var$Hn(s, 3, 1);
        if (n?.rotationDegrees) {
            if (0 != n?.rotationDegrees % 90) throw Error("Expected rotation to be a multiple of 90\xb0.");
            if ($b34bd66f0aa7fdf3$var$Hn(s, 5, -Math.PI * n.rotationDegrees / 180), 0 != n?.rotationDegrees % 180) {
                const [t, r] = $b34bd66f0aa7fdf3$var$zo(e);
                n = $b34bd66f0aa7fdf3$var$Gn(s, 3) * r / t, i = $b34bd66f0aa7fdf3$var$Gn(s, 4) * t / r, $b34bd66f0aa7fdf3$var$Hn(s, 4, n), $b34bd66f0aa7fdf3$var$Hn(s, 3, i);
            }
        }
        t.g.addProtoToStream(s.g(), "mediapipe.NormalizedRect", t.V, r);
    }
    t.g.sa(e, t.ba, r ?? performance.now()), t.finishProcessing();
}
function $b34bd66f0aa7fdf3$var$eh(t, e, n) {
    if (t.baseOptions?.g()) throw Error("Task is not initialized with image mode. 'runningMode' must be set to 'IMAGE'.");
    $b34bd66f0aa7fdf3$var$th(t, e, n, t.J + 1);
}
function $b34bd66f0aa7fdf3$var$nh(t, e, n, r) {
    if (!t.baseOptions?.g()) throw Error("Task is not initialized with video mode. 'runningMode' must be set to 'VIDEO'.");
    $b34bd66f0aa7fdf3$var$th(t, e, n, r);
}
function $b34bd66f0aa7fdf3$var$rh(t, e, n, r) {
    var i = e.data;
    const s = e.width, o = s * (e = e.height);
    if ((i instanceof Uint8Array || i instanceof Float32Array) && i.length !== o) throw Error("Unsupported channel count: " + i.length / o);
    return t = new $b34bd66f0aa7fdf3$export$e68fd2753c6d17ef([
        i
    ], n, !1, t.g.i.canvas, t.M, s, e), r ? t.clone() : t;
}
var $b34bd66f0aa7fdf3$export$6371bff908d1a094 = class extends $b34bd66f0aa7fdf3$var$sa {
    constructor(t, e, n, r){
        super(t), this.g = t, this.ba = e, this.V = n, this.ra = r, this.M = new $b34bd66f0aa7fdf3$var$ga;
    }
    l(t, e = !0) {
        if ("runningMode" in t && $b34bd66f0aa7fdf3$var$Vn(this.baseOptions, 2, !!t.runningMode && "IMAGE" !== t.runningMode), void 0 !== t.canvas && this.g.i.canvas !== t.canvas) throw Error("You must create a new task to reset the canvas.");
        return super.l(t, e);
    }
    close() {
        this.M.close(), super.close();
    }
};
$b34bd66f0aa7fdf3$export$6371bff908d1a094.prototype.close = $b34bd66f0aa7fdf3$export$6371bff908d1a094.prototype.close;
var $b34bd66f0aa7fdf3$export$6de3c7136b240002 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "image_in", "norm_rect_in", !1), this.j = {
            detections: []
        }, $b34bd66f0aa7fdf3$var$Cn(t = this.h = new $b34bd66f0aa7fdf3$var$Is, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs), $b34bd66f0aa7fdf3$var$Hn(this.h, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.h, 3, .3);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.h, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 1, t);
    }
    o(t) {
        return "minDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.h, 2, t.minDetectionConfidence ?? .5), "minSuppressionThreshold" in t && $b34bd66f0aa7fdf3$var$Hn(this.h, 3, t.minSuppressionThreshold ?? .3), this.l(t);
    }
    F(t, e) {
        return this.j = {
            detections: []
        }, $b34bd66f0aa7fdf3$var$eh(this, t, e), this.j;
    }
    G(t, e, n) {
        return this.j = {
            detections: []
        }, $b34bd66f0aa7fdf3$var$nh(this, t, n, e), this.j;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "image_in"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect_in"), $b34bd66f0aa7fdf3$var$Ui(t, "detections");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$Ds, this.h);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.face_detector.FaceDetectorGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect_in"), $b34bd66f0aa7fdf3$var$Si(n, "DETECTIONS:detections"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), this.g.attachProtoVectorListener("detections", (t, e)=>{
            for (const e of t)t = $b34bd66f0aa7fdf3$var$ns(e), this.j.detections.push($b34bd66f0aa7fdf3$var$Oo(t));
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("detections", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.G, $b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.detect = $b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.F, $b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.setOptions = $b34bd66f0aa7fdf3$export$6de3c7136b240002.prototype.o, $b34bd66f0aa7fdf3$export$6de3c7136b240002.createFromModelPath = async function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$6de3c7136b240002, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$6de3c7136b240002.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$6de3c7136b240002, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$6de3c7136b240002.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$6de3c7136b240002, t, e);
};
var $b34bd66f0aa7fdf3$var$oh = $b34bd66f0aa7fdf3$var$$a([
    61,
    146
], [
    146,
    91
], [
    91,
    181
], [
    181,
    84
], [
    84,
    17
], [
    17,
    314
], [
    314,
    405
], [
    405,
    321
], [
    321,
    375
], [
    375,
    291
], [
    61,
    185
], [
    185,
    40
], [
    40,
    39
], [
    39,
    37
], [
    37,
    0
], [
    0,
    267
], [
    267,
    269
], [
    269,
    270
], [
    270,
    409
], [
    409,
    291
], [
    78,
    95
], [
    95,
    88
], [
    88,
    178
], [
    178,
    87
], [
    87,
    14
], [
    14,
    317
], [
    317,
    402
], [
    402,
    318
], [
    318,
    324
], [
    324,
    308
], [
    78,
    191
], [
    191,
    80
], [
    80,
    81
], [
    81,
    82
], [
    82,
    13
], [
    13,
    312
], [
    312,
    311
], [
    311,
    310
], [
    310,
    415
], [
    415,
    308
]), $b34bd66f0aa7fdf3$var$ah = $b34bd66f0aa7fdf3$var$$a([
    263,
    249
], [
    249,
    390
], [
    390,
    373
], [
    373,
    374
], [
    374,
    380
], [
    380,
    381
], [
    381,
    382
], [
    382,
    362
], [
    263,
    466
], [
    466,
    388
], [
    388,
    387
], [
    387,
    386
], [
    386,
    385
], [
    385,
    384
], [
    384,
    398
], [
    398,
    362
]), $b34bd66f0aa7fdf3$var$hh = $b34bd66f0aa7fdf3$var$$a([
    276,
    283
], [
    283,
    282
], [
    282,
    295
], [
    295,
    285
], [
    300,
    293
], [
    293,
    334
], [
    334,
    296
], [
    296,
    336
]), $b34bd66f0aa7fdf3$var$ch = $b34bd66f0aa7fdf3$var$$a([
    474,
    475
], [
    475,
    476
], [
    476,
    477
], [
    477,
    474
]), $b34bd66f0aa7fdf3$var$uh = $b34bd66f0aa7fdf3$var$$a([
    33,
    7
], [
    7,
    163
], [
    163,
    144
], [
    144,
    145
], [
    145,
    153
], [
    153,
    154
], [
    154,
    155
], [
    155,
    133
], [
    33,
    246
], [
    246,
    161
], [
    161,
    160
], [
    160,
    159
], [
    159,
    158
], [
    158,
    157
], [
    157,
    173
], [
    173,
    133
]), $b34bd66f0aa7fdf3$var$lh = $b34bd66f0aa7fdf3$var$$a([
    46,
    53
], [
    53,
    52
], [
    52,
    65
], [
    65,
    55
], [
    70,
    63
], [
    63,
    105
], [
    105,
    66
], [
    66,
    107
]), $b34bd66f0aa7fdf3$var$dh = $b34bd66f0aa7fdf3$var$$a([
    469,
    470
], [
    470,
    471
], [
    471,
    472
], [
    472,
    469
]), $b34bd66f0aa7fdf3$var$fh = $b34bd66f0aa7fdf3$var$$a([
    10,
    338
], [
    338,
    297
], [
    297,
    332
], [
    332,
    284
], [
    284,
    251
], [
    251,
    389
], [
    389,
    356
], [
    356,
    454
], [
    454,
    323
], [
    323,
    361
], [
    361,
    288
], [
    288,
    397
], [
    397,
    365
], [
    365,
    379
], [
    379,
    378
], [
    378,
    400
], [
    400,
    377
], [
    377,
    152
], [
    152,
    148
], [
    148,
    176
], [
    176,
    149
], [
    149,
    150
], [
    150,
    136
], [
    136,
    172
], [
    172,
    58
], [
    58,
    132
], [
    132,
    93
], [
    93,
    234
], [
    234,
    127
], [
    127,
    162
], [
    162,
    21
], [
    21,
    54
], [
    54,
    103
], [
    103,
    67
], [
    67,
    109
], [
    109,
    10
]), $b34bd66f0aa7fdf3$var$ph = [
    ...$b34bd66f0aa7fdf3$var$oh,
    ...$b34bd66f0aa7fdf3$var$ah,
    ...$b34bd66f0aa7fdf3$var$hh,
    ...$b34bd66f0aa7fdf3$var$uh,
    ...$b34bd66f0aa7fdf3$var$lh,
    ...$b34bd66f0aa7fdf3$var$fh
], $b34bd66f0aa7fdf3$var$gh = $b34bd66f0aa7fdf3$var$$a([
    127,
    34
], [
    34,
    139
], [
    139,
    127
], [
    11,
    0
], [
    0,
    37
], [
    37,
    11
], [
    232,
    231
], [
    231,
    120
], [
    120,
    232
], [
    72,
    37
], [
    37,
    39
], [
    39,
    72
], [
    128,
    121
], [
    121,
    47
], [
    47,
    128
], [
    232,
    121
], [
    121,
    128
], [
    128,
    232
], [
    104,
    69
], [
    69,
    67
], [
    67,
    104
], [
    175,
    171
], [
    171,
    148
], [
    148,
    175
], [
    118,
    50
], [
    50,
    101
], [
    101,
    118
], [
    73,
    39
], [
    39,
    40
], [
    40,
    73
], [
    9,
    151
], [
    151,
    108
], [
    108,
    9
], [
    48,
    115
], [
    115,
    131
], [
    131,
    48
], [
    194,
    204
], [
    204,
    211
], [
    211,
    194
], [
    74,
    40
], [
    40,
    185
], [
    185,
    74
], [
    80,
    42
], [
    42,
    183
], [
    183,
    80
], [
    40,
    92
], [
    92,
    186
], [
    186,
    40
], [
    230,
    229
], [
    229,
    118
], [
    118,
    230
], [
    202,
    212
], [
    212,
    214
], [
    214,
    202
], [
    83,
    18
], [
    18,
    17
], [
    17,
    83
], [
    76,
    61
], [
    61,
    146
], [
    146,
    76
], [
    160,
    29
], [
    29,
    30
], [
    30,
    160
], [
    56,
    157
], [
    157,
    173
], [
    173,
    56
], [
    106,
    204
], [
    204,
    194
], [
    194,
    106
], [
    135,
    214
], [
    214,
    192
], [
    192,
    135
], [
    203,
    165
], [
    165,
    98
], [
    98,
    203
], [
    21,
    71
], [
    71,
    68
], [
    68,
    21
], [
    51,
    45
], [
    45,
    4
], [
    4,
    51
], [
    144,
    24
], [
    24,
    23
], [
    23,
    144
], [
    77,
    146
], [
    146,
    91
], [
    91,
    77
], [
    205,
    50
], [
    50,
    187
], [
    187,
    205
], [
    201,
    200
], [
    200,
    18
], [
    18,
    201
], [
    91,
    106
], [
    106,
    182
], [
    182,
    91
], [
    90,
    91
], [
    91,
    181
], [
    181,
    90
], [
    85,
    84
], [
    84,
    17
], [
    17,
    85
], [
    206,
    203
], [
    203,
    36
], [
    36,
    206
], [
    148,
    171
], [
    171,
    140
], [
    140,
    148
], [
    92,
    40
], [
    40,
    39
], [
    39,
    92
], [
    193,
    189
], [
    189,
    244
], [
    244,
    193
], [
    159,
    158
], [
    158,
    28
], [
    28,
    159
], [
    247,
    246
], [
    246,
    161
], [
    161,
    247
], [
    236,
    3
], [
    3,
    196
], [
    196,
    236
], [
    54,
    68
], [
    68,
    104
], [
    104,
    54
], [
    193,
    168
], [
    168,
    8
], [
    8,
    193
], [
    117,
    228
], [
    228,
    31
], [
    31,
    117
], [
    189,
    193
], [
    193,
    55
], [
    55,
    189
], [
    98,
    97
], [
    97,
    99
], [
    99,
    98
], [
    126,
    47
], [
    47,
    100
], [
    100,
    126
], [
    166,
    79
], [
    79,
    218
], [
    218,
    166
], [
    155,
    154
], [
    154,
    26
], [
    26,
    155
], [
    209,
    49
], [
    49,
    131
], [
    131,
    209
], [
    135,
    136
], [
    136,
    150
], [
    150,
    135
], [
    47,
    126
], [
    126,
    217
], [
    217,
    47
], [
    223,
    52
], [
    52,
    53
], [
    53,
    223
], [
    45,
    51
], [
    51,
    134
], [
    134,
    45
], [
    211,
    170
], [
    170,
    140
], [
    140,
    211
], [
    67,
    69
], [
    69,
    108
], [
    108,
    67
], [
    43,
    106
], [
    106,
    91
], [
    91,
    43
], [
    230,
    119
], [
    119,
    120
], [
    120,
    230
], [
    226,
    130
], [
    130,
    247
], [
    247,
    226
], [
    63,
    53
], [
    53,
    52
], [
    52,
    63
], [
    238,
    20
], [
    20,
    242
], [
    242,
    238
], [
    46,
    70
], [
    70,
    156
], [
    156,
    46
], [
    78,
    62
], [
    62,
    96
], [
    96,
    78
], [
    46,
    53
], [
    53,
    63
], [
    63,
    46
], [
    143,
    34
], [
    34,
    227
], [
    227,
    143
], [
    123,
    117
], [
    117,
    111
], [
    111,
    123
], [
    44,
    125
], [
    125,
    19
], [
    19,
    44
], [
    236,
    134
], [
    134,
    51
], [
    51,
    236
], [
    216,
    206
], [
    206,
    205
], [
    205,
    216
], [
    154,
    153
], [
    153,
    22
], [
    22,
    154
], [
    39,
    37
], [
    37,
    167
], [
    167,
    39
], [
    200,
    201
], [
    201,
    208
], [
    208,
    200
], [
    36,
    142
], [
    142,
    100
], [
    100,
    36
], [
    57,
    212
], [
    212,
    202
], [
    202,
    57
], [
    20,
    60
], [
    60,
    99
], [
    99,
    20
], [
    28,
    158
], [
    158,
    157
], [
    157,
    28
], [
    35,
    226
], [
    226,
    113
], [
    113,
    35
], [
    160,
    159
], [
    159,
    27
], [
    27,
    160
], [
    204,
    202
], [
    202,
    210
], [
    210,
    204
], [
    113,
    225
], [
    225,
    46
], [
    46,
    113
], [
    43,
    202
], [
    202,
    204
], [
    204,
    43
], [
    62,
    76
], [
    76,
    77
], [
    77,
    62
], [
    137,
    123
], [
    123,
    116
], [
    116,
    137
], [
    41,
    38
], [
    38,
    72
], [
    72,
    41
], [
    203,
    129
], [
    129,
    142
], [
    142,
    203
], [
    64,
    98
], [
    98,
    240
], [
    240,
    64
], [
    49,
    102
], [
    102,
    64
], [
    64,
    49
], [
    41,
    73
], [
    73,
    74
], [
    74,
    41
], [
    212,
    216
], [
    216,
    207
], [
    207,
    212
], [
    42,
    74
], [
    74,
    184
], [
    184,
    42
], [
    169,
    170
], [
    170,
    211
], [
    211,
    169
], [
    170,
    149
], [
    149,
    176
], [
    176,
    170
], [
    105,
    66
], [
    66,
    69
], [
    69,
    105
], [
    122,
    6
], [
    6,
    168
], [
    168,
    122
], [
    123,
    147
], [
    147,
    187
], [
    187,
    123
], [
    96,
    77
], [
    77,
    90
], [
    90,
    96
], [
    65,
    55
], [
    55,
    107
], [
    107,
    65
], [
    89,
    90
], [
    90,
    180
], [
    180,
    89
], [
    101,
    100
], [
    100,
    120
], [
    120,
    101
], [
    63,
    105
], [
    105,
    104
], [
    104,
    63
], [
    93,
    137
], [
    137,
    227
], [
    227,
    93
], [
    15,
    86
], [
    86,
    85
], [
    85,
    15
], [
    129,
    102
], [
    102,
    49
], [
    49,
    129
], [
    14,
    87
], [
    87,
    86
], [
    86,
    14
], [
    55,
    8
], [
    8,
    9
], [
    9,
    55
], [
    100,
    47
], [
    47,
    121
], [
    121,
    100
], [
    145,
    23
], [
    23,
    22
], [
    22,
    145
], [
    88,
    89
], [
    89,
    179
], [
    179,
    88
], [
    6,
    122
], [
    122,
    196
], [
    196,
    6
], [
    88,
    95
], [
    95,
    96
], [
    96,
    88
], [
    138,
    172
], [
    172,
    136
], [
    136,
    138
], [
    215,
    58
], [
    58,
    172
], [
    172,
    215
], [
    115,
    48
], [
    48,
    219
], [
    219,
    115
], [
    42,
    80
], [
    80,
    81
], [
    81,
    42
], [
    195,
    3
], [
    3,
    51
], [
    51,
    195
], [
    43,
    146
], [
    146,
    61
], [
    61,
    43
], [
    171,
    175
], [
    175,
    199
], [
    199,
    171
], [
    81,
    82
], [
    82,
    38
], [
    38,
    81
], [
    53,
    46
], [
    46,
    225
], [
    225,
    53
], [
    144,
    163
], [
    163,
    110
], [
    110,
    144
], [
    52,
    65
], [
    65,
    66
], [
    66,
    52
], [
    229,
    228
], [
    228,
    117
], [
    117,
    229
], [
    34,
    127
], [
    127,
    234
], [
    234,
    34
], [
    107,
    108
], [
    108,
    69
], [
    69,
    107
], [
    109,
    108
], [
    108,
    151
], [
    151,
    109
], [
    48,
    64
], [
    64,
    235
], [
    235,
    48
], [
    62,
    78
], [
    78,
    191
], [
    191,
    62
], [
    129,
    209
], [
    209,
    126
], [
    126,
    129
], [
    111,
    35
], [
    35,
    143
], [
    143,
    111
], [
    117,
    123
], [
    123,
    50
], [
    50,
    117
], [
    222,
    65
], [
    65,
    52
], [
    52,
    222
], [
    19,
    125
], [
    125,
    141
], [
    141,
    19
], [
    221,
    55
], [
    55,
    65
], [
    65,
    221
], [
    3,
    195
], [
    195,
    197
], [
    197,
    3
], [
    25,
    7
], [
    7,
    33
], [
    33,
    25
], [
    220,
    237
], [
    237,
    44
], [
    44,
    220
], [
    70,
    71
], [
    71,
    139
], [
    139,
    70
], [
    122,
    193
], [
    193,
    245
], [
    245,
    122
], [
    247,
    130
], [
    130,
    33
], [
    33,
    247
], [
    71,
    21
], [
    21,
    162
], [
    162,
    71
], [
    170,
    169
], [
    169,
    150
], [
    150,
    170
], [
    188,
    174
], [
    174,
    196
], [
    196,
    188
], [
    216,
    186
], [
    186,
    92
], [
    92,
    216
], [
    2,
    97
], [
    97,
    167
], [
    167,
    2
], [
    141,
    125
], [
    125,
    241
], [
    241,
    141
], [
    164,
    167
], [
    167,
    37
], [
    37,
    164
], [
    72,
    38
], [
    38,
    12
], [
    12,
    72
], [
    38,
    82
], [
    82,
    13
], [
    13,
    38
], [
    63,
    68
], [
    68,
    71
], [
    71,
    63
], [
    226,
    35
], [
    35,
    111
], [
    111,
    226
], [
    101,
    50
], [
    50,
    205
], [
    205,
    101
], [
    206,
    92
], [
    92,
    165
], [
    165,
    206
], [
    209,
    198
], [
    198,
    217
], [
    217,
    209
], [
    165,
    167
], [
    167,
    97
], [
    97,
    165
], [
    220,
    115
], [
    115,
    218
], [
    218,
    220
], [
    133,
    112
], [
    112,
    243
], [
    243,
    133
], [
    239,
    238
], [
    238,
    241
], [
    241,
    239
], [
    214,
    135
], [
    135,
    169
], [
    169,
    214
], [
    190,
    173
], [
    173,
    133
], [
    133,
    190
], [
    171,
    208
], [
    208,
    32
], [
    32,
    171
], [
    125,
    44
], [
    44,
    237
], [
    237,
    125
], [
    86,
    87
], [
    87,
    178
], [
    178,
    86
], [
    85,
    86
], [
    86,
    179
], [
    179,
    85
], [
    84,
    85
], [
    85,
    180
], [
    180,
    84
], [
    83,
    84
], [
    84,
    181
], [
    181,
    83
], [
    201,
    83
], [
    83,
    182
], [
    182,
    201
], [
    137,
    93
], [
    93,
    132
], [
    132,
    137
], [
    76,
    62
], [
    62,
    183
], [
    183,
    76
], [
    61,
    76
], [
    76,
    184
], [
    184,
    61
], [
    57,
    61
], [
    61,
    185
], [
    185,
    57
], [
    212,
    57
], [
    57,
    186
], [
    186,
    212
], [
    214,
    207
], [
    207,
    187
], [
    187,
    214
], [
    34,
    143
], [
    143,
    156
], [
    156,
    34
], [
    79,
    239
], [
    239,
    237
], [
    237,
    79
], [
    123,
    137
], [
    137,
    177
], [
    177,
    123
], [
    44,
    1
], [
    1,
    4
], [
    4,
    44
], [
    201,
    194
], [
    194,
    32
], [
    32,
    201
], [
    64,
    102
], [
    102,
    129
], [
    129,
    64
], [
    213,
    215
], [
    215,
    138
], [
    138,
    213
], [
    59,
    166
], [
    166,
    219
], [
    219,
    59
], [
    242,
    99
], [
    99,
    97
], [
    97,
    242
], [
    2,
    94
], [
    94,
    141
], [
    141,
    2
], [
    75,
    59
], [
    59,
    235
], [
    235,
    75
], [
    24,
    110
], [
    110,
    228
], [
    228,
    24
], [
    25,
    130
], [
    130,
    226
], [
    226,
    25
], [
    23,
    24
], [
    24,
    229
], [
    229,
    23
], [
    22,
    23
], [
    23,
    230
], [
    230,
    22
], [
    26,
    22
], [
    22,
    231
], [
    231,
    26
], [
    112,
    26
], [
    26,
    232
], [
    232,
    112
], [
    189,
    190
], [
    190,
    243
], [
    243,
    189
], [
    221,
    56
], [
    56,
    190
], [
    190,
    221
], [
    28,
    56
], [
    56,
    221
], [
    221,
    28
], [
    27,
    28
], [
    28,
    222
], [
    222,
    27
], [
    29,
    27
], [
    27,
    223
], [
    223,
    29
], [
    30,
    29
], [
    29,
    224
], [
    224,
    30
], [
    247,
    30
], [
    30,
    225
], [
    225,
    247
], [
    238,
    79
], [
    79,
    20
], [
    20,
    238
], [
    166,
    59
], [
    59,
    75
], [
    75,
    166
], [
    60,
    75
], [
    75,
    240
], [
    240,
    60
], [
    147,
    177
], [
    177,
    215
], [
    215,
    147
], [
    20,
    79
], [
    79,
    166
], [
    166,
    20
], [
    187,
    147
], [
    147,
    213
], [
    213,
    187
], [
    112,
    233
], [
    233,
    244
], [
    244,
    112
], [
    233,
    128
], [
    128,
    245
], [
    245,
    233
], [
    128,
    114
], [
    114,
    188
], [
    188,
    128
], [
    114,
    217
], [
    217,
    174
], [
    174,
    114
], [
    131,
    115
], [
    115,
    220
], [
    220,
    131
], [
    217,
    198
], [
    198,
    236
], [
    236,
    217
], [
    198,
    131
], [
    131,
    134
], [
    134,
    198
], [
    177,
    132
], [
    132,
    58
], [
    58,
    177
], [
    143,
    35
], [
    35,
    124
], [
    124,
    143
], [
    110,
    163
], [
    163,
    7
], [
    7,
    110
], [
    228,
    110
], [
    110,
    25
], [
    25,
    228
], [
    356,
    389
], [
    389,
    368
], [
    368,
    356
], [
    11,
    302
], [
    302,
    267
], [
    267,
    11
], [
    452,
    350
], [
    350,
    349
], [
    349,
    452
], [
    302,
    303
], [
    303,
    269
], [
    269,
    302
], [
    357,
    343
], [
    343,
    277
], [
    277,
    357
], [
    452,
    453
], [
    453,
    357
], [
    357,
    452
], [
    333,
    332
], [
    332,
    297
], [
    297,
    333
], [
    175,
    152
], [
    152,
    377
], [
    377,
    175
], [
    347,
    348
], [
    348,
    330
], [
    330,
    347
], [
    303,
    304
], [
    304,
    270
], [
    270,
    303
], [
    9,
    336
], [
    336,
    337
], [
    337,
    9
], [
    278,
    279
], [
    279,
    360
], [
    360,
    278
], [
    418,
    262
], [
    262,
    431
], [
    431,
    418
], [
    304,
    408
], [
    408,
    409
], [
    409,
    304
], [
    310,
    415
], [
    415,
    407
], [
    407,
    310
], [
    270,
    409
], [
    409,
    410
], [
    410,
    270
], [
    450,
    348
], [
    348,
    347
], [
    347,
    450
], [
    422,
    430
], [
    430,
    434
], [
    434,
    422
], [
    313,
    314
], [
    314,
    17
], [
    17,
    313
], [
    306,
    307
], [
    307,
    375
], [
    375,
    306
], [
    387,
    388
], [
    388,
    260
], [
    260,
    387
], [
    286,
    414
], [
    414,
    398
], [
    398,
    286
], [
    335,
    406
], [
    406,
    418
], [
    418,
    335
], [
    364,
    367
], [
    367,
    416
], [
    416,
    364
], [
    423,
    358
], [
    358,
    327
], [
    327,
    423
], [
    251,
    284
], [
    284,
    298
], [
    298,
    251
], [
    281,
    5
], [
    5,
    4
], [
    4,
    281
], [
    373,
    374
], [
    374,
    253
], [
    253,
    373
], [
    307,
    320
], [
    320,
    321
], [
    321,
    307
], [
    425,
    427
], [
    427,
    411
], [
    411,
    425
], [
    421,
    313
], [
    313,
    18
], [
    18,
    421
], [
    321,
    405
], [
    405,
    406
], [
    406,
    321
], [
    320,
    404
], [
    404,
    405
], [
    405,
    320
], [
    315,
    16
], [
    16,
    17
], [
    17,
    315
], [
    426,
    425
], [
    425,
    266
], [
    266,
    426
], [
    377,
    400
], [
    400,
    369
], [
    369,
    377
], [
    322,
    391
], [
    391,
    269
], [
    269,
    322
], [
    417,
    465
], [
    465,
    464
], [
    464,
    417
], [
    386,
    257
], [
    257,
    258
], [
    258,
    386
], [
    466,
    260
], [
    260,
    388
], [
    388,
    466
], [
    456,
    399
], [
    399,
    419
], [
    419,
    456
], [
    284,
    332
], [
    332,
    333
], [
    333,
    284
], [
    417,
    285
], [
    285,
    8
], [
    8,
    417
], [
    346,
    340
], [
    340,
    261
], [
    261,
    346
], [
    413,
    441
], [
    441,
    285
], [
    285,
    413
], [
    327,
    460
], [
    460,
    328
], [
    328,
    327
], [
    355,
    371
], [
    371,
    329
], [
    329,
    355
], [
    392,
    439
], [
    439,
    438
], [
    438,
    392
], [
    382,
    341
], [
    341,
    256
], [
    256,
    382
], [
    429,
    420
], [
    420,
    360
], [
    360,
    429
], [
    364,
    394
], [
    394,
    379
], [
    379,
    364
], [
    277,
    343
], [
    343,
    437
], [
    437,
    277
], [
    443,
    444
], [
    444,
    283
], [
    283,
    443
], [
    275,
    440
], [
    440,
    363
], [
    363,
    275
], [
    431,
    262
], [
    262,
    369
], [
    369,
    431
], [
    297,
    338
], [
    338,
    337
], [
    337,
    297
], [
    273,
    375
], [
    375,
    321
], [
    321,
    273
], [
    450,
    451
], [
    451,
    349
], [
    349,
    450
], [
    446,
    342
], [
    342,
    467
], [
    467,
    446
], [
    293,
    334
], [
    334,
    282
], [
    282,
    293
], [
    458,
    461
], [
    461,
    462
], [
    462,
    458
], [
    276,
    353
], [
    353,
    383
], [
    383,
    276
], [
    308,
    324
], [
    324,
    325
], [
    325,
    308
], [
    276,
    300
], [
    300,
    293
], [
    293,
    276
], [
    372,
    345
], [
    345,
    447
], [
    447,
    372
], [
    352,
    345
], [
    345,
    340
], [
    340,
    352
], [
    274,
    1
], [
    1,
    19
], [
    19,
    274
], [
    456,
    248
], [
    248,
    281
], [
    281,
    456
], [
    436,
    427
], [
    427,
    425
], [
    425,
    436
], [
    381,
    256
], [
    256,
    252
], [
    252,
    381
], [
    269,
    391
], [
    391,
    393
], [
    393,
    269
], [
    200,
    199
], [
    199,
    428
], [
    428,
    200
], [
    266,
    330
], [
    330,
    329
], [
    329,
    266
], [
    287,
    273
], [
    273,
    422
], [
    422,
    287
], [
    250,
    462
], [
    462,
    328
], [
    328,
    250
], [
    258,
    286
], [
    286,
    384
], [
    384,
    258
], [
    265,
    353
], [
    353,
    342
], [
    342,
    265
], [
    387,
    259
], [
    259,
    257
], [
    257,
    387
], [
    424,
    431
], [
    431,
    430
], [
    430,
    424
], [
    342,
    353
], [
    353,
    276
], [
    276,
    342
], [
    273,
    335
], [
    335,
    424
], [
    424,
    273
], [
    292,
    325
], [
    325,
    307
], [
    307,
    292
], [
    366,
    447
], [
    447,
    345
], [
    345,
    366
], [
    271,
    303
], [
    303,
    302
], [
    302,
    271
], [
    423,
    266
], [
    266,
    371
], [
    371,
    423
], [
    294,
    455
], [
    455,
    460
], [
    460,
    294
], [
    279,
    278
], [
    278,
    294
], [
    294,
    279
], [
    271,
    272
], [
    272,
    304
], [
    304,
    271
], [
    432,
    434
], [
    434,
    427
], [
    427,
    432
], [
    272,
    407
], [
    407,
    408
], [
    408,
    272
], [
    394,
    430
], [
    430,
    431
], [
    431,
    394
], [
    395,
    369
], [
    369,
    400
], [
    400,
    395
], [
    334,
    333
], [
    333,
    299
], [
    299,
    334
], [
    351,
    417
], [
    417,
    168
], [
    168,
    351
], [
    352,
    280
], [
    280,
    411
], [
    411,
    352
], [
    325,
    319
], [
    319,
    320
], [
    320,
    325
], [
    295,
    296
], [
    296,
    336
], [
    336,
    295
], [
    319,
    403
], [
    403,
    404
], [
    404,
    319
], [
    330,
    348
], [
    348,
    349
], [
    349,
    330
], [
    293,
    298
], [
    298,
    333
], [
    333,
    293
], [
    323,
    454
], [
    454,
    447
], [
    447,
    323
], [
    15,
    16
], [
    16,
    315
], [
    315,
    15
], [
    358,
    429
], [
    429,
    279
], [
    279,
    358
], [
    14,
    15
], [
    15,
    316
], [
    316,
    14
], [
    285,
    336
], [
    336,
    9
], [
    9,
    285
], [
    329,
    349
], [
    349,
    350
], [
    350,
    329
], [
    374,
    380
], [
    380,
    252
], [
    252,
    374
], [
    318,
    402
], [
    402,
    403
], [
    403,
    318
], [
    6,
    197
], [
    197,
    419
], [
    419,
    6
], [
    318,
    319
], [
    319,
    325
], [
    325,
    318
], [
    367,
    364
], [
    364,
    365
], [
    365,
    367
], [
    435,
    367
], [
    367,
    397
], [
    397,
    435
], [
    344,
    438
], [
    438,
    439
], [
    439,
    344
], [
    272,
    271
], [
    271,
    311
], [
    311,
    272
], [
    195,
    5
], [
    5,
    281
], [
    281,
    195
], [
    273,
    287
], [
    287,
    291
], [
    291,
    273
], [
    396,
    428
], [
    428,
    199
], [
    199,
    396
], [
    311,
    271
], [
    271,
    268
], [
    268,
    311
], [
    283,
    444
], [
    444,
    445
], [
    445,
    283
], [
    373,
    254
], [
    254,
    339
], [
    339,
    373
], [
    282,
    334
], [
    334,
    296
], [
    296,
    282
], [
    449,
    347
], [
    347,
    346
], [
    346,
    449
], [
    264,
    447
], [
    447,
    454
], [
    454,
    264
], [
    336,
    296
], [
    296,
    299
], [
    299,
    336
], [
    338,
    10
], [
    10,
    151
], [
    151,
    338
], [
    278,
    439
], [
    439,
    455
], [
    455,
    278
], [
    292,
    407
], [
    407,
    415
], [
    415,
    292
], [
    358,
    371
], [
    371,
    355
], [
    355,
    358
], [
    340,
    345
], [
    345,
    372
], [
    372,
    340
], [
    346,
    347
], [
    347,
    280
], [
    280,
    346
], [
    442,
    443
], [
    443,
    282
], [
    282,
    442
], [
    19,
    94
], [
    94,
    370
], [
    370,
    19
], [
    441,
    442
], [
    442,
    295
], [
    295,
    441
], [
    248,
    419
], [
    419,
    197
], [
    197,
    248
], [
    263,
    255
], [
    255,
    359
], [
    359,
    263
], [
    440,
    275
], [
    275,
    274
], [
    274,
    440
], [
    300,
    383
], [
    383,
    368
], [
    368,
    300
], [
    351,
    412
], [
    412,
    465
], [
    465,
    351
], [
    263,
    467
], [
    467,
    466
], [
    466,
    263
], [
    301,
    368
], [
    368,
    389
], [
    389,
    301
], [
    395,
    378
], [
    378,
    379
], [
    379,
    395
], [
    412,
    351
], [
    351,
    419
], [
    419,
    412
], [
    436,
    426
], [
    426,
    322
], [
    322,
    436
], [
    2,
    164
], [
    164,
    393
], [
    393,
    2
], [
    370,
    462
], [
    462,
    461
], [
    461,
    370
], [
    164,
    0
], [
    0,
    267
], [
    267,
    164
], [
    302,
    11
], [
    11,
    12
], [
    12,
    302
], [
    268,
    12
], [
    12,
    13
], [
    13,
    268
], [
    293,
    300
], [
    300,
    301
], [
    301,
    293
], [
    446,
    261
], [
    261,
    340
], [
    340,
    446
], [
    330,
    266
], [
    266,
    425
], [
    425,
    330
], [
    426,
    423
], [
    423,
    391
], [
    391,
    426
], [
    429,
    355
], [
    355,
    437
], [
    437,
    429
], [
    391,
    327
], [
    327,
    326
], [
    326,
    391
], [
    440,
    457
], [
    457,
    438
], [
    438,
    440
], [
    341,
    382
], [
    382,
    362
], [
    362,
    341
], [
    459,
    457
], [
    457,
    461
], [
    461,
    459
], [
    434,
    430
], [
    430,
    394
], [
    394,
    434
], [
    414,
    463
], [
    463,
    362
], [
    362,
    414
], [
    396,
    369
], [
    369,
    262
], [
    262,
    396
], [
    354,
    461
], [
    461,
    457
], [
    457,
    354
], [
    316,
    403
], [
    403,
    402
], [
    402,
    316
], [
    315,
    404
], [
    404,
    403
], [
    403,
    315
], [
    314,
    405
], [
    405,
    404
], [
    404,
    314
], [
    313,
    406
], [
    406,
    405
], [
    405,
    313
], [
    421,
    418
], [
    418,
    406
], [
    406,
    421
], [
    366,
    401
], [
    401,
    361
], [
    361,
    366
], [
    306,
    408
], [
    408,
    407
], [
    407,
    306
], [
    291,
    409
], [
    409,
    408
], [
    408,
    291
], [
    287,
    410
], [
    410,
    409
], [
    409,
    287
], [
    432,
    436
], [
    436,
    410
], [
    410,
    432
], [
    434,
    416
], [
    416,
    411
], [
    411,
    434
], [
    264,
    368
], [
    368,
    383
], [
    383,
    264
], [
    309,
    438
], [
    438,
    457
], [
    457,
    309
], [
    352,
    376
], [
    376,
    401
], [
    401,
    352
], [
    274,
    275
], [
    275,
    4
], [
    4,
    274
], [
    421,
    428
], [
    428,
    262
], [
    262,
    421
], [
    294,
    327
], [
    327,
    358
], [
    358,
    294
], [
    433,
    416
], [
    416,
    367
], [
    367,
    433
], [
    289,
    455
], [
    455,
    439
], [
    439,
    289
], [
    462,
    370
], [
    370,
    326
], [
    326,
    462
], [
    2,
    326
], [
    326,
    370
], [
    370,
    2
], [
    305,
    460
], [
    460,
    455
], [
    455,
    305
], [
    254,
    449
], [
    449,
    448
], [
    448,
    254
], [
    255,
    261
], [
    261,
    446
], [
    446,
    255
], [
    253,
    450
], [
    450,
    449
], [
    449,
    253
], [
    252,
    451
], [
    451,
    450
], [
    450,
    252
], [
    256,
    452
], [
    452,
    451
], [
    451,
    256
], [
    341,
    453
], [
    453,
    452
], [
    452,
    341
], [
    413,
    464
], [
    464,
    463
], [
    463,
    413
], [
    441,
    413
], [
    413,
    414
], [
    414,
    441
], [
    258,
    442
], [
    442,
    441
], [
    441,
    258
], [
    257,
    443
], [
    443,
    442
], [
    442,
    257
], [
    259,
    444
], [
    444,
    443
], [
    443,
    259
], [
    260,
    445
], [
    445,
    444
], [
    444,
    260
], [
    467,
    342
], [
    342,
    445
], [
    445,
    467
], [
    459,
    458
], [
    458,
    250
], [
    250,
    459
], [
    289,
    392
], [
    392,
    290
], [
    290,
    289
], [
    290,
    328
], [
    328,
    460
], [
    460,
    290
], [
    376,
    433
], [
    433,
    435
], [
    435,
    376
], [
    250,
    290
], [
    290,
    392
], [
    392,
    250
], [
    411,
    416
], [
    416,
    433
], [
    433,
    411
], [
    341,
    463
], [
    463,
    464
], [
    464,
    341
], [
    453,
    464
], [
    464,
    465
], [
    465,
    453
], [
    357,
    465
], [
    465,
    412
], [
    412,
    357
], [
    343,
    412
], [
    412,
    399
], [
    399,
    343
], [
    360,
    363
], [
    363,
    440
], [
    440,
    360
], [
    437,
    399
], [
    399,
    456
], [
    456,
    437
], [
    420,
    456
], [
    456,
    363
], [
    363,
    420
], [
    401,
    435
], [
    435,
    288
], [
    288,
    401
], [
    372,
    383
], [
    383,
    353
], [
    353,
    372
], [
    339,
    255
], [
    255,
    249
], [
    249,
    339
], [
    448,
    261
], [
    261,
    255
], [
    255,
    448
], [
    133,
    243
], [
    243,
    190
], [
    190,
    133
], [
    133,
    155
], [
    155,
    112
], [
    112,
    133
], [
    33,
    246
], [
    246,
    247
], [
    247,
    33
], [
    33,
    130
], [
    130,
    25
], [
    25,
    33
], [
    398,
    384
], [
    384,
    286
], [
    286,
    398
], [
    362,
    398
], [
    398,
    414
], [
    414,
    362
], [
    362,
    463
], [
    463,
    341
], [
    341,
    362
], [
    263,
    359
], [
    359,
    467
], [
    467,
    263
], [
    263,
    249
], [
    249,
    255
], [
    255,
    263
], [
    466,
    467
], [
    467,
    260
], [
    260,
    466
], [
    75,
    60
], [
    60,
    166
], [
    166,
    75
], [
    238,
    239
], [
    239,
    79
], [
    79,
    238
], [
    162,
    127
], [
    127,
    139
], [
    139,
    162
], [
    72,
    11
], [
    11,
    37
], [
    37,
    72
], [
    121,
    232
], [
    232,
    120
], [
    120,
    121
], [
    73,
    72
], [
    72,
    39
], [
    39,
    73
], [
    114,
    128
], [
    128,
    47
], [
    47,
    114
], [
    233,
    232
], [
    232,
    128
], [
    128,
    233
], [
    103,
    104
], [
    104,
    67
], [
    67,
    103
], [
    152,
    175
], [
    175,
    148
], [
    148,
    152
], [
    119,
    118
], [
    118,
    101
], [
    101,
    119
], [
    74,
    73
], [
    73,
    40
], [
    40,
    74
], [
    107,
    9
], [
    9,
    108
], [
    108,
    107
], [
    49,
    48
], [
    48,
    131
], [
    131,
    49
], [
    32,
    194
], [
    194,
    211
], [
    211,
    32
], [
    184,
    74
], [
    74,
    185
], [
    185,
    184
], [
    191,
    80
], [
    80,
    183
], [
    183,
    191
], [
    185,
    40
], [
    40,
    186
], [
    186,
    185
], [
    119,
    230
], [
    230,
    118
], [
    118,
    119
], [
    210,
    202
], [
    202,
    214
], [
    214,
    210
], [
    84,
    83
], [
    83,
    17
], [
    17,
    84
], [
    77,
    76
], [
    76,
    146
], [
    146,
    77
], [
    161,
    160
], [
    160,
    30
], [
    30,
    161
], [
    190,
    56
], [
    56,
    173
], [
    173,
    190
], [
    182,
    106
], [
    106,
    194
], [
    194,
    182
], [
    138,
    135
], [
    135,
    192
], [
    192,
    138
], [
    129,
    203
], [
    203,
    98
], [
    98,
    129
], [
    54,
    21
], [
    21,
    68
], [
    68,
    54
], [
    5,
    51
], [
    51,
    4
], [
    4,
    5
], [
    145,
    144
], [
    144,
    23
], [
    23,
    145
], [
    90,
    77
], [
    77,
    91
], [
    91,
    90
], [
    207,
    205
], [
    205,
    187
], [
    187,
    207
], [
    83,
    201
], [
    201,
    18
], [
    18,
    83
], [
    181,
    91
], [
    91,
    182
], [
    182,
    181
], [
    180,
    90
], [
    90,
    181
], [
    181,
    180
], [
    16,
    85
], [
    85,
    17
], [
    17,
    16
], [
    205,
    206
], [
    206,
    36
], [
    36,
    205
], [
    176,
    148
], [
    148,
    140
], [
    140,
    176
], [
    165,
    92
], [
    92,
    39
], [
    39,
    165
], [
    245,
    193
], [
    193,
    244
], [
    244,
    245
], [
    27,
    159
], [
    159,
    28
], [
    28,
    27
], [
    30,
    247
], [
    247,
    161
], [
    161,
    30
], [
    174,
    236
], [
    236,
    196
], [
    196,
    174
], [
    103,
    54
], [
    54,
    104
], [
    104,
    103
], [
    55,
    193
], [
    193,
    8
], [
    8,
    55
], [
    111,
    117
], [
    117,
    31
], [
    31,
    111
], [
    221,
    189
], [
    189,
    55
], [
    55,
    221
], [
    240,
    98
], [
    98,
    99
], [
    99,
    240
], [
    142,
    126
], [
    126,
    100
], [
    100,
    142
], [
    219,
    166
], [
    166,
    218
], [
    218,
    219
], [
    112,
    155
], [
    155,
    26
], [
    26,
    112
], [
    198,
    209
], [
    209,
    131
], [
    131,
    198
], [
    169,
    135
], [
    135,
    150
], [
    150,
    169
], [
    114,
    47
], [
    47,
    217
], [
    217,
    114
], [
    224,
    223
], [
    223,
    53
], [
    53,
    224
], [
    220,
    45
], [
    45,
    134
], [
    134,
    220
], [
    32,
    211
], [
    211,
    140
], [
    140,
    32
], [
    109,
    67
], [
    67,
    108
], [
    108,
    109
], [
    146,
    43
], [
    43,
    91
], [
    91,
    146
], [
    231,
    230
], [
    230,
    120
], [
    120,
    231
], [
    113,
    226
], [
    226,
    247
], [
    247,
    113
], [
    105,
    63
], [
    63,
    52
], [
    52,
    105
], [
    241,
    238
], [
    238,
    242
], [
    242,
    241
], [
    124,
    46
], [
    46,
    156
], [
    156,
    124
], [
    95,
    78
], [
    78,
    96
], [
    96,
    95
], [
    70,
    46
], [
    46,
    63
], [
    63,
    70
], [
    116,
    143
], [
    143,
    227
], [
    227,
    116
], [
    116,
    123
], [
    123,
    111
], [
    111,
    116
], [
    1,
    44
], [
    44,
    19
], [
    19,
    1
], [
    3,
    236
], [
    236,
    51
], [
    51,
    3
], [
    207,
    216
], [
    216,
    205
], [
    205,
    207
], [
    26,
    154
], [
    154,
    22
], [
    22,
    26
], [
    165,
    39
], [
    39,
    167
], [
    167,
    165
], [
    199,
    200
], [
    200,
    208
], [
    208,
    199
], [
    101,
    36
], [
    36,
    100
], [
    100,
    101
], [
    43,
    57
], [
    57,
    202
], [
    202,
    43
], [
    242,
    20
], [
    20,
    99
], [
    99,
    242
], [
    56,
    28
], [
    28,
    157
], [
    157,
    56
], [
    124,
    35
], [
    35,
    113
], [
    113,
    124
], [
    29,
    160
], [
    160,
    27
], [
    27,
    29
], [
    211,
    204
], [
    204,
    210
], [
    210,
    211
], [
    124,
    113
], [
    113,
    46
], [
    46,
    124
], [
    106,
    43
], [
    43,
    204
], [
    204,
    106
], [
    96,
    62
], [
    62,
    77
], [
    77,
    96
], [
    227,
    137
], [
    137,
    116
], [
    116,
    227
], [
    73,
    41
], [
    41,
    72
], [
    72,
    73
], [
    36,
    203
], [
    203,
    142
], [
    142,
    36
], [
    235,
    64
], [
    64,
    240
], [
    240,
    235
], [
    48,
    49
], [
    49,
    64
], [
    64,
    48
], [
    42,
    41
], [
    41,
    74
], [
    74,
    42
], [
    214,
    212
], [
    212,
    207
], [
    207,
    214
], [
    183,
    42
], [
    42,
    184
], [
    184,
    183
], [
    210,
    169
], [
    169,
    211
], [
    211,
    210
], [
    140,
    170
], [
    170,
    176
], [
    176,
    140
], [
    104,
    105
], [
    105,
    69
], [
    69,
    104
], [
    193,
    122
], [
    122,
    168
], [
    168,
    193
], [
    50,
    123
], [
    123,
    187
], [
    187,
    50
], [
    89,
    96
], [
    96,
    90
], [
    90,
    89
], [
    66,
    65
], [
    65,
    107
], [
    107,
    66
], [
    179,
    89
], [
    89,
    180
], [
    180,
    179
], [
    119,
    101
], [
    101,
    120
], [
    120,
    119
], [
    68,
    63
], [
    63,
    104
], [
    104,
    68
], [
    234,
    93
], [
    93,
    227
], [
    227,
    234
], [
    16,
    15
], [
    15,
    85
], [
    85,
    16
], [
    209,
    129
], [
    129,
    49
], [
    49,
    209
], [
    15,
    14
], [
    14,
    86
], [
    86,
    15
], [
    107,
    55
], [
    55,
    9
], [
    9,
    107
], [
    120,
    100
], [
    100,
    121
], [
    121,
    120
], [
    153,
    145
], [
    145,
    22
], [
    22,
    153
], [
    178,
    88
], [
    88,
    179
], [
    179,
    178
], [
    197,
    6
], [
    6,
    196
], [
    196,
    197
], [
    89,
    88
], [
    88,
    96
], [
    96,
    89
], [
    135,
    138
], [
    138,
    136
], [
    136,
    135
], [
    138,
    215
], [
    215,
    172
], [
    172,
    138
], [
    218,
    115
], [
    115,
    219
], [
    219,
    218
], [
    41,
    42
], [
    42,
    81
], [
    81,
    41
], [
    5,
    195
], [
    195,
    51
], [
    51,
    5
], [
    57,
    43
], [
    43,
    61
], [
    61,
    57
], [
    208,
    171
], [
    171,
    199
], [
    199,
    208
], [
    41,
    81
], [
    81,
    38
], [
    38,
    41
], [
    224,
    53
], [
    53,
    225
], [
    225,
    224
], [
    24,
    144
], [
    144,
    110
], [
    110,
    24
], [
    105,
    52
], [
    52,
    66
], [
    66,
    105
], [
    118,
    229
], [
    229,
    117
], [
    117,
    118
], [
    227,
    34
], [
    34,
    234
], [
    234,
    227
], [
    66,
    107
], [
    107,
    69
], [
    69,
    66
], [
    10,
    109
], [
    109,
    151
], [
    151,
    10
], [
    219,
    48
], [
    48,
    235
], [
    235,
    219
], [
    183,
    62
], [
    62,
    191
], [
    191,
    183
], [
    142,
    129
], [
    129,
    126
], [
    126,
    142
], [
    116,
    111
], [
    111,
    143
], [
    143,
    116
], [
    118,
    117
], [
    117,
    50
], [
    50,
    118
], [
    223,
    222
], [
    222,
    52
], [
    52,
    223
], [
    94,
    19
], [
    19,
    141
], [
    141,
    94
], [
    222,
    221
], [
    221,
    65
], [
    65,
    222
], [
    196,
    3
], [
    3,
    197
], [
    197,
    196
], [
    45,
    220
], [
    220,
    44
], [
    44,
    45
], [
    156,
    70
], [
    70,
    139
], [
    139,
    156
], [
    188,
    122
], [
    122,
    245
], [
    245,
    188
], [
    139,
    71
], [
    71,
    162
], [
    162,
    139
], [
    149,
    170
], [
    170,
    150
], [
    150,
    149
], [
    122,
    188
], [
    188,
    196
], [
    196,
    122
], [
    206,
    216
], [
    216,
    92
], [
    92,
    206
], [
    164,
    2
], [
    2,
    167
], [
    167,
    164
], [
    242,
    141
], [
    141,
    241
], [
    241,
    242
], [
    0,
    164
], [
    164,
    37
], [
    37,
    0
], [
    11,
    72
], [
    72,
    12
], [
    12,
    11
], [
    12,
    38
], [
    38,
    13
], [
    13,
    12
], [
    70,
    63
], [
    63,
    71
], [
    71,
    70
], [
    31,
    226
], [
    226,
    111
], [
    111,
    31
], [
    36,
    101
], [
    101,
    205
], [
    205,
    36
], [
    203,
    206
], [
    206,
    165
], [
    165,
    203
], [
    126,
    209
], [
    209,
    217
], [
    217,
    126
], [
    98,
    165
], [
    165,
    97
], [
    97,
    98
], [
    237,
    220
], [
    220,
    218
], [
    218,
    237
], [
    237,
    239
], [
    239,
    241
], [
    241,
    237
], [
    210,
    214
], [
    214,
    169
], [
    169,
    210
], [
    140,
    171
], [
    171,
    32
], [
    32,
    140
], [
    241,
    125
], [
    125,
    237
], [
    237,
    241
], [
    179,
    86
], [
    86,
    178
], [
    178,
    179
], [
    180,
    85
], [
    85,
    179
], [
    179,
    180
], [
    181,
    84
], [
    84,
    180
], [
    180,
    181
], [
    182,
    83
], [
    83,
    181
], [
    181,
    182
], [
    194,
    201
], [
    201,
    182
], [
    182,
    194
], [
    177,
    137
], [
    137,
    132
], [
    132,
    177
], [
    184,
    76
], [
    76,
    183
], [
    183,
    184
], [
    185,
    61
], [
    61,
    184
], [
    184,
    185
], [
    186,
    57
], [
    57,
    185
], [
    185,
    186
], [
    216,
    212
], [
    212,
    186
], [
    186,
    216
], [
    192,
    214
], [
    214,
    187
], [
    187,
    192
], [
    139,
    34
], [
    34,
    156
], [
    156,
    139
], [
    218,
    79
], [
    79,
    237
], [
    237,
    218
], [
    147,
    123
], [
    123,
    177
], [
    177,
    147
], [
    45,
    44
], [
    44,
    4
], [
    4,
    45
], [
    208,
    201
], [
    201,
    32
], [
    32,
    208
], [
    98,
    64
], [
    64,
    129
], [
    129,
    98
], [
    192,
    213
], [
    213,
    138
], [
    138,
    192
], [
    235,
    59
], [
    59,
    219
], [
    219,
    235
], [
    141,
    242
], [
    242,
    97
], [
    97,
    141
], [
    97,
    2
], [
    2,
    141
], [
    141,
    97
], [
    240,
    75
], [
    75,
    235
], [
    235,
    240
], [
    229,
    24
], [
    24,
    228
], [
    228,
    229
], [
    31,
    25
], [
    25,
    226
], [
    226,
    31
], [
    230,
    23
], [
    23,
    229
], [
    229,
    230
], [
    231,
    22
], [
    22,
    230
], [
    230,
    231
], [
    232,
    26
], [
    26,
    231
], [
    231,
    232
], [
    233,
    112
], [
    112,
    232
], [
    232,
    233
], [
    244,
    189
], [
    189,
    243
], [
    243,
    244
], [
    189,
    221
], [
    221,
    190
], [
    190,
    189
], [
    222,
    28
], [
    28,
    221
], [
    221,
    222
], [
    223,
    27
], [
    27,
    222
], [
    222,
    223
], [
    224,
    29
], [
    29,
    223
], [
    223,
    224
], [
    225,
    30
], [
    30,
    224
], [
    224,
    225
], [
    113,
    247
], [
    247,
    225
], [
    225,
    113
], [
    99,
    60
], [
    60,
    240
], [
    240,
    99
], [
    213,
    147
], [
    147,
    215
], [
    215,
    213
], [
    60,
    20
], [
    20,
    166
], [
    166,
    60
], [
    192,
    187
], [
    187,
    213
], [
    213,
    192
], [
    243,
    112
], [
    112,
    244
], [
    244,
    243
], [
    244,
    233
], [
    233,
    245
], [
    245,
    244
], [
    245,
    128
], [
    128,
    188
], [
    188,
    245
], [
    188,
    114
], [
    114,
    174
], [
    174,
    188
], [
    134,
    131
], [
    131,
    220
], [
    220,
    134
], [
    174,
    217
], [
    217,
    236
], [
    236,
    174
], [
    236,
    198
], [
    198,
    134
], [
    134,
    236
], [
    215,
    177
], [
    177,
    58
], [
    58,
    215
], [
    156,
    143
], [
    143,
    124
], [
    124,
    156
], [
    25,
    110
], [
    110,
    7
], [
    7,
    25
], [
    31,
    228
], [
    228,
    25
], [
    25,
    31
], [
    264,
    356
], [
    356,
    368
], [
    368,
    264
], [
    0,
    11
], [
    11,
    267
], [
    267,
    0
], [
    451,
    452
], [
    452,
    349
], [
    349,
    451
], [
    267,
    302
], [
    302,
    269
], [
    269,
    267
], [
    350,
    357
], [
    357,
    277
], [
    277,
    350
], [
    350,
    452
], [
    452,
    357
], [
    357,
    350
], [
    299,
    333
], [
    333,
    297
], [
    297,
    299
], [
    396,
    175
], [
    175,
    377
], [
    377,
    396
], [
    280,
    347
], [
    347,
    330
], [
    330,
    280
], [
    269,
    303
], [
    303,
    270
], [
    270,
    269
], [
    151,
    9
], [
    9,
    337
], [
    337,
    151
], [
    344,
    278
], [
    278,
    360
], [
    360,
    344
], [
    424,
    418
], [
    418,
    431
], [
    431,
    424
], [
    270,
    304
], [
    304,
    409
], [
    409,
    270
], [
    272,
    310
], [
    310,
    407
], [
    407,
    272
], [
    322,
    270
], [
    270,
    410
], [
    410,
    322
], [
    449,
    450
], [
    450,
    347
], [
    347,
    449
], [
    432,
    422
], [
    422,
    434
], [
    434,
    432
], [
    18,
    313
], [
    313,
    17
], [
    17,
    18
], [
    291,
    306
], [
    306,
    375
], [
    375,
    291
], [
    259,
    387
], [
    387,
    260
], [
    260,
    259
], [
    424,
    335
], [
    335,
    418
], [
    418,
    424
], [
    434,
    364
], [
    364,
    416
], [
    416,
    434
], [
    391,
    423
], [
    423,
    327
], [
    327,
    391
], [
    301,
    251
], [
    251,
    298
], [
    298,
    301
], [
    275,
    281
], [
    281,
    4
], [
    4,
    275
], [
    254,
    373
], [
    373,
    253
], [
    253,
    254
], [
    375,
    307
], [
    307,
    321
], [
    321,
    375
], [
    280,
    425
], [
    425,
    411
], [
    411,
    280
], [
    200,
    421
], [
    421,
    18
], [
    18,
    200
], [
    335,
    321
], [
    321,
    406
], [
    406,
    335
], [
    321,
    320
], [
    320,
    405
], [
    405,
    321
], [
    314,
    315
], [
    315,
    17
], [
    17,
    314
], [
    423,
    426
], [
    426,
    266
], [
    266,
    423
], [
    396,
    377
], [
    377,
    369
], [
    369,
    396
], [
    270,
    322
], [
    322,
    269
], [
    269,
    270
], [
    413,
    417
], [
    417,
    464
], [
    464,
    413
], [
    385,
    386
], [
    386,
    258
], [
    258,
    385
], [
    248,
    456
], [
    456,
    419
], [
    419,
    248
], [
    298,
    284
], [
    284,
    333
], [
    333,
    298
], [
    168,
    417
], [
    417,
    8
], [
    8,
    168
], [
    448,
    346
], [
    346,
    261
], [
    261,
    448
], [
    417,
    413
], [
    413,
    285
], [
    285,
    417
], [
    326,
    327
], [
    327,
    328
], [
    328,
    326
], [
    277,
    355
], [
    355,
    329
], [
    329,
    277
], [
    309,
    392
], [
    392,
    438
], [
    438,
    309
], [
    381,
    382
], [
    382,
    256
], [
    256,
    381
], [
    279,
    429
], [
    429,
    360
], [
    360,
    279
], [
    365,
    364
], [
    364,
    379
], [
    379,
    365
], [
    355,
    277
], [
    277,
    437
], [
    437,
    355
], [
    282,
    443
], [
    443,
    283
], [
    283,
    282
], [
    281,
    275
], [
    275,
    363
], [
    363,
    281
], [
    395,
    431
], [
    431,
    369
], [
    369,
    395
], [
    299,
    297
], [
    297,
    337
], [
    337,
    299
], [
    335,
    273
], [
    273,
    321
], [
    321,
    335
], [
    348,
    450
], [
    450,
    349
], [
    349,
    348
], [
    359,
    446
], [
    446,
    467
], [
    467,
    359
], [
    283,
    293
], [
    293,
    282
], [
    282,
    283
], [
    250,
    458
], [
    458,
    462
], [
    462,
    250
], [
    300,
    276
], [
    276,
    383
], [
    383,
    300
], [
    292,
    308
], [
    308,
    325
], [
    325,
    292
], [
    283,
    276
], [
    276,
    293
], [
    293,
    283
], [
    264,
    372
], [
    372,
    447
], [
    447,
    264
], [
    346,
    352
], [
    352,
    340
], [
    340,
    346
], [
    354,
    274
], [
    274,
    19
], [
    19,
    354
], [
    363,
    456
], [
    456,
    281
], [
    281,
    363
], [
    426,
    436
], [
    436,
    425
], [
    425,
    426
], [
    380,
    381
], [
    381,
    252
], [
    252,
    380
], [
    267,
    269
], [
    269,
    393
], [
    393,
    267
], [
    421,
    200
], [
    200,
    428
], [
    428,
    421
], [
    371,
    266
], [
    266,
    329
], [
    329,
    371
], [
    432,
    287
], [
    287,
    422
], [
    422,
    432
], [
    290,
    250
], [
    250,
    328
], [
    328,
    290
], [
    385,
    258
], [
    258,
    384
], [
    384,
    385
], [
    446,
    265
], [
    265,
    342
], [
    342,
    446
], [
    386,
    387
], [
    387,
    257
], [
    257,
    386
], [
    422,
    424
], [
    424,
    430
], [
    430,
    422
], [
    445,
    342
], [
    342,
    276
], [
    276,
    445
], [
    422,
    273
], [
    273,
    424
], [
    424,
    422
], [
    306,
    292
], [
    292,
    307
], [
    307,
    306
], [
    352,
    366
], [
    366,
    345
], [
    345,
    352
], [
    268,
    271
], [
    271,
    302
], [
    302,
    268
], [
    358,
    423
], [
    423,
    371
], [
    371,
    358
], [
    327,
    294
], [
    294,
    460
], [
    460,
    327
], [
    331,
    279
], [
    279,
    294
], [
    294,
    331
], [
    303,
    271
], [
    271,
    304
], [
    304,
    303
], [
    436,
    432
], [
    432,
    427
], [
    427,
    436
], [
    304,
    272
], [
    272,
    408
], [
    408,
    304
], [
    395,
    394
], [
    394,
    431
], [
    431,
    395
], [
    378,
    395
], [
    395,
    400
], [
    400,
    378
], [
    296,
    334
], [
    334,
    299
], [
    299,
    296
], [
    6,
    351
], [
    351,
    168
], [
    168,
    6
], [
    376,
    352
], [
    352,
    411
], [
    411,
    376
], [
    307,
    325
], [
    325,
    320
], [
    320,
    307
], [
    285,
    295
], [
    295,
    336
], [
    336,
    285
], [
    320,
    319
], [
    319,
    404
], [
    404,
    320
], [
    329,
    330
], [
    330,
    349
], [
    349,
    329
], [
    334,
    293
], [
    293,
    333
], [
    333,
    334
], [
    366,
    323
], [
    323,
    447
], [
    447,
    366
], [
    316,
    15
], [
    15,
    315
], [
    315,
    316
], [
    331,
    358
], [
    358,
    279
], [
    279,
    331
], [
    317,
    14
], [
    14,
    316
], [
    316,
    317
], [
    8,
    285
], [
    285,
    9
], [
    9,
    8
], [
    277,
    329
], [
    329,
    350
], [
    350,
    277
], [
    253,
    374
], [
    374,
    252
], [
    252,
    253
], [
    319,
    318
], [
    318,
    403
], [
    403,
    319
], [
    351,
    6
], [
    6,
    419
], [
    419,
    351
], [
    324,
    318
], [
    318,
    325
], [
    325,
    324
], [
    397,
    367
], [
    367,
    365
], [
    365,
    397
], [
    288,
    435
], [
    435,
    397
], [
    397,
    288
], [
    278,
    344
], [
    344,
    439
], [
    439,
    278
], [
    310,
    272
], [
    272,
    311
], [
    311,
    310
], [
    248,
    195
], [
    195,
    281
], [
    281,
    248
], [
    375,
    273
], [
    273,
    291
], [
    291,
    375
], [
    175,
    396
], [
    396,
    199
], [
    199,
    175
], [
    312,
    311
], [
    311,
    268
], [
    268,
    312
], [
    276,
    283
], [
    283,
    445
], [
    445,
    276
], [
    390,
    373
], [
    373,
    339
], [
    339,
    390
], [
    295,
    282
], [
    282,
    296
], [
    296,
    295
], [
    448,
    449
], [
    449,
    346
], [
    346,
    448
], [
    356,
    264
], [
    264,
    454
], [
    454,
    356
], [
    337,
    336
], [
    336,
    299
], [
    299,
    337
], [
    337,
    338
], [
    338,
    151
], [
    151,
    337
], [
    294,
    278
], [
    278,
    455
], [
    455,
    294
], [
    308,
    292
], [
    292,
    415
], [
    415,
    308
], [
    429,
    358
], [
    358,
    355
], [
    355,
    429
], [
    265,
    340
], [
    340,
    372
], [
    372,
    265
], [
    352,
    346
], [
    346,
    280
], [
    280,
    352
], [
    295,
    442
], [
    442,
    282
], [
    282,
    295
], [
    354,
    19
], [
    19,
    370
], [
    370,
    354
], [
    285,
    441
], [
    441,
    295
], [
    295,
    285
], [
    195,
    248
], [
    248,
    197
], [
    197,
    195
], [
    457,
    440
], [
    440,
    274
], [
    274,
    457
], [
    301,
    300
], [
    300,
    368
], [
    368,
    301
], [
    417,
    351
], [
    351,
    465
], [
    465,
    417
], [
    251,
    301
], [
    301,
    389
], [
    389,
    251
], [
    394,
    395
], [
    395,
    379
], [
    379,
    394
], [
    399,
    412
], [
    412,
    419
], [
    419,
    399
], [
    410,
    436
], [
    436,
    322
], [
    322,
    410
], [
    326,
    2
], [
    2,
    393
], [
    393,
    326
], [
    354,
    370
], [
    370,
    461
], [
    461,
    354
], [
    393,
    164
], [
    164,
    267
], [
    267,
    393
], [
    268,
    302
], [
    302,
    12
], [
    12,
    268
], [
    312,
    268
], [
    268,
    13
], [
    13,
    312
], [
    298,
    293
], [
    293,
    301
], [
    301,
    298
], [
    265,
    446
], [
    446,
    340
], [
    340,
    265
], [
    280,
    330
], [
    330,
    425
], [
    425,
    280
], [
    322,
    426
], [
    426,
    391
], [
    391,
    322
], [
    420,
    429
], [
    429,
    437
], [
    437,
    420
], [
    393,
    391
], [
    391,
    326
], [
    326,
    393
], [
    344,
    440
], [
    440,
    438
], [
    438,
    344
], [
    458,
    459
], [
    459,
    461
], [
    461,
    458
], [
    364,
    434
], [
    434,
    394
], [
    394,
    364
], [
    428,
    396
], [
    396,
    262
], [
    262,
    428
], [
    274,
    354
], [
    354,
    457
], [
    457,
    274
], [
    317,
    316
], [
    316,
    402
], [
    402,
    317
], [
    316,
    315
], [
    315,
    403
], [
    403,
    316
], [
    315,
    314
], [
    314,
    404
], [
    404,
    315
], [
    314,
    313
], [
    313,
    405
], [
    405,
    314
], [
    313,
    421
], [
    421,
    406
], [
    406,
    313
], [
    323,
    366
], [
    366,
    361
], [
    361,
    323
], [
    292,
    306
], [
    306,
    407
], [
    407,
    292
], [
    306,
    291
], [
    291,
    408
], [
    408,
    306
], [
    291,
    287
], [
    287,
    409
], [
    409,
    291
], [
    287,
    432
], [
    432,
    410
], [
    410,
    287
], [
    427,
    434
], [
    434,
    411
], [
    411,
    427
], [
    372,
    264
], [
    264,
    383
], [
    383,
    372
], [
    459,
    309
], [
    309,
    457
], [
    457,
    459
], [
    366,
    352
], [
    352,
    401
], [
    401,
    366
], [
    1,
    274
], [
    274,
    4
], [
    4,
    1
], [
    418,
    421
], [
    421,
    262
], [
    262,
    418
], [
    331,
    294
], [
    294,
    358
], [
    358,
    331
], [
    435,
    433
], [
    433,
    367
], [
    367,
    435
], [
    392,
    289
], [
    289,
    439
], [
    439,
    392
], [
    328,
    462
], [
    462,
    326
], [
    326,
    328
], [
    94,
    2
], [
    2,
    370
], [
    370,
    94
], [
    289,
    305
], [
    305,
    455
], [
    455,
    289
], [
    339,
    254
], [
    254,
    448
], [
    448,
    339
], [
    359,
    255
], [
    255,
    446
], [
    446,
    359
], [
    254,
    253
], [
    253,
    449
], [
    449,
    254
], [
    253,
    252
], [
    252,
    450
], [
    450,
    253
], [
    252,
    256
], [
    256,
    451
], [
    451,
    252
], [
    256,
    341
], [
    341,
    452
], [
    452,
    256
], [
    414,
    413
], [
    413,
    463
], [
    463,
    414
], [
    286,
    441
], [
    441,
    414
], [
    414,
    286
], [
    286,
    258
], [
    258,
    441
], [
    441,
    286
], [
    258,
    257
], [
    257,
    442
], [
    442,
    258
], [
    257,
    259
], [
    259,
    443
], [
    443,
    257
], [
    259,
    260
], [
    260,
    444
], [
    444,
    259
], [
    260,
    467
], [
    467,
    445
], [
    445,
    260
], [
    309,
    459
], [
    459,
    250
], [
    250,
    309
], [
    305,
    289
], [
    289,
    290
], [
    290,
    305
], [
    305,
    290
], [
    290,
    460
], [
    460,
    305
], [
    401,
    376
], [
    376,
    435
], [
    435,
    401
], [
    309,
    250
], [
    250,
    392
], [
    392,
    309
], [
    376,
    411
], [
    411,
    433
], [
    433,
    376
], [
    453,
    341
], [
    341,
    464
], [
    464,
    453
], [
    357,
    453
], [
    453,
    465
], [
    465,
    357
], [
    343,
    357
], [
    357,
    412
], [
    412,
    343
], [
    437,
    343
], [
    343,
    399
], [
    399,
    437
], [
    344,
    360
], [
    360,
    440
], [
    440,
    344
], [
    420,
    437
], [
    437,
    456
], [
    456,
    420
], [
    360,
    420
], [
    420,
    363
], [
    363,
    360
], [
    361,
    401
], [
    401,
    288
], [
    288,
    361
], [
    265,
    372
], [
    372,
    353
], [
    353,
    265
], [
    390,
    339
], [
    339,
    249
], [
    249,
    390
], [
    339,
    448
], [
    448,
    255
], [
    255,
    339
]);
function $b34bd66f0aa7fdf3$var$mh(t) {
    t.u = {
        faceLandmarks: [],
        faceBlendshapes: [],
        facialTransformationMatrixes: []
    };
}
var $b34bd66f0aa7fdf3$export$9a141f0109a4ba18 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "image_in", "norm_rect", !1), this.u = {
            faceLandmarks: [],
            faceBlendshapes: [],
            facialTransformationMatrixes: []
        }, this.outputFacialTransformationMatrixes = this.outputFaceBlendshapes = !1, $b34bd66f0aa7fdf3$var$Cn(t = this.h = new $b34bd66f0aa7fdf3$var$Hs, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs), this.H = new $b34bd66f0aa7fdf3$var$Vs, $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 3, this.H), this.j = new $b34bd66f0aa7fdf3$var$Is, $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 2, this.j), $b34bd66f0aa7fdf3$var$Xn(this.j, 4, 1), $b34bd66f0aa7fdf3$var$Hn(this.j, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.H, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.h, 4, .5);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.h, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 1, t);
    }
    o(t) {
        return "numFaces" in t && $b34bd66f0aa7fdf3$var$Xn(this.j, 4, t.numFaces ?? 1), "minFaceDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.j, 2, t.minFaceDetectionConfidence ?? .5), "minTrackingConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.h, 4, t.minTrackingConfidence ?? .5), "minFacePresenceConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.H, 2, t.minFacePresenceConfidence ?? .5), "outputFaceBlendshapes" in t && (this.outputFaceBlendshapes = !!t.outputFaceBlendshapes), "outputFacialTransformationMatrixes" in t && (this.outputFacialTransformationMatrixes = !!t.outputFacialTransformationMatrixes), this.l(t);
    }
    F(t, e) {
        return $b34bd66f0aa7fdf3$var$mh(this), $b34bd66f0aa7fdf3$var$eh(this, t, e), this.u;
    }
    G(t, e, n) {
        return $b34bd66f0aa7fdf3$var$mh(this), $b34bd66f0aa7fdf3$var$nh(this, t, n, e), this.u;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "image_in"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect"), $b34bd66f0aa7fdf3$var$Ui(t, "face_landmarks");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$zs, this.h);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.face_landmarker.FaceLandmarkerGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$Si(n, "NORM_LANDMARKS:face_landmarks"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), this.g.attachProtoVectorListener("face_landmarks", (t, e)=>{
            for (const e of t)t = $b34bd66f0aa7fdf3$var$us(e), this.u.faceLandmarks.push($b34bd66f0aa7fdf3$var$Io(t));
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("face_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.outputFaceBlendshapes && ($b34bd66f0aa7fdf3$var$Ui(t, "blendshapes"), $b34bd66f0aa7fdf3$var$Si(n, "BLENDSHAPES:blendshapes"), this.g.attachProtoVectorListener("blendshapes", (t, e)=>{
            if (this.outputFaceBlendshapes) for (const e of t)t = $b34bd66f0aa7fdf3$var$Wi(e), this.u.faceBlendshapes.push($b34bd66f0aa7fdf3$var$Co(t.g() ?? []));
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("blendshapes", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        })), this.outputFacialTransformationMatrixes && ($b34bd66f0aa7fdf3$var$Ui(t, "face_geometry"), $b34bd66f0aa7fdf3$var$Si(n, "FACE_GEOMETRY:face_geometry"), this.g.attachProtoVectorListener("face_geometry", (t, e)=>{
            if (this.outputFacialTransformationMatrixes) for (const e of t)(t = $b34bd66f0aa7fdf3$var$Rn($b34bd66f0aa7fdf3$var$Gs(e), $b34bd66f0aa7fdf3$var$ls, 2)) && this.u.facialTransformationMatrixes.push({
                rows: $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$Nn(t, 1), 0) ?? 0,
                columns: $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$Nn(t, 2), 0) ?? 0,
                data: $b34bd66f0aa7fdf3$var$yn(t, 3, $b34bd66f0aa7fdf3$var$ve).slice() ?? []
            });
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("face_geometry", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        })), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.G, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.detect = $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.F, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.setOptions = $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.prototype.o, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$9a141f0109a4ba18, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$9a141f0109a4ba18, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$9a141f0109a4ba18, t, e);
}, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_LIPS = $b34bd66f0aa7fdf3$var$oh, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_EYE = $b34bd66f0aa7fdf3$var$ah, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_EYEBROW = $b34bd66f0aa7fdf3$var$hh, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_IRIS = $b34bd66f0aa7fdf3$var$ch, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_EYE = $b34bd66f0aa7fdf3$var$uh, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_EYEBROW = $b34bd66f0aa7fdf3$var$lh, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_IRIS = $b34bd66f0aa7fdf3$var$dh, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_FACE_OVAL = $b34bd66f0aa7fdf3$var$fh, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_CONTOURS = $b34bd66f0aa7fdf3$var$ph, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18.FACE_LANDMARKS_TESSELATION = $b34bd66f0aa7fdf3$var$gh;
var $b34bd66f0aa7fdf3$export$f84ed81869a621dd = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "image_in", "norm_rect", !0), $b34bd66f0aa7fdf3$var$Cn(t = this.j = new $b34bd66f0aa7fdf3$var$Ks, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.j, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.j, 0, 1, t);
    }
    o(t) {
        return super.l(t);
    }
    Pa(t, e, n) {
        const r = "function" != typeof e ? e : {};
        if (this.h = "function" == typeof e ? e : n, $b34bd66f0aa7fdf3$var$eh(this, t, r ?? {}), !this.h) return this.u;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "image_in"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect"), $b34bd66f0aa7fdf3$var$Ui(t, "stylized_image");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$Ys, this.j);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.face_stylizer.FaceStylizerGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$Si(n, "STYLIZED_IMAGE:stylized_image"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), this.g.W("stylized_image", (t, e)=>{
            var n = !this.h, r = t.data, i = t.width;
            const s = i * (t = t.height);
            if (r instanceof Uint8Array) {
                if (r.length === 3 * s) {
                    const e = new Uint8ClampedArray(4 * s);
                    for(let t = 0; t < s; ++t)e[4 * t] = r[3 * t], e[4 * t + 1] = r[3 * t + 1], e[4 * t + 2] = r[3 * t + 2], e[4 * t + 3] = 255;
                    r = new ImageData(e, i, t);
                } else {
                    if (r.length !== 4 * s) throw Error("Unsupported channel count: " + r.length / s);
                    r = new ImageData(new Uint8ClampedArray(r.buffer, r.byteOffset, r.length), i, t);
                }
            } else if (!(r instanceof WebGLTexture)) throw Error(`Unsupported format: ${r.constructor.name}`);
            i = new $b34bd66f0aa7fdf3$export$7c9479202f61c045([
                r
            ], !1, !1, this.g.i.canvas, this.M, i, t), this.u = n = n ? i.clone() : i, this.h && this.h(n), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("stylized_image", (t)=>{
            this.u = null, this.h && this.h(null), $b34bd66f0aa7fdf3$var$ea(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$f84ed81869a621dd.prototype.stylize = $b34bd66f0aa7fdf3$export$f84ed81869a621dd.prototype.Pa, $b34bd66f0aa7fdf3$export$f84ed81869a621dd.prototype.setOptions = $b34bd66f0aa7fdf3$export$f84ed81869a621dd.prototype.o, $b34bd66f0aa7fdf3$export$f84ed81869a621dd.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$f84ed81869a621dd, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$f84ed81869a621dd.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$f84ed81869a621dd, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$f84ed81869a621dd.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$f84ed81869a621dd, t, e);
};
var $b34bd66f0aa7fdf3$var$vh = $b34bd66f0aa7fdf3$var$$a([
    0,
    1
], [
    1,
    2
], [
    2,
    3
], [
    3,
    4
], [
    0,
    5
], [
    5,
    6
], [
    6,
    7
], [
    7,
    8
], [
    5,
    9
], [
    9,
    10
], [
    10,
    11
], [
    11,
    12
], [
    9,
    13
], [
    13,
    14
], [
    14,
    15
], [
    15,
    16
], [
    13,
    17
], [
    0,
    17
], [
    17,
    18
], [
    18,
    19
], [
    19,
    20
]);
function $b34bd66f0aa7fdf3$var$Eh(t) {
    t.gestures = [], t.landmarks = [], t.worldLandmarks = [], t.handedness = [];
}
function $b34bd66f0aa7fdf3$var$wh(t) {
    return 0 === t.gestures.length ? {
        gestures: [],
        landmarks: [],
        worldLandmarks: [],
        handedness: [],
        handednesses: []
    } : {
        gestures: t.gestures,
        landmarks: t.landmarks,
        worldLandmarks: t.worldLandmarks,
        handedness: t.handedness,
        handednesses: t.handedness
    };
}
function $b34bd66f0aa7fdf3$var$Th(t, e = !0) {
    const n = [];
    for (const i of t){
        var r = $b34bd66f0aa7fdf3$var$Wi(i);
        t = [];
        for (const n of r.g())r = e && null != $b34bd66f0aa7fdf3$var$Nn(n, 1) ? $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$Nn(n, 1), 0) : -1, t.push({
            score: $b34bd66f0aa7fdf3$var$Gn(n, 2) ?? 0,
            index: r,
            categoryName: $b34bd66f0aa7fdf3$var$jn(n, 3) ?? "",
            displayName: $b34bd66f0aa7fdf3$var$jn(n, 4) ?? ""
        });
        n.push(t);
    }
    return n;
}
var $b34bd66f0aa7fdf3$export$e1bdb836a8013647 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "image_in", "norm_rect", !1), this.gestures = [], this.landmarks = [], this.worldLandmarks = [], this.handedness = [], $b34bd66f0aa7fdf3$var$Cn(t = this.v = new $b34bd66f0aa7fdf3$var$oo, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs), this.A = new $b34bd66f0aa7fdf3$var$io, $b34bd66f0aa7fdf3$var$Cn(this.v, 0, 2, this.A), this.u = new $b34bd66f0aa7fdf3$var$no, $b34bd66f0aa7fdf3$var$Cn(this.A, 0, 3, this.u), this.h = new $b34bd66f0aa7fdf3$var$to, $b34bd66f0aa7fdf3$var$Cn(this.A, 0, 2, this.h), this.j = new $b34bd66f0aa7fdf3$var$Zs, $b34bd66f0aa7fdf3$var$Cn(this.v, 0, 3, this.j), $b34bd66f0aa7fdf3$var$Hn(this.h, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.A, 4, .5), $b34bd66f0aa7fdf3$var$Hn(this.u, 2, .5);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.v, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.v, 0, 1, t);
    }
    o(t) {
        if ($b34bd66f0aa7fdf3$var$Xn(this.h, 3, t.numHands ?? 1), "minHandDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.h, 2, t.minHandDetectionConfidence ?? .5), "minTrackingConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.A, 4, t.minTrackingConfidence ?? .5), "minHandPresenceConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.u, 2, t.minHandPresenceConfidence ?? .5), t.cannedGesturesClassifierOptions) {
            var e = new $b34bd66f0aa7fdf3$var$$s, n = e, r = $b34bd66f0aa7fdf3$var$Po(t.cannedGesturesClassifierOptions, $b34bd66f0aa7fdf3$var$Rn(this.j, $b34bd66f0aa7fdf3$var$$s, 3)?.h());
            $b34bd66f0aa7fdf3$var$Cn(n, 0, 2, r), $b34bd66f0aa7fdf3$var$Cn(this.j, 0, 3, e);
        } else void 0 === t.cannedGesturesClassifierOptions && $b34bd66f0aa7fdf3$var$Rn(this.j, $b34bd66f0aa7fdf3$var$$s, 3)?.g();
        return t.customGesturesClassifierOptions ? ($b34bd66f0aa7fdf3$var$Cn(n = e = new $b34bd66f0aa7fdf3$var$$s, 0, 2, r = $b34bd66f0aa7fdf3$var$Po(t.customGesturesClassifierOptions, $b34bd66f0aa7fdf3$var$Rn(this.j, $b34bd66f0aa7fdf3$var$$s, 4)?.h())), $b34bd66f0aa7fdf3$var$Cn(this.j, 0, 4, e)) : void 0 === t.customGesturesClassifierOptions && $b34bd66f0aa7fdf3$var$Rn(this.j, $b34bd66f0aa7fdf3$var$$s, 4)?.g(), this.l(t);
    }
    Ka(t, e) {
        return $b34bd66f0aa7fdf3$var$Eh(this), $b34bd66f0aa7fdf3$var$eh(this, t, e), $b34bd66f0aa7fdf3$var$wh(this);
    }
    La(t, e, n) {
        return $b34bd66f0aa7fdf3$var$Eh(this), $b34bd66f0aa7fdf3$var$nh(this, t, n, e), $b34bd66f0aa7fdf3$var$wh(this);
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "image_in"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect"), $b34bd66f0aa7fdf3$var$Ui(t, "hand_gestures"), $b34bd66f0aa7fdf3$var$Ui(t, "hand_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "world_hand_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "handedness");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$co, this.v);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.gesture_recognizer.GestureRecognizerGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$Si(n, "HAND_GESTURES:hand_gestures"), $b34bd66f0aa7fdf3$var$Si(n, "LANDMARKS:hand_landmarks"), $b34bd66f0aa7fdf3$var$Si(n, "WORLD_LANDMARKS:world_hand_landmarks"), $b34bd66f0aa7fdf3$var$Si(n, "HANDEDNESS:handedness"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), this.g.attachProtoVectorListener("hand_landmarks", (t, e)=>{
            for (const e of t){
                t = $b34bd66f0aa7fdf3$var$us(e);
                const n = [];
                for (const e of $b34bd66f0aa7fdf3$var$Pn(t, $b34bd66f0aa7fdf3$var$as, 1))n.push({
                    x: $b34bd66f0aa7fdf3$var$Gn(e, 1) ?? 0,
                    y: $b34bd66f0aa7fdf3$var$Gn(e, 2) ?? 0,
                    z: $b34bd66f0aa7fdf3$var$Gn(e, 3) ?? 0,
                    visibility: $b34bd66f0aa7fdf3$var$Gn(e, 4) ?? 0
                });
                this.landmarks.push(n);
            }
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("hand_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.g.attachProtoVectorListener("world_hand_landmarks", (t, e)=>{
            for (const e of t){
                t = $b34bd66f0aa7fdf3$var$os(e);
                const n = [];
                for (const e of $b34bd66f0aa7fdf3$var$Pn(t, $b34bd66f0aa7fdf3$var$rs, 1))n.push({
                    x: $b34bd66f0aa7fdf3$var$Gn(e, 1) ?? 0,
                    y: $b34bd66f0aa7fdf3$var$Gn(e, 2) ?? 0,
                    z: $b34bd66f0aa7fdf3$var$Gn(e, 3) ?? 0,
                    visibility: $b34bd66f0aa7fdf3$var$Gn(e, 4) ?? 0
                });
                this.worldLandmarks.push(n);
            }
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("world_hand_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.g.attachProtoVectorListener("hand_gestures", (t, e)=>{
            this.gestures.push(...$b34bd66f0aa7fdf3$var$Th(t, !1)), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("hand_gestures", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.g.attachProtoVectorListener("handedness", (t, e)=>{
            this.handedness.push(...$b34bd66f0aa7fdf3$var$Th(t)), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("handedness", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
function $b34bd66f0aa7fdf3$var$bh(t) {
    return {
        landmarks: t.landmarks,
        worldLandmarks: t.worldLandmarks,
        handednesses: t.handedness,
        handedness: t.handedness
    };
}
$b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.recognizeForVideo = $b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.La, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.recognize = $b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.Ka, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.setOptions = $b34bd66f0aa7fdf3$export$e1bdb836a8013647.prototype.o, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$e1bdb836a8013647, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$e1bdb836a8013647, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$e1bdb836a8013647, t, e);
}, $b34bd66f0aa7fdf3$export$e1bdb836a8013647.HAND_CONNECTIONS = $b34bd66f0aa7fdf3$var$vh;
var $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "image_in", "norm_rect", !1), this.landmarks = [], this.worldLandmarks = [], this.handedness = [], $b34bd66f0aa7fdf3$var$Cn(t = this.j = new $b34bd66f0aa7fdf3$var$io, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs), this.u = new $b34bd66f0aa7fdf3$var$no, $b34bd66f0aa7fdf3$var$Cn(this.j, 0, 3, this.u), this.h = new $b34bd66f0aa7fdf3$var$to, $b34bd66f0aa7fdf3$var$Cn(this.j, 0, 2, this.h), $b34bd66f0aa7fdf3$var$Xn(this.h, 3, 1), $b34bd66f0aa7fdf3$var$Hn(this.h, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.u, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.j, 4, .5);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.j, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.j, 0, 1, t);
    }
    o(t) {
        return "numHands" in t && $b34bd66f0aa7fdf3$var$Xn(this.h, 3, t.numHands ?? 1), "minHandDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.h, 2, t.minHandDetectionConfidence ?? .5), "minTrackingConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.j, 4, t.minTrackingConfidence ?? .5), "minHandPresenceConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.u, 2, t.minHandPresenceConfidence ?? .5), this.l(t);
    }
    F(t, e) {
        return this.landmarks = [], this.worldLandmarks = [], this.handedness = [], $b34bd66f0aa7fdf3$var$eh(this, t, e), $b34bd66f0aa7fdf3$var$bh(this);
    }
    G(t, e, n) {
        return this.landmarks = [], this.worldLandmarks = [], this.handedness = [], $b34bd66f0aa7fdf3$var$nh(this, t, n, e), $b34bd66f0aa7fdf3$var$bh(this);
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "image_in"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect"), $b34bd66f0aa7fdf3$var$Ui(t, "hand_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "world_hand_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "handedness");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$ho, this.j);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.hand_landmarker.HandLandmarkerGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$Si(n, "LANDMARKS:hand_landmarks"), $b34bd66f0aa7fdf3$var$Si(n, "WORLD_LANDMARKS:world_hand_landmarks"), $b34bd66f0aa7fdf3$var$Si(n, "HANDEDNESS:handedness"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), this.g.attachProtoVectorListener("hand_landmarks", (t, e)=>{
            for (const e of t)t = $b34bd66f0aa7fdf3$var$us(e), this.landmarks.push($b34bd66f0aa7fdf3$var$Io(t));
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("hand_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.g.attachProtoVectorListener("world_hand_landmarks", (t, e)=>{
            for (const e of t)t = $b34bd66f0aa7fdf3$var$os(e), this.worldLandmarks.push($b34bd66f0aa7fdf3$var$Uo(t));
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("world_hand_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.g.attachProtoVectorListener("handedness", (t, e)=>{
            var n = this.handedness, r = n.push;
            const i = [];
            for (const e of t){
                t = $b34bd66f0aa7fdf3$var$Wi(e);
                const n = [];
                for (const e of t.g())n.push({
                    score: $b34bd66f0aa7fdf3$var$Gn(e, 2) ?? 0,
                    index: $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$Nn(e, 1), 0) ?? -1,
                    categoryName: $b34bd66f0aa7fdf3$var$jn(e, 3) ?? "",
                    displayName: $b34bd66f0aa7fdf3$var$jn(e, 4) ?? ""
                });
                i.push(n);
            }
            r.call(n, ...i), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("handedness", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.G, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.detect = $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.F, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.setOptions = $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.prototype.o, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$d2c56c12d54a59a1, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$d2c56c12d54a59a1, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$d2c56c12d54a59a1, t, e);
}, $b34bd66f0aa7fdf3$export$d2c56c12d54a59a1.HAND_CONNECTIONS = $b34bd66f0aa7fdf3$var$vh;
var $b34bd66f0aa7fdf3$var$xh = $b34bd66f0aa7fdf3$var$$a([
    0,
    1
], [
    1,
    2
], [
    2,
    3
], [
    3,
    7
], [
    0,
    4
], [
    4,
    5
], [
    5,
    6
], [
    6,
    8
], [
    9,
    10
], [
    11,
    12
], [
    11,
    13
], [
    13,
    15
], [
    15,
    17
], [
    15,
    19
], [
    15,
    21
], [
    17,
    19
], [
    12,
    14
], [
    14,
    16
], [
    16,
    18
], [
    16,
    20
], [
    16,
    22
], [
    18,
    20
], [
    11,
    23
], [
    12,
    24
], [
    23,
    24
], [
    23,
    25
], [
    24,
    26
], [
    25,
    27
], [
    26,
    28
], [
    27,
    29
], [
    28,
    30
], [
    29,
    31
], [
    30,
    32
], [
    27,
    31
], [
    28,
    32
]);
function $b34bd66f0aa7fdf3$var$Sh(t) {
    t.h = {
        faceLandmarks: [],
        faceBlendshapes: [],
        poseLandmarks: [],
        poseWorldLandmarks: [],
        poseSegmentationMasks: [],
        leftHandLandmarks: [],
        leftHandWorldLandmarks: [],
        rightHandLandmarks: [],
        rightHandWorldLandmarks: []
    };
}
function $b34bd66f0aa7fdf3$var$Lh(t) {
    try {
        if (!t.I) return t.h;
        t.I(t.h);
    } finally{
        $b34bd66f0aa7fdf3$var$ia(t);
    }
}
function $b34bd66f0aa7fdf3$var$Fh(t, e) {
    t = $b34bd66f0aa7fdf3$var$us(t), e.push($b34bd66f0aa7fdf3$var$Io(t));
}
var $b34bd66f0aa7fdf3$export$6911d649b097b693 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "input_frames_image", null, !1), this.h = {
            faceLandmarks: [],
            faceBlendshapes: [],
            poseLandmarks: [],
            poseWorldLandmarks: [],
            poseSegmentationMasks: [],
            leftHandLandmarks: [],
            leftHandWorldLandmarks: [],
            rightHandLandmarks: [],
            rightHandWorldLandmarks: []
        }, this.outputPoseSegmentationMasks = this.outputFaceBlendshapes = !1, $b34bd66f0aa7fdf3$var$Cn(t = this.A = new $b34bd66f0aa7fdf3$var$yo, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs), this.u = new $b34bd66f0aa7fdf3$var$no, $b34bd66f0aa7fdf3$var$Cn(this.A, 0, 2, this.u), this.aa = new $b34bd66f0aa7fdf3$var$uo, $b34bd66f0aa7fdf3$var$Cn(this.A, 0, 3, this.aa), this.j = new $b34bd66f0aa7fdf3$var$Is, $b34bd66f0aa7fdf3$var$Cn(this.A, 0, 4, this.j), this.H = new $b34bd66f0aa7fdf3$var$Vs, $b34bd66f0aa7fdf3$var$Cn(this.A, 0, 5, this.H), this.v = new $b34bd66f0aa7fdf3$var$fo, $b34bd66f0aa7fdf3$var$Cn(this.A, 0, 6, this.v), this.D = new $b34bd66f0aa7fdf3$var$go, $b34bd66f0aa7fdf3$var$Cn(this.A, 0, 7, this.D), $b34bd66f0aa7fdf3$var$Hn(this.j, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.j, 3, .3), $b34bd66f0aa7fdf3$var$Hn(this.H, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.v, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.v, 3, .3), $b34bd66f0aa7fdf3$var$Hn(this.D, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.u, 2, .5);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.A, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.A, 0, 1, t);
    }
    o(t) {
        return "minFaceDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.j, 2, t.minFaceDetectionConfidence ?? .5), "minFaceSuppressionThreshold" in t && $b34bd66f0aa7fdf3$var$Hn(this.j, 3, t.minFaceSuppressionThreshold ?? .3), "minFacePresenceConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.H, 2, t.minFacePresenceConfidence ?? .5), "outputFaceBlendshapes" in t && (this.outputFaceBlendshapes = !!t.outputFaceBlendshapes), "minPoseDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.v, 2, t.minPoseDetectionConfidence ?? .5), "minPoseSuppressionThreshold" in t && $b34bd66f0aa7fdf3$var$Hn(this.v, 3, t.minPoseSuppressionThreshold ?? .3), "minPosePresenceConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.D, 2, t.minPosePresenceConfidence ?? .5), "outputPoseSegmentationMasks" in t && (this.outputPoseSegmentationMasks = !!t.outputPoseSegmentationMasks), "minHandLandmarksConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.u, 2, t.minHandLandmarksConfidence ?? .5), this.l(t);
    }
    F(t, e, n) {
        const r = "function" != typeof e ? e : {};
        return this.I = "function" == typeof e ? e : n, $b34bd66f0aa7fdf3$var$Sh(this), $b34bd66f0aa7fdf3$var$eh(this, t, r), $b34bd66f0aa7fdf3$var$Lh(this);
    }
    G(t, e, n, r) {
        const i = "function" != typeof n ? n : {};
        return this.I = "function" == typeof n ? n : r, $b34bd66f0aa7fdf3$var$Sh(this), $b34bd66f0aa7fdf3$var$nh(this, t, i, e), $b34bd66f0aa7fdf3$var$Lh(this);
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "input_frames_image"), $b34bd66f0aa7fdf3$var$Ui(t, "pose_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "pose_world_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "face_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "left_hand_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "left_hand_world_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "right_hand_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "right_hand_world_landmarks");
        const e = new $b34bd66f0aa7fdf3$var$yi, n = new $b34bd66f0aa7fdf3$var$oi;
        $b34bd66f0aa7fdf3$var$An(n, 1, $b34bd66f0aa7fdf3$var$Me("type.googleapis.com/mediapipe.tasks.vision.holistic_landmarker.proto.HolisticLandmarkerGraphOptions"), ""), function(t, e) {
            if (null != e) {
                if (Array.isArray(e)) $b34bd66f0aa7fdf3$var$dn(t, 2, $b34bd66f0aa7fdf3$var$tn(e, $b34bd66f0aa7fdf3$var$nn, void 0, void 0, !1));
                else {
                    if (!("string" == typeof e || e instanceof $b34bd66f0aa7fdf3$var$B || $b34bd66f0aa7fdf3$var$M(e))) throw Error("invalid value in Any.value field: " + e + " expected a ByteString, a base64 encoded string, a Uint8Array or a jspb array");
                    $b34bd66f0aa7fdf3$var$An(t, 2, $b34bd66f0aa7fdf3$var$ae(e, !1, !1), $b34bd66f0aa7fdf3$var$D());
                }
            }
        }(n, this.A.g());
        const r = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(r, "mediapipe.tasks.vision.holistic_landmarker.HolisticLandmarkerGraph"), $b34bd66f0aa7fdf3$var$Dn(r, 8, $b34bd66f0aa7fdf3$var$oi, n), $b34bd66f0aa7fdf3$var$xi(r, "IMAGE:input_frames_image"), $b34bd66f0aa7fdf3$var$Si(r, "POSE_LANDMARKS:pose_landmarks"), $b34bd66f0aa7fdf3$var$Si(r, "POSE_WORLD_LANDMARKS:pose_world_landmarks"), $b34bd66f0aa7fdf3$var$Si(r, "FACE_LANDMARKS:face_landmarks"), $b34bd66f0aa7fdf3$var$Si(r, "LEFT_HAND_LANDMARKS:left_hand_landmarks"), $b34bd66f0aa7fdf3$var$Si(r, "LEFT_HAND_WORLD_LANDMARKS:left_hand_world_landmarks"), $b34bd66f0aa7fdf3$var$Si(r, "RIGHT_HAND_LANDMARKS:right_hand_landmarks"), $b34bd66f0aa7fdf3$var$Si(r, "RIGHT_HAND_WORLD_LANDMARKS:right_hand_world_landmarks"), r.o(e), $b34bd66f0aa7fdf3$var$Oi(t, r), $b34bd66f0aa7fdf3$var$na(this, t), this.g.attachProtoListener("pose_landmarks", (t, e)=>{
            $b34bd66f0aa7fdf3$var$Fh(t, this.h.poseLandmarks), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("pose_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.g.attachProtoListener("pose_world_landmarks", (t, e)=>{
            var n = this.h.poseWorldLandmarks;
            t = $b34bd66f0aa7fdf3$var$os(t), n.push($b34bd66f0aa7fdf3$var$Uo(t)), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("pose_world_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.outputPoseSegmentationMasks && ($b34bd66f0aa7fdf3$var$Si(r, "POSE_SEGMENTATION_MASK:pose_segmentation_mask"), $b34bd66f0aa7fdf3$var$ra(this, "pose_segmentation_mask"), this.g.W("pose_segmentation_mask", (t, e)=>{
            this.h.poseSegmentationMasks = [
                $b34bd66f0aa7fdf3$var$rh(this, t, !0, !this.I)
            ], $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("pose_segmentation_mask", (t)=>{
            this.h.poseSegmentationMasks = [], $b34bd66f0aa7fdf3$var$ea(this, t);
        })), this.g.attachProtoListener("face_landmarks", (t, e)=>{
            $b34bd66f0aa7fdf3$var$Fh(t, this.h.faceLandmarks), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("face_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.outputFaceBlendshapes && ($b34bd66f0aa7fdf3$var$Ui(t, "extra_blendshapes"), $b34bd66f0aa7fdf3$var$Si(r, "FACE_BLENDSHAPES:extra_blendshapes"), this.g.attachProtoListener("extra_blendshapes", (t, e)=>{
            var n = this.h.faceBlendshapes;
            this.outputFaceBlendshapes && (t = $b34bd66f0aa7fdf3$var$Wi(t), n.push($b34bd66f0aa7fdf3$var$Co(t.g() ?? []))), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("extra_blendshapes", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        })), this.g.attachProtoListener("left_hand_landmarks", (t, e)=>{
            $b34bd66f0aa7fdf3$var$Fh(t, this.h.leftHandLandmarks), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("left_hand_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.g.attachProtoListener("left_hand_world_landmarks", (t, e)=>{
            var n = this.h.leftHandWorldLandmarks;
            t = $b34bd66f0aa7fdf3$var$os(t), n.push($b34bd66f0aa7fdf3$var$Uo(t)), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("left_hand_world_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.g.attachProtoListener("right_hand_landmarks", (t, e)=>{
            $b34bd66f0aa7fdf3$var$Fh(t, this.h.rightHandLandmarks), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("right_hand_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.g.attachProtoListener("right_hand_world_landmarks", (t, e)=>{
            var n = this.h.rightHandWorldLandmarks;
            t = $b34bd66f0aa7fdf3$var$os(t), n.push($b34bd66f0aa7fdf3$var$Uo(t)), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("right_hand_world_landmarks", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$6911d649b097b693.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$6911d649b097b693.prototype.G, $b34bd66f0aa7fdf3$export$6911d649b097b693.prototype.detect = $b34bd66f0aa7fdf3$export$6911d649b097b693.prototype.F, $b34bd66f0aa7fdf3$export$6911d649b097b693.prototype.setOptions = $b34bd66f0aa7fdf3$export$6911d649b097b693.prototype.o, $b34bd66f0aa7fdf3$export$6911d649b097b693.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$6911d649b097b693, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$6911d649b097b693.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$6911d649b097b693, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$6911d649b097b693.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$6911d649b097b693, t, e);
}, $b34bd66f0aa7fdf3$export$6911d649b097b693.HAND_CONNECTIONS = $b34bd66f0aa7fdf3$var$vh, $b34bd66f0aa7fdf3$export$6911d649b097b693.POSE_CONNECTIONS = $b34bd66f0aa7fdf3$var$xh, $b34bd66f0aa7fdf3$export$6911d649b097b693.FACE_LANDMARKS_LIPS = $b34bd66f0aa7fdf3$var$oh, $b34bd66f0aa7fdf3$export$6911d649b097b693.FACE_LANDMARKS_LEFT_EYE = $b34bd66f0aa7fdf3$var$ah, $b34bd66f0aa7fdf3$export$6911d649b097b693.FACE_LANDMARKS_LEFT_EYEBROW = $b34bd66f0aa7fdf3$var$hh, $b34bd66f0aa7fdf3$export$6911d649b097b693.FACE_LANDMARKS_LEFT_IRIS = $b34bd66f0aa7fdf3$var$ch, $b34bd66f0aa7fdf3$export$6911d649b097b693.FACE_LANDMARKS_RIGHT_EYE = $b34bd66f0aa7fdf3$var$uh, $b34bd66f0aa7fdf3$export$6911d649b097b693.FACE_LANDMARKS_RIGHT_EYEBROW = $b34bd66f0aa7fdf3$var$lh, $b34bd66f0aa7fdf3$export$6911d649b097b693.FACE_LANDMARKS_RIGHT_IRIS = $b34bd66f0aa7fdf3$var$dh, $b34bd66f0aa7fdf3$export$6911d649b097b693.FACE_LANDMARKS_FACE_OVAL = $b34bd66f0aa7fdf3$var$fh, $b34bd66f0aa7fdf3$export$6911d649b097b693.FACE_LANDMARKS_CONTOURS = $b34bd66f0aa7fdf3$var$ph, $b34bd66f0aa7fdf3$export$6911d649b097b693.FACE_LANDMARKS_TESSELATION = $b34bd66f0aa7fdf3$var$gh;
var $b34bd66f0aa7fdf3$export$af0b5c7f41d90214 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "input_image", "norm_rect", !0), this.j = {
            classifications: []
        }, $b34bd66f0aa7fdf3$var$Cn(t = this.h = new $b34bd66f0aa7fdf3$var$_o, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.h, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 1, t);
    }
    o(t) {
        return $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 2, $b34bd66f0aa7fdf3$var$Po(t, $b34bd66f0aa7fdf3$var$Rn(this.h, $b34bd66f0aa7fdf3$var$ks, 2))), this.l(t);
    }
    ua(t, e) {
        return this.j = {
            classifications: []
        }, $b34bd66f0aa7fdf3$var$eh(this, t, e), this.j;
    }
    va(t, e, n) {
        return this.j = {
            classifications: []
        }, $b34bd66f0aa7fdf3$var$nh(this, t, n, e), this.j;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "input_image"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect"), $b34bd66f0aa7fdf3$var$Ui(t, "classifications");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$vo, this.h);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.image_classifier.ImageClassifierGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:input_image"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$Si(n, "CLASSIFICATIONS:classifications"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), this.g.attachProtoListener("classifications", (t, e)=>{
            this.j = function(t) {
                const e = {
                    classifications: $b34bd66f0aa7fdf3$var$Pn(t, $b34bd66f0aa7fdf3$var$ps, 1).map((t)=>$b34bd66f0aa7fdf3$var$Co($b34bd66f0aa7fdf3$var$Rn(t, $b34bd66f0aa7fdf3$var$Xi, 4)?.g() ?? [], $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$Nn(t, 2), 0), $b34bd66f0aa7fdf3$var$jn(t, 3)))
                };
                return null != $b34bd66f0aa7fdf3$var$Fe($b34bd66f0aa7fdf3$var$cn(t, 2)) && (e.timestampMs = $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$Fe($b34bd66f0aa7fdf3$var$cn(t, 2)), 0)), e;
            }($b34bd66f0aa7fdf3$var$ys(t)), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("classifications", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.classifyForVideo = $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.va, $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.classify = $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.ua, $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.setOptions = $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.prototype.o, $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$af0b5c7f41d90214, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$af0b5c7f41d90214, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$af0b5c7f41d90214.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$af0b5c7f41d90214, t, e);
};
var $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "image_in", "norm_rect", !0), this.h = new $b34bd66f0aa7fdf3$var$Eo, this.embeddings = {
            embeddings: []
        }, $b34bd66f0aa7fdf3$var$Cn(t = this.h, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.h, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 1, t);
    }
    o(t) {
        var e = this.h, n = $b34bd66f0aa7fdf3$var$Rn(this.h, $b34bd66f0aa7fdf3$var$Ss, 2);
        return n = n ? n.clone() : new $b34bd66f0aa7fdf3$var$Ss, void 0 !== t.l2Normalize ? $b34bd66f0aa7fdf3$var$Vn(n, 1, t.l2Normalize) : "l2Normalize" in t && $b34bd66f0aa7fdf3$var$dn(n, 1), void 0 !== t.quantize ? $b34bd66f0aa7fdf3$var$Vn(n, 2, t.quantize) : "quantize" in t && $b34bd66f0aa7fdf3$var$dn(n, 2), $b34bd66f0aa7fdf3$var$Cn(e, 0, 2, n), this.l(t);
    }
    Ba(t, e) {
        return $b34bd66f0aa7fdf3$var$eh(this, t, e), this.embeddings;
    }
    Ca(t, e, n) {
        return $b34bd66f0aa7fdf3$var$nh(this, t, n, e), this.embeddings;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "image_in"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect"), $b34bd66f0aa7fdf3$var$Ui(t, "embeddings_out");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$wo, this.h);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.image_embedder.ImageEmbedderGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$Si(n, "EMBEDDINGS:embeddings_out"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), this.g.attachProtoListener("embeddings_out", (t, e)=>{
            t = $b34bd66f0aa7fdf3$var$bs(t), this.embeddings = function(t) {
                return {
                    embeddings: $b34bd66f0aa7fdf3$var$Pn(t, $b34bd66f0aa7fdf3$var$Es, 1).map((t)=>{
                        const e = {
                            headIndex: $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$Nn(t, 3), 0) ?? -1,
                            headName: $b34bd66f0aa7fdf3$var$jn(t, 4) ?? ""
                        };
                        if (void 0 !== $b34bd66f0aa7fdf3$var$Fn(t, $b34bd66f0aa7fdf3$var$_s, $b34bd66f0aa7fdf3$var$xn(t, 1))) t = $b34bd66f0aa7fdf3$var$yn(t = $b34bd66f0aa7fdf3$var$Rn(t, $b34bd66f0aa7fdf3$var$_s, $b34bd66f0aa7fdf3$var$xn(t, 1)), 1, $b34bd66f0aa7fdf3$var$ve), e.floatEmbedding = t.slice();
                        else {
                            const n = new Uint8Array(0);
                            e.quantizedEmbedding = $b34bd66f0aa7fdf3$var$Rn(t, $b34bd66f0aa7fdf3$var$vs, $b34bd66f0aa7fdf3$var$xn(t, 2))?.qa()?.h() ?? n;
                        }
                        return e;
                    }),
                    timestampMs: $b34bd66f0aa7fdf3$var$Bn($b34bd66f0aa7fdf3$var$Fe($b34bd66f0aa7fdf3$var$cn(t, 2)), 0)
                };
            }(t), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("embeddings_out", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.cosineSimilarity = function(t, e) {
    if (t.floatEmbedding && e.floatEmbedding) t = $b34bd66f0aa7fdf3$var$No(t.floatEmbedding, e.floatEmbedding);
    else {
        if (!t.quantizedEmbedding || !e.quantizedEmbedding) throw Error("Cannot compute cosine similarity between quantized and float embeddings.");
        t = $b34bd66f0aa7fdf3$var$No($b34bd66f0aa7fdf3$var$Do(t.quantizedEmbedding), $b34bd66f0aa7fdf3$var$Do(e.quantizedEmbedding));
    }
    return t;
}, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.embedForVideo = $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.Ca, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.embed = $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.Ba, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.setOptions = $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.prototype.o, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$7bd9ab1a59f5f8a2, t, e);
};
var $b34bd66f0aa7fdf3$export$23c2ae92dccdcffe = class {
    constructor(t, e, n){
        this.confidenceMasks = t, this.categoryMask = e, this.qualityScores = n;
    }
    close() {
        this.confidenceMasks?.forEach((t)=>{
            t.close();
        }), this.categoryMask?.close();
    }
};
function $b34bd66f0aa7fdf3$var$Oh(t) {
    t.categoryMask = void 0, t.confidenceMasks = void 0, t.qualityScores = void 0;
}
function $b34bd66f0aa7fdf3$var$Ih(t) {
    try {
        const e = new $b34bd66f0aa7fdf3$export$23c2ae92dccdcffe(t.confidenceMasks, t.categoryMask, t.qualityScores);
        if (!t.j) return e;
        t.j(e);
    } finally{
        $b34bd66f0aa7fdf3$var$ia(t);
    }
}
$b34bd66f0aa7fdf3$export$23c2ae92dccdcffe.prototype.close = $b34bd66f0aa7fdf3$export$23c2ae92dccdcffe.prototype.close;
var $b34bd66f0aa7fdf3$export$a6aab52785405573 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "image_in", "norm_rect", !1), this.u = [], this.outputCategoryMask = !1, this.outputConfidenceMasks = !0, this.h = new $b34bd66f0aa7fdf3$var$xo, this.v = new $b34bd66f0aa7fdf3$var$To, $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 3, this.v), $b34bd66f0aa7fdf3$var$Cn(t = this.h, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.h, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 1, t);
    }
    o(t) {
        return void 0 !== t.displayNamesLocale ? $b34bd66f0aa7fdf3$var$dn(this.h, 2, $b34bd66f0aa7fdf3$var$Me(t.displayNamesLocale)) : "displayNamesLocale" in t && $b34bd66f0aa7fdf3$var$dn(this.h, 2), "outputCategoryMask" in t && (this.outputCategoryMask = t.outputCategoryMask ?? !1), "outputConfidenceMasks" in t && (this.outputConfidenceMasks = t.outputConfidenceMasks ?? !0), super.l(t);
    }
    L() {
        !function(t) {
            const e = $b34bd66f0aa7fdf3$var$Pn(t.fa(), $b34bd66f0aa7fdf3$var$Li, 1).filter((t)=>$b34bd66f0aa7fdf3$var$jn(t, 1).includes("mediapipe.tasks.TensorsToSegmentationCalculator"));
            if (t.u = [], 1 < e.length) throw Error("The graph has more than one mediapipe.tasks.TensorsToSegmentationCalculator.");
            1 === e.length && ($b34bd66f0aa7fdf3$var$Rn(e[0], $b34bd66f0aa7fdf3$var$yi, 7)?.l()?.g() ?? new Map).forEach((e, n)=>{
                t.u[Number(n)] = $b34bd66f0aa7fdf3$var$jn(e, 1);
            });
        }(this);
    }
    ga(t, e, n) {
        const r = "function" != typeof e ? e : {};
        return this.j = "function" == typeof e ? e : n, $b34bd66f0aa7fdf3$var$Oh(this), $b34bd66f0aa7fdf3$var$eh(this, t, r), $b34bd66f0aa7fdf3$var$Ih(this);
    }
    Na(t, e, n, r) {
        const i = "function" != typeof n ? n : {};
        return this.j = "function" == typeof n ? n : r, $b34bd66f0aa7fdf3$var$Oh(this), $b34bd66f0aa7fdf3$var$nh(this, t, i, e), $b34bd66f0aa7fdf3$var$Ih(this);
    }
    Fa() {
        return this.u;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "image_in"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$So, this.h);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.image_segmenter.ImageSegmenterGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), $b34bd66f0aa7fdf3$var$na(this, t), this.outputConfidenceMasks && ($b34bd66f0aa7fdf3$var$Ui(t, "confidence_masks"), $b34bd66f0aa7fdf3$var$Si(n, "CONFIDENCE_MASKS:confidence_masks"), $b34bd66f0aa7fdf3$var$ra(this, "confidence_masks"), this.g.da("confidence_masks", (t, e)=>{
            this.confidenceMasks = t.map((t)=>$b34bd66f0aa7fdf3$var$rh(this, t, !0, !this.j)), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("confidence_masks", (t)=>{
            this.confidenceMasks = [], $b34bd66f0aa7fdf3$var$ea(this, t);
        })), this.outputCategoryMask && ($b34bd66f0aa7fdf3$var$Ui(t, "category_mask"), $b34bd66f0aa7fdf3$var$Si(n, "CATEGORY_MASK:category_mask"), $b34bd66f0aa7fdf3$var$ra(this, "category_mask"), this.g.W("category_mask", (t, e)=>{
            this.categoryMask = $b34bd66f0aa7fdf3$var$rh(this, t, !1, !this.j), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("category_mask", (t)=>{
            this.categoryMask = void 0, $b34bd66f0aa7fdf3$var$ea(this, t);
        })), $b34bd66f0aa7fdf3$var$Ui(t, "quality_scores"), $b34bd66f0aa7fdf3$var$Si(n, "QUALITY_SCORES:quality_scores"), this.g.attachFloatVectorListener("quality_scores", (t, e)=>{
            this.qualityScores = t, $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("quality_scores", (t)=>{
            this.categoryMask = void 0, $b34bd66f0aa7fdf3$var$ea(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.getLabels = $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.Fa, $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.segmentForVideo = $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.Na, $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.segment = $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.ga, $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.setOptions = $b34bd66f0aa7fdf3$export$a6aab52785405573.prototype.o, $b34bd66f0aa7fdf3$export$a6aab52785405573.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$a6aab52785405573, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$a6aab52785405573.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$a6aab52785405573, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$a6aab52785405573.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$a6aab52785405573, t, e);
};
var $b34bd66f0aa7fdf3$export$100d0e384e102553 = class {
    constructor(t, e, n){
        this.confidenceMasks = t, this.categoryMask = e, this.qualityScores = n;
    }
    close() {
        this.confidenceMasks?.forEach((t)=>{
            t.close();
        }), this.categoryMask?.close();
    }
};
$b34bd66f0aa7fdf3$export$100d0e384e102553.prototype.close = $b34bd66f0aa7fdf3$export$100d0e384e102553.prototype.close;
var $b34bd66f0aa7fdf3$var$Nh = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Bh = [
    0,
    $b34bd66f0aa7fdf3$var$jr,
    -2
], $b34bd66f0aa7fdf3$var$Gh = [
    0,
    $b34bd66f0aa7fdf3$var$Or,
    -3,
    $b34bd66f0aa7fdf3$var$Hr
], $b34bd66f0aa7fdf3$var$jh = [
    0,
    $b34bd66f0aa7fdf3$var$Or,
    -3,
    $b34bd66f0aa7fdf3$var$Hr,
    $b34bd66f0aa7fdf3$var$Or,
    -1
], $b34bd66f0aa7fdf3$var$Vh = [
    0,
    $b34bd66f0aa7fdf3$var$jh
], $b34bd66f0aa7fdf3$var$Xh = [
    0,
    $b34bd66f0aa7fdf3$var$Vh,
    $b34bd66f0aa7fdf3$var$Bh
], $b34bd66f0aa7fdf3$var$Hh = [
    0,
    $b34bd66f0aa7fdf3$var$jh,
    $b34bd66f0aa7fdf3$var$Bh
], $b34bd66f0aa7fdf3$var$Wh = [
    0,
    $b34bd66f0aa7fdf3$var$jh,
    $b34bd66f0aa7fdf3$var$jr,
    -1
], $b34bd66f0aa7fdf3$var$zh = [
    0,
    $b34bd66f0aa7fdf3$var$Wh,
    $b34bd66f0aa7fdf3$var$Bh
], $b34bd66f0aa7fdf3$var$Kh = [
    0,
    $b34bd66f0aa7fdf3$var$Or,
    -3,
    $b34bd66f0aa7fdf3$var$Hr,
    $b34bd66f0aa7fdf3$var$Bh,
    -1
], $b34bd66f0aa7fdf3$var$Yh = [
    0,
    $b34bd66f0aa7fdf3$var$Or,
    -3,
    $b34bd66f0aa7fdf3$var$Hr,
    $b34bd66f0aa7fdf3$var$ti
], $b34bd66f0aa7fdf3$var$$h = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$qh = [
    0,
    $b34bd66f0aa7fdf3$var$Or,
    -1,
    $b34bd66f0aa7fdf3$var$Hr
], $b34bd66f0aa7fdf3$var$Jh = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(){
        super();
    }
};
$b34bd66f0aa7fdf3$var$Jh.B = [
    1
];
var $b34bd66f0aa7fdf3$var$Zh = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(t){
        super(t);
    }
}, $b34bd66f0aa7fdf3$var$Qh = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    14,
    15
], $b34bd66f0aa7fdf3$var$tc = [
    0,
    $b34bd66f0aa7fdf3$var$Qh,
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$jh,
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$Hh,
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$Vh,
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$Xh,
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$qh,
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$Yh,
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$Gh,
    $b34bd66f0aa7fdf3$var$Jr,
    [
        0,
        $b34bd66f0aa7fdf3$var$Yr,
        $b34bd66f0aa7fdf3$var$Or,
        -2,
        $b34bd66f0aa7fdf3$var$Hr,
        $b34bd66f0aa7fdf3$var$jr,
        $b34bd66f0aa7fdf3$var$Hr,
        -1,
        2,
        $b34bd66f0aa7fdf3$var$Or,
        $b34bd66f0aa7fdf3$var$Bh
    ],
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$Wh,
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$zh,
    $b34bd66f0aa7fdf3$var$Or,
    $b34bd66f0aa7fdf3$var$Bh,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$Jr,
    $b34bd66f0aa7fdf3$var$Kh,
    $b34bd66f0aa7fdf3$var$Jr,
    [
        0,
        $b34bd66f0aa7fdf3$var$Cr,
        $b34bd66f0aa7fdf3$var$qh
    ]
], $b34bd66f0aa7fdf3$var$ec = [
    0,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$jr,
    -1,
    $b34bd66f0aa7fdf3$var$Hr
], $b34bd66f0aa7fdf3$var$nc = class extends $b34bd66f0aa7fdf3$var$zn {
    constructor(){
        super();
    }
};
$b34bd66f0aa7fdf3$var$nc.B = [
    1
], $b34bd66f0aa7fdf3$var$nc.prototype.g = $b34bd66f0aa7fdf3$var$si([
    0,
    $b34bd66f0aa7fdf3$var$Cr,
    $b34bd66f0aa7fdf3$var$tc,
    $b34bd66f0aa7fdf3$var$Yr,
    $b34bd66f0aa7fdf3$var$ec
]);
var $b34bd66f0aa7fdf3$export$1911ac08eb46d346 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "image_in", "norm_rect_in", !1), this.outputCategoryMask = !1, this.outputConfidenceMasks = !0, this.h = new $b34bd66f0aa7fdf3$var$xo, this.v = new $b34bd66f0aa7fdf3$var$To, $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 3, this.v), $b34bd66f0aa7fdf3$var$Cn(t = this.h, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.h, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 1, t);
    }
    o(t) {
        return "outputCategoryMask" in t && (this.outputCategoryMask = t.outputCategoryMask ?? !1), "outputConfidenceMasks" in t && (this.outputConfidenceMasks = t.outputConfidenceMasks ?? !0), super.l(t);
    }
    ga(t, e, n, r) {
        const i = "function" != typeof n ? n : {};
        this.j = "function" == typeof n ? n : r, this.qualityScores = this.categoryMask = this.confidenceMasks = void 0, n = this.J + 1, r = new $b34bd66f0aa7fdf3$var$nc;
        const s = new $b34bd66f0aa7fdf3$var$Zh;
        var o = new $b34bd66f0aa7fdf3$var$Nh;
        if ($b34bd66f0aa7fdf3$var$Xn(o, 1, 255), $b34bd66f0aa7fdf3$var$Cn(s, 0, 12, o), e.keypoint && e.scribble) throw Error("Cannot provide both keypoint and scribble.");
        if (e.keypoint) {
            var a = new $b34bd66f0aa7fdf3$var$$h;
            $b34bd66f0aa7fdf3$var$Vn(a, 3, !0), $b34bd66f0aa7fdf3$var$Hn(a, 1, e.keypoint.x), $b34bd66f0aa7fdf3$var$Hn(a, 2, e.keypoint.y), $b34bd66f0aa7fdf3$var$On(s, 5, $b34bd66f0aa7fdf3$var$Qh, a);
        } else {
            if (!e.scribble) throw Error("Must provide either a keypoint or a scribble.");
            for (a of (o = new $b34bd66f0aa7fdf3$var$Jh, e.scribble))$b34bd66f0aa7fdf3$var$Vn(e = new $b34bd66f0aa7fdf3$var$$h, 3, !0), $b34bd66f0aa7fdf3$var$Hn(e, 1, a.x), $b34bd66f0aa7fdf3$var$Hn(e, 2, a.y), $b34bd66f0aa7fdf3$var$Dn(o, 1, $b34bd66f0aa7fdf3$var$$h, e);
            $b34bd66f0aa7fdf3$var$On(s, 15, $b34bd66f0aa7fdf3$var$Qh, o);
        }
        $b34bd66f0aa7fdf3$var$Dn(r, 1, $b34bd66f0aa7fdf3$var$Zh, s), this.g.addProtoToStream(r.g(), "drishti.RenderData", "roi_in", n), $b34bd66f0aa7fdf3$var$eh(this, t, i);
        t: {
            try {
                const t = new $b34bd66f0aa7fdf3$export$100d0e384e102553(this.confidenceMasks, this.categoryMask, this.qualityScores);
                if (!this.j) {
                    var h = t;
                    break t;
                }
                this.j(t);
            } finally{
                $b34bd66f0aa7fdf3$var$ia(this);
            }
            h = void 0;
        }
        return h;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "image_in"), $b34bd66f0aa7fdf3$var$Ii(t, "roi_in"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect_in");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$So, this.h);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.interactive_segmenter.InteractiveSegmenterGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$xi(n, "ROI:roi_in"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect_in"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), $b34bd66f0aa7fdf3$var$na(this, t), this.outputConfidenceMasks && ($b34bd66f0aa7fdf3$var$Ui(t, "confidence_masks"), $b34bd66f0aa7fdf3$var$Si(n, "CONFIDENCE_MASKS:confidence_masks"), $b34bd66f0aa7fdf3$var$ra(this, "confidence_masks"), this.g.da("confidence_masks", (t, e)=>{
            this.confidenceMasks = t.map((t)=>$b34bd66f0aa7fdf3$var$rh(this, t, !0, !this.j)), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("confidence_masks", (t)=>{
            this.confidenceMasks = [], $b34bd66f0aa7fdf3$var$ea(this, t);
        })), this.outputCategoryMask && ($b34bd66f0aa7fdf3$var$Ui(t, "category_mask"), $b34bd66f0aa7fdf3$var$Si(n, "CATEGORY_MASK:category_mask"), $b34bd66f0aa7fdf3$var$ra(this, "category_mask"), this.g.W("category_mask", (t, e)=>{
            this.categoryMask = $b34bd66f0aa7fdf3$var$rh(this, t, !1, !this.j), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("category_mask", (t)=>{
            this.categoryMask = void 0, $b34bd66f0aa7fdf3$var$ea(this, t);
        })), $b34bd66f0aa7fdf3$var$Ui(t, "quality_scores"), $b34bd66f0aa7fdf3$var$Si(n, "QUALITY_SCORES:quality_scores"), this.g.attachFloatVectorListener("quality_scores", (t, e)=>{
            this.qualityScores = t, $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("quality_scores", (t)=>{
            this.categoryMask = void 0, $b34bd66f0aa7fdf3$var$ea(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$1911ac08eb46d346.prototype.segment = $b34bd66f0aa7fdf3$export$1911ac08eb46d346.prototype.ga, $b34bd66f0aa7fdf3$export$1911ac08eb46d346.prototype.setOptions = $b34bd66f0aa7fdf3$export$1911ac08eb46d346.prototype.o, $b34bd66f0aa7fdf3$export$1911ac08eb46d346.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$1911ac08eb46d346, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$1911ac08eb46d346.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$1911ac08eb46d346, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$1911ac08eb46d346.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$1911ac08eb46d346, t, e);
};
var $b34bd66f0aa7fdf3$export$f03f381c3c95b342 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "input_frame_gpu", "norm_rect", !1), this.j = {
            detections: []
        }, $b34bd66f0aa7fdf3$var$Cn(t = this.h = new $b34bd66f0aa7fdf3$var$Lo, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.h, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 1, t);
    }
    o(t) {
        return void 0 !== t.displayNamesLocale ? $b34bd66f0aa7fdf3$var$dn(this.h, 2, $b34bd66f0aa7fdf3$var$Me(t.displayNamesLocale)) : "displayNamesLocale" in t && $b34bd66f0aa7fdf3$var$dn(this.h, 2), void 0 !== t.maxResults ? $b34bd66f0aa7fdf3$var$Xn(this.h, 3, t.maxResults) : "maxResults" in t && $b34bd66f0aa7fdf3$var$dn(this.h, 3), void 0 !== t.scoreThreshold ? $b34bd66f0aa7fdf3$var$Hn(this.h, 4, t.scoreThreshold) : "scoreThreshold" in t && $b34bd66f0aa7fdf3$var$dn(this.h, 4), void 0 !== t.categoryAllowlist ? $b34bd66f0aa7fdf3$var$Tn(this.h, 5, t.categoryAllowlist) : "categoryAllowlist" in t && $b34bd66f0aa7fdf3$var$dn(this.h, 5), void 0 !== t.categoryDenylist ? $b34bd66f0aa7fdf3$var$Tn(this.h, 6, t.categoryDenylist) : "categoryDenylist" in t && $b34bd66f0aa7fdf3$var$dn(this.h, 6), this.l(t);
    }
    F(t, e) {
        return this.j = {
            detections: []
        }, $b34bd66f0aa7fdf3$var$eh(this, t, e), this.j;
    }
    G(t, e, n) {
        return this.j = {
            detections: []
        }, $b34bd66f0aa7fdf3$var$nh(this, t, n, e), this.j;
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "input_frame_gpu"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect"), $b34bd66f0aa7fdf3$var$Ui(t, "detections");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$Fo, this.h);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.ObjectDetectorGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:input_frame_gpu"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$Si(n, "DETECTIONS:detections"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), this.g.attachProtoVectorListener("detections", (t, e)=>{
            for (const e of t)t = $b34bd66f0aa7fdf3$var$ns(e), this.j.detections.push($b34bd66f0aa7fdf3$var$Oo(t));
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("detections", (t)=>{
            $b34bd66f0aa7fdf3$var$ea(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.G, $b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.detect = $b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.F, $b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.setOptions = $b34bd66f0aa7fdf3$export$f03f381c3c95b342.prototype.o, $b34bd66f0aa7fdf3$export$f03f381c3c95b342.createFromModelPath = async function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$f03f381c3c95b342, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$f03f381c3c95b342.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$f03f381c3c95b342, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$f03f381c3c95b342.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$f03f381c3c95b342, t, e);
};
var $b34bd66f0aa7fdf3$var$sc = class {
    constructor(t, e, n){
        this.landmarks = t, this.worldLandmarks = e, this.segmentationMasks = n;
    }
    close() {
        this.segmentationMasks?.forEach((t)=>{
            t.close();
        });
    }
};
function $b34bd66f0aa7fdf3$var$oc(t) {
    t.landmarks = [], t.worldLandmarks = [], t.segmentationMasks = void 0;
}
function $b34bd66f0aa7fdf3$var$ac(t) {
    try {
        const e = new $b34bd66f0aa7fdf3$var$sc(t.landmarks, t.worldLandmarks, t.segmentationMasks);
        if (!t.j) return e;
        t.j(e);
    } finally{
        $b34bd66f0aa7fdf3$var$ia(t);
    }
}
$b34bd66f0aa7fdf3$var$sc.prototype.close = $b34bd66f0aa7fdf3$var$sc.prototype.close;
var $b34bd66f0aa7fdf3$export$fe95e48202120e29 = class extends $b34bd66f0aa7fdf3$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $b34bd66f0aa7fdf3$var$Za(t, e), "image_in", "norm_rect", !1), this.landmarks = [], this.worldLandmarks = [], this.outputSegmentationMasks = !1, $b34bd66f0aa7fdf3$var$Cn(t = this.h = new $b34bd66f0aa7fdf3$var$Ro, 0, 1, e = new $b34bd66f0aa7fdf3$var$Cs), this.D = new $b34bd66f0aa7fdf3$var$go, $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 3, this.D), this.v = new $b34bd66f0aa7fdf3$var$fo, $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 2, this.v), $b34bd66f0aa7fdf3$var$Xn(this.v, 4, 1), $b34bd66f0aa7fdf3$var$Hn(this.v, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.D, 2, .5), $b34bd66f0aa7fdf3$var$Hn(this.h, 4, .5);
    }
    get baseOptions() {
        return $b34bd66f0aa7fdf3$var$Rn(this.h, $b34bd66f0aa7fdf3$var$Cs, 1);
    }
    set baseOptions(t) {
        $b34bd66f0aa7fdf3$var$Cn(this.h, 0, 1, t);
    }
    o(t) {
        return "numPoses" in t && $b34bd66f0aa7fdf3$var$Xn(this.v, 4, t.numPoses ?? 1), "minPoseDetectionConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.v, 2, t.minPoseDetectionConfidence ?? .5), "minTrackingConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.h, 4, t.minTrackingConfidence ?? .5), "minPosePresenceConfidence" in t && $b34bd66f0aa7fdf3$var$Hn(this.D, 2, t.minPosePresenceConfidence ?? .5), "outputSegmentationMasks" in t && (this.outputSegmentationMasks = t.outputSegmentationMasks ?? !1), this.l(t);
    }
    F(t, e, n) {
        const r = "function" != typeof e ? e : {};
        return this.j = "function" == typeof e ? e : n, $b34bd66f0aa7fdf3$var$oc(this), $b34bd66f0aa7fdf3$var$eh(this, t, r), $b34bd66f0aa7fdf3$var$ac(this);
    }
    G(t, e, n, r) {
        const i = "function" != typeof n ? n : {};
        return this.j = "function" == typeof n ? n : r, $b34bd66f0aa7fdf3$var$oc(this), $b34bd66f0aa7fdf3$var$nh(this, t, i, e), $b34bd66f0aa7fdf3$var$ac(this);
    }
    m() {
        var t = new $b34bd66f0aa7fdf3$var$Di;
        $b34bd66f0aa7fdf3$var$Ii(t, "image_in"), $b34bd66f0aa7fdf3$var$Ii(t, "norm_rect"), $b34bd66f0aa7fdf3$var$Ui(t, "normalized_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "world_landmarks"), $b34bd66f0aa7fdf3$var$Ui(t, "segmentation_masks");
        const e = new $b34bd66f0aa7fdf3$var$yi;
        $b34bd66f0aa7fdf3$var$Wn(e, $b34bd66f0aa7fdf3$var$Mo, this.h);
        const n = new $b34bd66f0aa7fdf3$var$Li;
        $b34bd66f0aa7fdf3$var$ki(n, "mediapipe.tasks.vision.pose_landmarker.PoseLandmarkerGraph"), $b34bd66f0aa7fdf3$var$xi(n, "IMAGE:image_in"), $b34bd66f0aa7fdf3$var$xi(n, "NORM_RECT:norm_rect"), $b34bd66f0aa7fdf3$var$Si(n, "NORM_LANDMARKS:normalized_landmarks"), $b34bd66f0aa7fdf3$var$Si(n, "WORLD_LANDMARKS:world_landmarks"), n.o(e), $b34bd66f0aa7fdf3$var$Oi(t, n), $b34bd66f0aa7fdf3$var$na(this, t), this.g.attachProtoVectorListener("normalized_landmarks", (t, e)=>{
            this.landmarks = [];
            for (const e of t)t = $b34bd66f0aa7fdf3$var$us(e), this.landmarks.push($b34bd66f0aa7fdf3$var$Io(t));
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("normalized_landmarks", (t)=>{
            this.landmarks = [], $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.g.attachProtoVectorListener("world_landmarks", (t, e)=>{
            this.worldLandmarks = [];
            for (const e of t)t = $b34bd66f0aa7fdf3$var$os(e), this.worldLandmarks.push($b34bd66f0aa7fdf3$var$Uo(t));
            $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("world_landmarks", (t)=>{
            this.worldLandmarks = [], $b34bd66f0aa7fdf3$var$ea(this, t);
        }), this.outputSegmentationMasks && ($b34bd66f0aa7fdf3$var$Si(n, "SEGMENTATION_MASK:segmentation_masks"), $b34bd66f0aa7fdf3$var$ra(this, "segmentation_masks"), this.g.da("segmentation_masks", (t, e)=>{
            this.segmentationMasks = t.map((t)=>$b34bd66f0aa7fdf3$var$rh(this, t, !0, !this.j)), $b34bd66f0aa7fdf3$var$ea(this, e);
        }), this.g.attachEmptyPacketListener("segmentation_masks", (t)=>{
            this.segmentationMasks = [], $b34bd66f0aa7fdf3$var$ea(this, t);
        })), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.detectForVideo = $b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.G, $b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.detect = $b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.F, $b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.setOptions = $b34bd66f0aa7fdf3$export$fe95e48202120e29.prototype.o, $b34bd66f0aa7fdf3$export$fe95e48202120e29.createFromModelPath = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$fe95e48202120e29, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $b34bd66f0aa7fdf3$export$fe95e48202120e29.createFromModelBuffer = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$fe95e48202120e29, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $b34bd66f0aa7fdf3$export$fe95e48202120e29.createFromOptions = function(t, e) {
    return $b34bd66f0aa7fdf3$var$Qa($b34bd66f0aa7fdf3$export$fe95e48202120e29, t, e);
}, $b34bd66f0aa7fdf3$export$fe95e48202120e29.POSE_CONNECTIONS = $b34bd66f0aa7fdf3$var$xh;
 //# sourceMappingURL=vision_bundle_mjs.js.map


// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//      http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
//const { FaceLandmarker, FilesetResolver, DrawingUtils } = v;
const $0f592d681121713f$var$demosSection = document.getElementById("demos");
const $0f592d681121713f$var$imageBlendShapes = document.getElementById("image-blend-shapes");
const $0f592d681121713f$var$videoBlendShapes = document.getElementById("video-blend-shapes");
let $0f592d681121713f$var$faceLandmarker;
let $0f592d681121713f$var$runningMode = "IMAGE";
let $0f592d681121713f$var$enableWebcamButton;
let $0f592d681121713f$var$webcamRunning = false;
const $0f592d681121713f$var$videoWidth = 480;
const $0f592d681121713f$var$heading = document.getElementById("title");
let $0f592d681121713f$var$isBlinking = false;
let $0f592d681121713f$var$blinkCount = 0;
function $0f592d681121713f$var$setBlinking(newValue) {
    if (newValue === $0f592d681121713f$var$isBlinking) return;
    if (newValue) $0f592d681121713f$var$blinkCount += 1;
    $0f592d681121713f$var$isBlinking = newValue;
    if ($0f592d681121713f$var$heading) $0f592d681121713f$var$heading.innerText = $0f592d681121713f$var$blinkCount.toString();
}
// Before we can use HandLandmarker class we must wait for it to finish
// loading. Machine Learning models can be large and take a moment to
// get everything needed to run.
async function $0f592d681121713f$var$createFaceLandmarker() {
    const filesetResolver = await (0, $b34bd66f0aa7fdf3$export$f97946dfe503e8d3).forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.3/wasm");
    $0f592d681121713f$var$faceLandmarker = await (0, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18).createFromOptions(filesetResolver, {
        baseOptions: {
            modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task`,
            delegate: "GPU"
        },
        outputFaceBlendshapes: true,
        runningMode: $0f592d681121713f$var$runningMode,
        numFaces: 1
    });
//demosSection.classList.remove("invisible");
}
$0f592d681121713f$var$createFaceLandmarker();
/********************************************************************
// Demo 1: Grab a bunch of images from the page and detection them
// upon click.
********************************************************************/ // In this demo, we have put all our clickable images in divs with the
// CSS class 'detectionOnClick'. Lets get all the elements that have
// this class.
const $0f592d681121713f$var$imageContainers = document.getElementsByClassName("detectOnClick");
// Now let's go through all of these and add a click event listener.
for (let imageContainer of $0f592d681121713f$var$imageContainers)// Add event listener to the child element whichis the img element.
imageContainer.children[0].addEventListener("click", $0f592d681121713f$var$handleClick);
// When an image is clicked, let's detect it and display results!
async function $0f592d681121713f$var$handleClick(event) {
    if (!$0f592d681121713f$var$faceLandmarker) {
        console.log("Wait for faceLandmarker to load before clicking!");
        return;
    }
    if ($0f592d681121713f$var$runningMode === "VIDEO") {
        $0f592d681121713f$var$runningMode = "IMAGE";
        await $0f592d681121713f$var$faceLandmarker.setOptions({
            runningMode: $0f592d681121713f$var$runningMode
        });
    }
    // Remove all landmarks drawed before
    const allCanvas = event.target.parentNode.getElementsByClassName("canvas");
    for(var i = allCanvas.length - 1; i >= 0; i--){
        const n = allCanvas[i];
        n.parentNode.removeChild(n);
    }
    // We can call faceLandmarker.detect as many times as we like with
    // different image data each time. This returns a promise
    // which we wait to complete and then call a function to
    // print out the results of the prediction.
    const faceLandmarkerResult = $0f592d681121713f$var$faceLandmarker.detect(event.target);
    const canvas = document.createElement("canvas");
    canvas.setAttribute("class", "canvas");
    canvas.setAttribute("width", event.target.naturalWidth + "px");
    canvas.setAttribute("height", event.target.naturalHeight + "px");
    canvas.style.left = "0px";
    canvas.style.top = "0px";
    canvas.style.width = `${event.target.width}px`;
    canvas.style.height = `${event.target.height}px`;
    event.target.parentNode.appendChild(canvas);
    const ctx = canvas.getContext("2d");
    const drawingUtils = new (0, $b34bd66f0aa7fdf3$export$94ffe84d90dbe8de)(ctx);
    for (const landmarks of faceLandmarkerResult.faceLandmarks){
        drawingUtils.drawConnectors(landmarks, (0, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18).FACE_LANDMARKS_TESSELATION, {
            color: "#C0C0C070",
            lineWidth: 1
        });
        drawingUtils.drawConnectors(landmarks, (0, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18).FACE_LANDMARKS_RIGHT_EYE, {
            color: "#FF3030"
        });
        drawingUtils.drawConnectors(landmarks, (0, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18).FACE_LANDMARKS_RIGHT_EYEBROW, {
            color: "#FF3030"
        });
        drawingUtils.drawConnectors(landmarks, (0, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18).FACE_LANDMARKS_LEFT_EYE, {
            color: "#30FF30"
        });
        drawingUtils.drawConnectors(landmarks, (0, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18).FACE_LANDMARKS_LEFT_EYEBROW, {
            color: "#30FF30"
        });
        drawingUtils.drawConnectors(landmarks, (0, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18).FACE_LANDMARKS_FACE_OVAL, {
            color: "#E0E0E0"
        });
        drawingUtils.drawConnectors(landmarks, (0, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18).FACE_LANDMARKS_LIPS, {
            color: "#E0E0E0"
        });
        drawingUtils.drawConnectors(landmarks, (0, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18).FACE_LANDMARKS_RIGHT_IRIS, {
            color: "#FF3030"
        });
        drawingUtils.drawConnectors(landmarks, (0, $b34bd66f0aa7fdf3$export$9a141f0109a4ba18).FACE_LANDMARKS_LEFT_IRIS, {
            color: "#30FF30"
        });
    }
    $0f592d681121713f$var$drawBlendShapes($0f592d681121713f$var$imageBlendShapes, faceLandmarkerResult.faceBlendshapes);
}
/********************************************************************
// Demo 2: Continuously grab image from webcam stream and detect it.
********************************************************************/ const $0f592d681121713f$var$video = document.getElementById("webcam");
const $0f592d681121713f$var$canvasElement = document.getElementById("output_canvas");
const $0f592d681121713f$var$canvasCtx = $0f592d681121713f$var$canvasElement.getContext("2d");
// Check if webcam access is supported.
function $0f592d681121713f$var$hasGetUserMedia() {
    return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
}
// If webcam supported, add event listener to button for when user
// wants to activate it.
if ($0f592d681121713f$var$hasGetUserMedia()) {
    $0f592d681121713f$var$enableWebcamButton = document.getElementById("webcamButton");
    $0f592d681121713f$var$enableWebcamButton.addEventListener("click", $0f592d681121713f$var$enableCam);
} else console.warn("getUserMedia() is not supported by your browser");
// Enable the live webcam view and start detection.
function $0f592d681121713f$var$enableCam(event) {
    if (!$0f592d681121713f$var$faceLandmarker) {
        console.log("Wait! faceLandmarker not loaded yet.");
        return;
    }
    if ($0f592d681121713f$var$webcamRunning === true) {
        $0f592d681121713f$var$webcamRunning = false;
        $0f592d681121713f$var$enableWebcamButton.innerText = "RESUME";
        if ($0f592d681121713f$var$heading) $0f592d681121713f$var$heading.style.display = "none";
    } else {
        $0f592d681121713f$var$webcamRunning = true;
        $0f592d681121713f$var$enableWebcamButton.innerText = "PAUSE";
        $0f592d681121713f$var$enableWebcamButton.style.display = "none";
        if ($0f592d681121713f$var$heading) $0f592d681121713f$var$heading.style.display = "block";
    }
    // getUsermedia parameters.
    const constraints = {
        video: true
    };
    // Activate the webcam stream.
    navigator.mediaDevices.getUserMedia(constraints).then((stream)=>{
        $0f592d681121713f$var$video.srcObject = stream;
        $0f592d681121713f$var$video.addEventListener("loadeddata", $0f592d681121713f$var$predictWebcam);
    });
}
let $0f592d681121713f$var$lastVideoTime = -1;
let $0f592d681121713f$var$results = undefined;
//const drawingUtils = new DrawingUtils(canvasCtx);
async function $0f592d681121713f$var$predictWebcam() {
    //const radio = video.videoHeight / video.videoWidth;
    //video.style.width = videoWidth + "px";
    //video.style.height = videoWidth * radio + "px";
    //canvasElement.style.width = videoWidth + "px";
    //canvasElement.style.height = videoWidth * radio + "px";
    //canvasElement.width = video.videoWidth;
    //canvasElement.height = video.videoHeight;
    // Now let's start detecting the stream.
    if ($0f592d681121713f$var$runningMode === "IMAGE") {
        $0f592d681121713f$var$runningMode = "VIDEO";
        await $0f592d681121713f$var$faceLandmarker.setOptions({
            runningMode: $0f592d681121713f$var$runningMode
        });
    }
    let startTimeMs = performance.now();
    if ($0f592d681121713f$var$lastVideoTime !== $0f592d681121713f$var$video.currentTime) {
        $0f592d681121713f$var$lastVideoTime = $0f592d681121713f$var$video.currentTime;
        $0f592d681121713f$var$results = $0f592d681121713f$var$faceLandmarker.detectForVideo($0f592d681121713f$var$video, startTimeMs);
    }
    /*
  if (results.faceLandmarks) {
    for (const landmarks of results.faceLandmarks) {
      drawingUtils.drawConnectors(
        landmarks,
        FaceLandmarker.FACE_LANDMARKS_TESSELATION,
        { color: "#C0C0C070", lineWidth: 1 }
      );
      drawingUtils.drawConnectors(
        landmarks,
        FaceLandmarker.FACE_LANDMARKS_RIGHT_EYE,
        { color: "#FF3030" }
      );
      drawingUtils.drawConnectors(
        landmarks,
        FaceLandmarker.FACE_LANDMARKS_RIGHT_EYEBROW,
        { color: "#FF3030" }
      );
      drawingUtils.drawConnectors(
        landmarks,
        FaceLandmarker.FACE_LANDMARKS_LEFT_EYE,
        { color: "#30FF30" }
      );
      drawingUtils.drawConnectors(
        landmarks,
        FaceLandmarker.FACE_LANDMARKS_LEFT_EYEBROW,
        { color: "#30FF30" }
      );
      drawingUtils.drawConnectors(
        landmarks,
        FaceLandmarker.FACE_LANDMARKS_FACE_OVAL,
        { color: "#E0E0E0" }
      );
      drawingUtils.drawConnectors(
        landmarks,
        FaceLandmarker.FACE_LANDMARKS_LIPS,
        { color: "#E0E0E0" }
      );
      drawingUtils.drawConnectors(
        landmarks,
        FaceLandmarker.FACE_LANDMARKS_RIGHT_IRIS,
        { color: "#FF3030" }
      );
      drawingUtils.drawConnectors(
        landmarks,
        FaceLandmarker.FACE_LANDMARKS_LEFT_IRIS,
        { color: "#30FF30" }
      );
    }
  }

  drawBlendShapes(videoBlendShapes, results.faceBlendshapes);
  */ if ($0f592d681121713f$var$results.faceBlendshapes.length > 0) {
        const categories = $0f592d681121713f$var$results.faceBlendshapes[0].categories;
        const blinkLeft = categories.find((category)=>category.categoryName === "eyeBlinkLeft");
        const blinkRight = categories.find((category)=>category.categoryName === "eyeBlinkRight");
        if (blinkLeft && blinkRight && $0f592d681121713f$var$heading) {
            const left = blinkLeft.score;
            const right = blinkRight.score;
            if (left >= 0.4 || right >= 0.4) $0f592d681121713f$var$setBlinking(true);
            else $0f592d681121713f$var$setBlinking(false);
        }
    }
    // Call this function again to keep predicting when the browser is ready.
    if ($0f592d681121713f$var$webcamRunning === true) window.requestAnimationFrame($0f592d681121713f$var$predictWebcam);
}
function $0f592d681121713f$var$drawBlendShapes(el, blendShapes) {
    var shape;
    return;
}


//# sourceMappingURL=index.ca5cb9e5.js.map
